import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl, ValidationErrors, FormArray } from '@angular/forms';
import { ProformaRepository } from 'src/app/proforma/domain/proforma.repository';
import { ComercialRepository } from 'src/app/repositorio/comercial.repository';
import { Parametros } from 'src/app/services/domain/services-domain';
import { StorageService } from 'src/app/services/storage.service';
import { UtilService } from 'src/app/services/util.service';
import { newmetadate } from 'src/app/shared/components/datatable/domain/datatable-domain';
import { SelectItem } from 'primeng/api/selectitem';
import { MessageService } from 'primeng/api';
import { lisPais, listDepartamento, listProvincia, listDistrito, ComercialDataRequest, GetComercialDataResponse, itemsObtenerClienteArchivo, ClientesComerciales, ClientesComercialesCrear, ParamAsignacionClientesRequest, AsignacionClienteDTO } from 'src/app/proforma/domain/response/proforma_response';
import { requestDepartamento, requestProvincia, requestDistrito, incoterRequest, sunatRequest, ParamGrupoBandeja } from 'src/app/proforma/domain/request/proforma_request';
import { ComisionesRepository } from 'src/app/comisiones/domain/Comisiones-repository';
import { ListarTiposRequest } from 'src/app/statement-carrier/domain/request/statement-carrier-request';
import { error } from 'pdf-lib';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { debounceTime, firstValueFrom, lastValueFrom, Subscription } from 'rxjs';
import { SelectedItems } from 'src/app/services/SelectedItems';
import { DatatableComponent } from 'src/app/shared/components/datatable/datatable.component';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConsultarDireccionEntidadRequest, consultarServiciosRequest, envioCorreosRequest, envioFinanzasNuevoClienteRequest, formatoCorreoRequest, registroNuevoRucRequest, ListarCuentasBancariasRequest, ListarEntidadesRequest, ListarHistorialRequest, ListarLimiteCreditoRequest, ListarUbigeosRequest, SincronizarEntidadSapRequest, TablaDireccionEntidad, TablaEntidadBloqueo, TablaEntidadRelacionados, TablaEntidadServicios, TransaccionEntidadBloqueoRequest, ValidarDocIdentidadRequest } from 'src/app/comercial/mantenimiento/domain/request/mantenimiento-request';
import { ListaCuentasBancarias, ListarEntidades } from 'src/app/comercial/mantenimiento/domain/response/mantenimiento-response';
import { ListarAuditoriaRequest, ListarArchivoEntidadRequest } from '../../../../comercial/mantenimiento/domain/request/mantenimiento-request';
import { itemsConfirmarRuc } from 'src/app/extranet/solicitud-atencion/domain/solicitud-atencion.request';
import { InternationalLogisticsContact, OperationsContact } from 'src/app/cliente/domain/datos-comerciales.interface';
import { v4 as uuidv4 } from 'uuid'; // Importa uuid para IDs únicos
import { FileSelectEvent, FileUpload } from 'primeng/fileupload';
import { lisTipoDocumento } from '../../../../proforma/domain/response/proforma_response';

@Component({
  selector: 'app-dialog-formulario',
  providers: [MessageService],
  standalone: false,
  // imports: [],
  templateUrl: './dialog-formulario.component.html',
  styleUrl: './dialog-formulario.component.css',
  // changeDetection: ChangeDetectionStrategy.OnPush,
})

export class DialogFormularioComponent {
  constructor(private readonly mantcomercial: ComercialRepository,
    private readonly storage: StorageService,
    public util: UtilService,
    private readonly comisiones: ComisionesRepository,
    private readonly proformaService: ProformaRepository,
    private messageService: MessageService,
    private readonly router: Router,
    private readonly title: Title,
    private cdr: ChangeDetectorRef,
    // public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
  ) { }

  @ViewChild('fileUploader') fileUploader!: FileUpload;
  fechaActual: Date = new Date();
  codigoEntidad: number = 1
  //FORMULARIOS PARA CADA SECCION
  group: FormGroup
  groupPoppupDG: FormGroup
  groupPoppupD: FormGroup
  groupPoppupB: FormGroup
  groupPS: FormGroup
  groupPoppupE: FormGroup
  // --- Nuevo FormGroup para la sección "Datos Comerciales" ---
  groupDatosComerciales: FormGroup = new FormGroup({
    contactoPrincipal: new FormGroup({
      nombre: new FormControl(null),
      apellido: new FormControl(null),
      puesto: new FormControl(null),
      telefono: new FormControl(null),
      cumpleanos: new FormControl(null),
      email: new FormControl(null, this.multiEmailTrimmedValidator),
      checkOpcionalPrincipal: new FormControl(false), // Nuevo checkbox
    }),
    checkOpcionalILC: new FormControl(false), // Checkbox para International Logistics Contacts
    internationalLogisticsContacts: new FormArray([]),
    billingContact: new FormGroup({
      checkOpcionalBC: new FormControl(false), // Nuevo checkbox
    }),
    checkOpcionalOC: new FormControl(false), // Checkbox para Operations Contacts
    operationsContacts: new FormArray([]),
    checkOpcionalCustomerProfile: new FormControl(false), // Checkbox para Customer Profile

    replicateFromPrincipal2: new FormControl(false, null)
  });
  private emailSubscriptions: Subscription[] = [];
  //DATATABLES
  dataTable: any[] = []
  dataTableCuentasBancarias: any[] = []
  dataTableServicios: any[] = []
  dtS: any[] = []
  // inicializar y enviar los valores manualmente
  defaultRowCuentasBancarias: ListaCuentasBancarias = {
    tipotran: null,
    entC_Codigo: null,
    tipO_TabBCO: null,
    tipO_CodBCO: null,
    tipO_BCO: null,
    encB_TipoCuenta: null,
    tipoCuenta: null,
    encB_NroCuentaSol: null,
    encB_NroCuentaDol: null,
  };

  defaultRowServicios: any = {
    servicio: null,
    valor: null,
    fechainicio: null,
    fechaventa: null,
    tipoacuerdo: null,
    beneficiario: null,
    notas: null,
    eseR_Cantidad: 0,
    // eseR_Codigo: 0,
    eseR_Exonerado: false,
    eseR_Valor: 0,
  }

  defaultRowRelacionados: TablaEntidadRelacionados = {
    entC_CodPadre: null, entC_CodHijo: null, conS_TabRGM: "RGM", conS_CodRGM: null,
    relA_Activo: null, tipO_TabTRF: "TRF", tipO_CodTRF: null, relA_Tipos: null,
    relA_DepTemNegociaAgente: null, tipE_CodPadre: null, tipE_CodHijo: null,
    audI_UsrCrea: null, audI_UsrMod: null
  };

  dataTableLimiteCredito: any[] = []
  InsertLimCredito: any[] = []
  dataTableAuditoria: any[] = []
  dataTableArchivos: any[] = []
  dataTableDireccion: any[] = []
  dataTableHistorial: any[] = []
  dataTableAuditoriaServicios: any[] = []
  dataTableRelacionados: any[] = []
  //CONDICIONES
  visible: boolean
  juridica: boolean
  natural: boolean
  visiblebtn: boolean
  visiblenumdoc: boolean = true
  estadoEditar: boolean = true;
  //LISTAS DROPDOWN
  ListaTodosTipoDoc: any[] = []
  listTipoDocFiltrado: any[] = []; // Este será el listado que se muestre en el HTML
  ListaTodosBanco: SelectItem[] = []
  ListaTodosMoneda: SelectItem[] = []
  ListarTodosSegmento: any[] = []
  ListaMonedaDP: SelectedItems[] = []
  ListaBaseDP: SelectedItems[] = []
  ListaServiciosDP: SelectedItems[] = []
  ListaTodosTipoEntidad: any[] = []
  ListaTodosTipoAcuerdo: any[] = []
  ListaRegimenDP: SelectItem[] = []
  ListaTraficoDP: SelectItem[] = []
  ListaLineaNegocioDP: SelectItem[] = []
  ListaViaDP: SelectItem[] = []
  ListaTipoEntidadDP: SelectedItems[] = []
  ListaTipoRelacionDP: SelectedItems[] = []
  ListaNombreEntidadesDP: SelectedItems[] = []
  ListaFiltradaNombreEntidadesDP: SelectedItems[] = []
  ListaFiltradaTipoEntidadDP: SelectedItems[] = []
  listaDatosEntidad: any = [];
  ListaTipoLimiteCredito: SelectItem[] = [];
  tipo: any[] = []
  sexo: any[] = []
  atributos: any[] = []
  tipocuenta: SelectItem[] = []
  formapago: SelectItem[] = []
  listPais: lisPais[] = [];
  listDepartamento: any[] = [];
  listProvincia: any[] = [];
  listDistrito: any[] = [];
  // Nuevas variables para la dirección comercial
  listDepartamentoComercial: any[] = [];
  listProvinciaComercial: any[] = [];
  listDistritoComercial: any[] = [];
  activeIndex: number = 0;
  activeIndex2: number
  entcCod: number
  nomUsuario = '';
  correoUsuario = '';

  //LISTADO DEL TIPO CLIENTE
  ListarTipoCliente = [
    { name: 'Cliente nominado', value: '001' },
    { name: 'Cliente no domiciliado', value: '002' },
    { name: 'Cliente finanzas', value: '003' },
    { name: 'Cliente comercial', value: '004' },
  ];

  listadoGrupos: ClientesComercialesCrear[] = [];

  private tipoClienteSubscription: Subscription;

  //SEGMENTO
  private segmentoSubscription: Subscription;
  private detallesSegmentoSubscription: Subscription;

  ListarNuevoSegmento: any[] = [
    { name: 'heavy', value: 1 },
    { name: 'dry', value: 2 },
    { name: 'IMO', value: 3 },
    { name: 'reefer', value: 4 },
  ]
  // Opciones para el segundo select (select múltiple)
  ListarDetallesSegmento: any[] = [];

  // Guarda el estado de los segmentos para saber qué detalles son obligatorios
  private selectedSegmentDetails: Map<number, any[]> = new Map();

  // Datos de los detalles de segmento
  detallesSegmentoData = {
    '1': [ // heavy
      { name: 'vidrios', value: 10 },
      { name: 'ceramicos', value: 11 }
    ],
    '2': [ // dry
      { name: 'farmaceutico dry', value: 20 },
      { name: 'textiles', value: 21 },
      { name: 'zapatos', value: 22 },
      { name: 'llantas', value: 23 },
      { name: 'juguetes', value: 24 },
      { name: 'útiles escolares', value: 25 },
      { name: 'papel', value: 26 },
      { name: 'articulos de tocador', value: 27 },
      { name: 'linea blanca', value: 28 },
      { name: 'luminaria', value: 29 },
      { name: 'equipos electrónicos', value: 30 },
      { name: 'pegamentos dry', value: 31 },
      { name: 'motos y accesorios', value: 32 },
      { name: 'bicicletas', value: 33 },
      { name: 'autos camiones y vans', value: 34 }
    ],
    '3': [ // IMO
      { name: 'farmaceutico imo', value: 40 },
      { name: 'pinturas', value: 41 },
      { name: 'lacas', value: 42 },
      { name: 'pegamentos imo', value: 43 },
      { name: 'aceite', value: 44 },
      { name: 'lubricantes', value: 45 },
      { name: 'otros', value: 46 }
    ],
    '4': [ // reefer
      { name: 'reefer', value: 50 }
    ]
  };

  // emit para enviar datos al datatable
  @Output() onDpChangeTblServicios: EventEmitter<any> = new EventEmitter();
  @Output() onDpChangeTblRelacionados: EventEmitter<any> = new EventEmitter();

  metadataTable: newmetadate[] = [
    { title: 'Sincronizar SAP', field: '', inputType: 'buttonPersonalizado', icon: 'pi pi-user', loading: false, function: (row: any) => this.sincronizarSAP(row), style: { align: "center" } },
    { field: 'entC_Codigo', title: 'Código', inputType: 'text' }, { field: 'tipO_CodTDI', title: 'Tipo Doc. Iden.', inputType: 'text' },
    { field: 'entC_DocIden', title: 'N.I.T', inputType: 'text' }, { field: 'entC_RazonSocial', title: 'Nombre', inputType: 'text' },
    { field: 'entC_Activo', title: 'Activo', inputType: 'checkbox' }, { field: 'entC_EMail', title: 'Correo', inputType: 'text' },
    { field: 'entC_EmailReceptorFE', title: 'Correo Factura Electrónica', inputType: 'text' }, { field: 'entC_Telef1', title: 'Tel. Fijo', inputType: 'text' },
    { field: 'entC_Telef2', title: 'Tel. Móvil', inputType: 'text' }, { field: 'entC_CodSAP_C', title: 'Cliente SAP', inputType: 'text' },
    { field: 'entC_CodSAP_P', title: 'Proveedor SAP', inputType: 'text' }, { field: 'entC_FecActSAP', title: 'Sincronización SAP', inputType: 'datetime' },
    { field: 'audI_UsrCrea', title: 'Creado por', inputType: 'text' }, { field: 'audI_FecCrea', title: 'Fecha crea', inputType: 'datetime' },
    { field: 'audI_UsrMod', title: 'Modificado por', inputType: 'text' }, { field: 'audI_FecMod', title: 'Fecha mod.', inputType: 'datetime' }
  ]

  metadataTableCuentasBancarias: newmetadate[] = [
    { field: 'tipO_BCO', title: 'Banco', inputType: 'autocomplete', dropdown: this.ListaTodosBanco }, { field: 'tipoCuenta', title: 'Tipo de Cuenta', inputType: 'autocomplete', dropdown: this.tipocuenta },
    { field: 'encB_NroCuentaSol', title: 'Cuenta en S/.', inputType: 'text' }, { field: 'encB_NroCuentaDol', title: 'Cuenta en US$', inputType: 'text' }
  ]

  mdtS: newmetadate[] = [
    { field: 'nombre', title: 'Nombre del Servicio', inputType: 'text', filterType: 'text' },
    { field: 'critico', title: 'Critico', inputType: 'checkboxEdit' }
  ]

  metadataTableAuditoria: newmetadate[] = [
    { field: 'operacion', title: 'Operación', inputType: 'text' }, { field: 'direccionip', title: 'Dirección IP', inputType: 'text' },
    { field: 'nombremaquina', title: 'Nombre Máquina', inputType: 'text' }, { field: 'nombreaplicacion', title: 'Nombre Aplicación', inputType: 'text' },
    { field: 'usuariosql', title: 'Usuario SQL', inputType: 'text' }, { field: 'usuarioaplicacion', title: 'Usuario Aplicación', inputType: 'text' },
    { field: 'fechamodificacion', title: 'Fecha Modificación', inputType: 'datetime' }, { field: 'codigoentidad', title: 'Código Entidad', inputType: 'text' },
    { field: 'docidentidad', title: 'Doc. Identidad', inputType: 'text' }, { field: 'codigodocidentidad', title: 'Código Doc. Iden.', inputType: 'text' },
    { field: 'numdocidentidad', title: 'Num. Doc. Identidad', inputType: 'text' }, { field: 'tipopersona', title: 'Tipo Persona', inputType: 'text' },
    { field: 'domiciliado', title: 'Domiciliado', inputType: 'checkbox' }, { field: 'nombres', title: 'Nombres', inputType: 'text' },
    { field: 'apellidopaterno', title: 'Ape. Paterno', inputType: 'text' }, { field: 'apellidomaterno', title: 'Ape. Materno', inputType: 'text' },
    { field: 'nombrecompleto', title: 'Nom. Completo', inputType: 'text' }, { field: 'nombrecomercial', title: 'Nom. Comercial', inputType: 'text' },
    { field: 'razonsocial', title: 'Razón Social', inputType: 'text' }, { field: 'activo', title: 'Activo', inputType: 'checkbox' },
    { field: 'fechanacimiento', title: 'Fec. Nacimiento', inputType: 'datetime' }, { field: 'fechaingreso', title: 'Fec. Ingreso', inputType: 'datetime' },
    { field: 'vip', title: 'VIP', inputType: 'checkbox' }, { field: 'notas', title: 'Notas', inputType: 'text' },
    { field: 'sexo', title: 'Sexo', inputType: 'text' }, { field: 'email', title: 'E-mail', inputType: 'text' },
    { field: 'email2', title: 'E-mail2', inputType: 'text' }, { field: 'web', title: 'Web', inputType: 'text' },
    { field: 'propio', title: 'Propio', inputType: 'checkbox' }, { field: 'telefono1', title: 'Teléfono 1', inputType: 'text' },
    { field: 'telefono2', title: 'Teléfono 2', inputType: 'text' }, { field: 'telefono3', title: 'Teléfono 3', inputType: 'text' },
    { field: 'telefono4', title: 'Teléfono 4', inputType: 'text' }, { field: 'beneficiario', title: 'Beneficiario', inputType: 'text' },
    { field: 'area', title: 'Área', inputType: 'text' }, { field: 'cargo', title: 'Cargo', inputType: 'text' },
    { field: 'cuentausuario', title: 'Cuenta Usuario', inputType: 'text' }, { field: 'pais', title: 'País', inputType: 'text' },
    { field: 'codigopais', title: 'Cod. País', inputType: 'text' }, { field: 'holding', title: 'Holding', inputType: 'text' },
    { field: 'codigoholding', title: 'Cod. Holding', inputType: 'text' }, { field: 'tipotarifa', title: 'Tipo Tarifa', inputType: 'text' },
    { field: 'codigotarifa', title: 'Cod. Tarifa', inputType: 'text' }, { field: 'prospecto', title: 'Prospecto', inputType: 'checkbox' },
    { field: 'rebate', title: 'Rebate', inputType: 'decimal' }, { field: 'moneda', title: 'Moneda', inputType: 'text' },
    { field: 'codigomoneda', title: 'Cod. Moneda', inputType: 'text' }, { field: 'tipodeposito', title: 'Tipo Depósito', inputType: 'text' },
    { field: 'codtipodeposito', title: 'Cod. Tipo Depósito', inputType: 'text' }, { field: 'tarja', title: 'Tarja', inputType: 'decimal' },
    { field: 'realizatarja', title: 'Realiza Tarja', inputType: 'checkbox' }, { field: 'diacredito', title: 'Día Crédito', inputType: 'int' },
    { field: 'fechacredito', title: 'Fec. Crédito', inputType: 'datetime' }, { field: 'codigoaduana', title: 'Cod. Aduana', inputType: 'text' },
    { field: 'observaciones', title: 'Observaciones', inputType: 'text' }, { field: 'cuenintersoles', title: 'Cuen. Inter. Soles', inputType: 'text' },
    { field: 'cueninterdolares', title: 'Cuen. Inter. Dólares', inputType: 'text' }, { field: 'cuendetraccion', title: 'Cuen. Detracción', inputType: 'text' },
    { field: 'serviciologistico', title: 'Servicio Logístico', inputType: 'checkbox' }, { field: 'ocultarshipper', title: 'Ocultar Shipper', inputType: 'checkbox' },
    { field: 'obserfinanzas', title: 'Obser. Finanzas', inputType: 'text' }, { field: 'otrostraficos', title: 'Otros Tráficos', inputType: 'checkbox' },
    { field: 'mandato', title: 'Mandato', inputType: 'checkbox' }, { field: 'sli', title: 'SLI', inputType: 'checkbox' },
    { field: 'exportacion', title: 'Exportación', inputType: 'checkbox' }, { field: 'emailfinanzas', title: 'E-mail Fnanzas', inputType: 'text' },
    { field: 'bloqueocliente', title: 'Bloqueo Cliente', inputType: 'text' }, { field: 'usubloqueacliente', title: 'Usu Bloquea Cliente', inputType: 'text' },
    { field: 'fecbloqueocliente', title: 'Fec. Bloqueo Cliente', inputType: 'datetime' }, { field: 'obserbloqueocliente', title: 'Obser. Bloqueo Cliente', inputType: 'text' },
    { field: 'bloqueoproveedor', title: 'Bloqueo Proveedor', inputType: 'checkbox' }, { field: 'usubloqueaproveedor', title: 'Usu. Bloquea Proveedor', inputType: 'text' },
    { field: 'fecbloqueoproveedor', title: 'Fec. Bloqueo Proveedor', inputType: 'datetime' }, { field: 'obserbloqueoproveedor', title: 'Obser. Bloqueo Proveedor', inputType: 'text' },
    { field: 'obserproveedor', title: 'Obser. Proveedor', inputType: 'text' }, { field: 'asumedetraccion', title: 'Asume Detracción', inputType: 'checkbox' },
    { field: 'usuariocrea', title: 'Usuario Crea', inputType: 'text' }, { field: 'fechacrea', title: 'Fecha Crea', inputType: 'datetime' },
    { field: 'usuariomodifica', title: 'Usuario Modifica', inputType: 'text' }, { field: 'fechamodifica', title: 'Fecha Modifica', inputType: 'datetime' }
  ]

  metadataTableLimiteCredito: newmetadate[] = [
    { field: 'enlI_TiposDescripcion', title: 'Tipo', inputType: 'autocomplete', dropdown: this.ListaTipoLimiteCredito, required: true },
    { field: 'tipO_MND', title: 'Moneda', inputType: 'autocomplete', dropdown: this.ListaTodosMoneda, required: true },
    { field: 'enlI_Monto', title: 'Monto', inputType: 'int', required: true, },
    { field: 'enlI_FecInicio', title: 'Fecha Inicio', inputType: 'date' },
    { field: 'enlI_FecVencimiento', title: 'FechaVencimiento', inputType: 'date' },
    { field: 'enlI_FormaPagoDescripcion', title: 'Forma Pago', inputType: 'autocomplete', dropdown: this.formapago },
    { field: 'enlI_DiasDuracion', title: 'Días', inputType: 'int', required: true },
    { field: 'enlI_CliAutEmiCheqDiferidos', title: 'Autorizado a emitir cheques diferidos', required: true },
    { field: 'enlI_CliConCredLibre', title: 'Cliente con crédito libre', required: true },
    { field: 'enlI_Notas', title: 'Notas', inputType: 'textOnlyInput' },
  ]

  metadataTableHistorial: newmetadate[] = [
    { field: 'enlI_Codigo', title: 'Código', inputType: 'text' }, { field: 'tipO_MND', title: 'Moneda', inputType: 'text' },
    { field: 'enlI_Monto', title: 'Monto', inputType: 'decimal' }, { field: 'enlI_Fecha', title: 'Fecha Convenio', inputType: 'date' },
    { field: 'enlI_DiasDuracion', title: 'Dias', inputType: 'int' }
  ]

  metadataTableRelacionados: newmetadate[] = [
    { field: 'relA_TipoRelacion', title: 'Tipo Relación', inputType: 'autocomplete', dropdown: this.ListaTipoRelacionDP, required: true },
    { field: 'conS_RGM', title: 'Régimen', inputType: 'autocomplete', dropdown: this.ListaRegimenDP, required: true },
    { field: 'tipE_Hijo', title: 'Tipo Entidad', inputType: 'autocomplete', dropdown: this.ListaTipoEntidadDP, required: true },
    { field: 'entC_RazonSocial', title: 'Razón Social/Nombres', inputType: 'autocomplete', dropdown: this.ListaNombreEntidadesDP, required: true },
    { field: 'entC_CodHijo', title: 'Código', inputType: 'textdisabled' },
    { field: 'entC_DocIden', title: 'Número Documento', inputType: 'textdisabled' },
    { field: 'tipO_TRF', title: 'TRF', inputType: 'autocomplete', dropdown: this.ListaTraficoDP, required: true },
    { field: 'entC_EMail', title: 'E-mail', inputType: 'textdisabled' },
    { field: 'entC_EmailReceptorFE', title: 'E-mail FE', inputType: 'textdisabled' },
    { field: 'audI_FecCrea', title: 'Creación', inputType: 'dateDisabled' },
    { field: 'audI_FecMod', title: 'Actualización', inputType: 'dateDisabled' },
    { field: 'relA_Observacion', title: 'Observaciones', inputType: 'text' }
  ]

  metadataTableServicios: newmetadate[] = [
    { field: 'key', title: 'Código', inputType: 'textdisabled' },
    { field: 'serV_Nombre', title: 'Servicio', inputType: 'autocomplete', dropdown: this.ListaServiciosDP, required: true },
    { field: 'tipO_DescMND', title: 'Moneda', inputType: 'autocomplete', dropdown: this.ListaMonedaDP, required: true },
    { field: 'eseR_Valor', title: 'Valor', inputType: 'decimal' },
    { field: 'conS_DescBAS', title: 'Aplicado/Base de Cálculo', inputType: 'autocomplete', dropdown: this.ListaBaseDP, required: true },
    { field: 'eseR_Exonerado', title: 'Exonerado', inputType: 'checkboxEdit' },
    { field: 'conS_DescLNG', title: 'Línea', inputType: 'autocomplete', dropdown: this.ListaLineaNegocioDP, inputStatus: 'lock', showClear: false },
    { field: 'conS_DescRGM', title: 'Régimen', inputType: 'autocomplete', dropdown: this.ListaRegimenDP, inputStatus: 'lock', showClear: false },
    { field: 'conS_DescVIA', title: 'Vía', inputType: 'autocomplete', dropdown: this.ListaViaDP, inputStatus: 'lock', showClear: false },
  ]

  metadataTableAuditoriaServicios: newmetadate[] = [
    { field: 'operacion', title: 'Operación', inputType: 'text' },
    { field: 'direccion_IP', title: 'Dirección IP', inputType: 'text' },
    { field: 'nombre_Maquina', title: 'Nombre máquina', inputType: 'text' },
    { field: 'nombre_Aplicacion', title: 'Nombre Aplicación', inputType: 'text' },
    { field: 'usuario_SQL', title: 'Usuario SQL', inputType: 'text' },
    { field: 'usuario_Aplicacion', title: 'Usuario Aplicación', inputType: 'text' },
    { field: 'fecha_Modificacion', title: 'Fecha Modificación', inputType: 'date' },
    { field: 'codigo_Interno', title: 'Código Interno', inputType: 'text' },
    { field: 'cod_Servicio', title: 'Cod Servicio', inputType: 'text' },
    { field: 'cod_Entidad', title: 'Cod Entidad', inputType: 'text' },
    { field: 'valor', title: 'Valor', inputType: 'text' },
    { field: 'exonerado', title: 'Exonerado', inputType: 'checkboxEdit' },
    { field: 'cantidad', title: 'Cantidad', inputType: 'text' },
    { field: 'moneda', title: 'Moneda', inputType: 'text' },
    { field: 'cod_Moneda', title: 'Cod Moneda', inputType: 'text' },
    { field: 'base_Calculo', title: 'Base Cálculo', inputType: 'text' },
    { field: 'cod_Base_Calculo', title: 'Cod Base Cálculo', inputType: 'text' },
    { field: 'usuario_Crea', title: 'Usuario Crea', inputType: 'text' },
    { field: 'fec_Crea', title: 'Fec Crea', inputType: 'date' },
    { field: 'usuario_Modifica', title: 'Usuario Modifica', inputType: 'text' },
    { field: 'fec_Modifica', title: 'Fec Modifica', inputType: 'date' },
  ]

  customAuditoriaServicios = [
    { icon: 'pi pi-file-export', function: () => this.exportarAuditoriaServicios(), toolTip: "Exportar Excel" }
  ];

  parametros: Parametros[] = []
  async ListarParametros() {
    // this.groupPoppupDG.get("almacen").setValue(false)
    // this.groupPoppupDG.get("tipoCliente").setValue("001")
    this.parametros = await this.util.getParametros()
    this.ListarTipoCliente = await this.util.loadTiposClientes()
    this.proformaService.ListarClientesComercialesCrear().subscribe({
      next: (response) => {
        this.listadoGrupos = response.datos.result.map((item: ClientesComercialesCrear) => ({
          ...item,
          filtro_cliente: `${item.razon_social} - ${item.entC_DocIden} - ${item.nombre_grupo}`
        }));
      },
      error: (err) => {
        const mensaje = err.error?.meta?.mensaje || 'Ocurrió al buscar los grupos.';
        this.messageService.add({ key: 'toast1', severity: 'error', summary: 'Error', detail: mensaje });
        this.listadoGrupos = []
        console.error('Error en la creación:', err);
      }
    });
    this.tipo = [{ name: 'Jurídica', key: 'J' }, { name: 'Natural', key: 'N' }];
    this.sexo = [{ name: 'Femenino', key: 'F' }, { name: 'Masculino', key: 'M' }];
    this.ListaTodosTipoDoc = this.parametros.slice().filter(r => r.tipo === 'TIPODOC')
    this.filterTipoDocList(this.groupPoppupDG.get('tipopersona').value);
    // console.log("this.ListaTodosTipoDoc ", this.ListaTodosTipoDoc)
    this.listPais = this.parametros.slice().filter(r => r.tipo === 'PAI')
    // console.log("this.listPais ", this.listPais)
    this.ListarTodosSegmento = this.parametros.slice().filter(r => r.tipo === 'SEGMENTO')
    // console.log("this.ListarTodosSegmento ", this.ListarTodosSegmento)
    this.ListaTodosTipoEntidad = this.parametros.slice().filter(r => r.tipo === 'TIPE')
    this.ListaTodosTipoAcuerdo = this.parametros.slice().filter(r => r.tipo === 'ACU')
    this.parametros.map(r => {
      if (r.tipo === 'BANCO') {
        const item: SelectItem = {
          label: r.nombre, value: r.codigo
        }
        this.ListaTodosBanco.push(item)
      }
      if (r.tipo === 'MONEDA') {
        const item: SelectItem = {
          label: r.adicional1, value: r.codigo
        }
        this.ListaTodosMoneda.push(item)
      }
      if (r.tipo === 'BAS') {
        const item: SelectItem = {
          label: r.nombre, value: r.codigo
        }
        this.ListaBaseDP.push(item)
      }
      if (r.tipo === 'SERVICIO') {
        const item: SelectItem = {
          label: r.nombre + '/' + r.adicional1 + '/' + r.adicional2 + '/' + r.adicional3, value: r.codigo
        }
        this.ListaServiciosDP.push(item)
        // console.log(r)
      }
      if (r.tipo === 'MND') {
        const item: SelectItem = {
          label: r.nombre, value: r.codigo
        }
        this.ListaMonedaDP.push(item)
      }
      if (r.tipo === 'TIPO_ENTIDAD') {
        const item = { label: r.nombre, value: r.codigo }
        this.ListaTipoEntidadDP.push(item)
      }
      if (r.tipo === 'RELA_TIPOS') {
        const item = { label: r.nombre, value: r.codigo, key: r.adicional1 }
        this.ListaTipoRelacionDP.push(item)
      }
      if (r.tipo === 'AGE' || r.tipo === 'CONTACTO' || r.tipo === 'CUS' || r.tipo === 'DepositoVacio'
        || r.tipo === 'DepositoTemp' || r.tipo === 'EJEC' || r.tipo === 'TRANSPORTISTA') {
        const item = { label: r.nombre, value: r.codigo, tipo: r.tipo }
        this.ListaNombreEntidadesDP.push(item)
      }
      if (r.tipo === 'RGM') {
        const item = { label: r.nombre, value: r.codigo }
        this.ListaRegimenDP.push(item)
      }
      if (r.tipo === 'TRF') {
        const item = { label: r.nombre, value: r.codigo }
        this.ListaTraficoDP.push(item)
      }
      if (r.tipo === 'LNG') {
        const item = { label: r.nombre, value: r.codigo }
        this.ListaLineaNegocioDP.push(item)
      }
      if (r.tipo === 'VIA') {
        const item = { label: r.nombre, value: r.codigo }
        this.ListaViaDP.push(item)
      }
    })
    let tipo: SelectItem[] = [{ label: 'CUENTA CORRIENTE', value: 'C' }, { label: 'CUENTA DE AHORROS', value: 'A' }, { label: 'CUENTA MAESTRA', value: 'M' }];
    this.tipocuenta.push(...tipo)
    let formap: SelectItem[] = [{ label: 'CHEQUE DIFERIDO', value: 'C' }, { label: 'CONTRA DOCUMENTO', value: 'D' }];
    this.formapago.push(...formap)
    //(this.formapago)
    this.ListaFiltradaNombreEntidadesDP = this.ListaNombreEntidadesDP
    this.ListaFiltradaTipoEntidadDP = this.ListaTipoEntidadDP

    this.cdr.markForCheck()
  }
  private tipoPersonaSubscription: Subscription;
  private tipoDocumentoSubscription: Subscription;

  async ngOnInit(): Promise<void> {

    this.nomUsuario = this.storage.get('usuario');
    this.correoUsuario = this.storage.get('correo');
    this.groupPoppupDG = new FormGroup({
      tipoCliente: new FormControl('001', Validators.required),
      //CHECKBOXES
      activo: new FormControl(null, null),
      serviciologistico: new FormControl(null, null),
      almacen: new FormControl(false, null),
      //
      codigo: new FormControl(null, null),
      tipopersona: new FormControl("J", null),
      tipodocumento: new FormControl(null, Validators.required),//OBLIGATORIO
      numerodocumento: new FormControl(null, [Validators.required, this.minDigitsValidator(3)]),//OBLIGATORIO
      // Atributos de Persona Jurídica
      razonsocial: new FormControl(null, null), //OBLIGATORIO SI ES PERSONA JURÍDICA
      razoncomercial: new FormControl(null, null), //OBLIGATORIO SI ES PERSONA JURÍDICA
      // Atributos de Persona Natural
      apellidopaterno: new FormControl(null, null),//OBLIGATORIO SI ES PERSONA NATURAL
      apellidomaterno: new FormControl(null, null),//OBLIGATORIO SI ES PERSONA NATURAL
      nombres: new FormControl(null, null),//OBLIGATORIO SI ES PERSONA NATURAL
      sexo: new FormControl("M", null),//OBLIGATORIO SI ES PERSONA NATURAL, PERO POR DEFAULT SERÁ MASCULINO.
      area: new FormControl(null, null),//OBLIGATORIO SI ES PERSONA NATURAL
      cargo: new FormControl(null, null),//OBLIGATORIO SI ES PERSONA NATURAL
      fechanacimiento: new FormControl(null, null),//OBLIGATORIO SI ES PERSONA NATURAL
      fechaingreso: new FormControl(null, null),//OBLIGATORIO SI ES PERSONA NATURAL

      //comercial
      estadoSunat: new FormControl({ value: null, disabled: true }, null),
      estadoQunac: new FormControl(0, null),
      detalleQunac: new FormControl({ value: null, disabled: true }, null),
      segmentoNuevo: new FormControl(null, null),
      detallesSegmento: new FormControl(null, null),
      //no comercial
      nomgerente: new FormControl(null, null),
      fechanacimientog: new FormControl(null, null),
      fechaAniversariog: new FormControl(null, null),//para todos
      // no comercial
      correo: new FormControl(null, [this.multipleEmailValidator]),
      correo_otros_traficos: new FormControl(null, [this.multipleEmailValidator]),

      correo2: new FormControl(null, [this.multipleEmailValidator]),
      correo_otros_traficos2: new FormControl(null, [this.multipleEmailValidator]),

      contactonombre: new FormControl(null, null),
      contactoapellidos: new FormControl(null, null),
      correoexport: new FormControl(null, [this.multipleEmailValidator]),
      correo_facturacion: new FormControl(null, [Validators.required, this.singleEmailValidator]),

      correoexport2: new FormControl(null, [this.multipleEmailValidator]),
      correo_facturacion2: new FormControl(null, [ this.singleEmailValidator]),


      segmento: new FormControl(null, null),
      web: new FormControl(null, null),
      telefono_fijo: new FormControl(null, null),
      telefono_movil: new FormControl(null, null),
      //Fiscal para todos
      direccion: new FormControl(null, [Validators.required, this.minLettersOrNumbersValidator]),//OBLIGATORIO EN CUALQUIER CASO
      pais: new FormControl(null, null), departamento: new FormControl(null, null),
      provincia: new FormControl(null, null), distrito: new FormControl(null, null),
      // comercial
      direccionComercial: new FormControl(null, null), paisComercial: new FormControl(null, null),
      departamentoComercial: new FormControl(null, null), provinciaComercial: new FormControl(null, null),
      distritoComercial: new FormControl(null, null),
      //ADMIN Y FINANZAS (disabled para comercial)
      fechacredito: new FormControl(null, null),
      diascreditos: new FormControl(null, null),
      nodomiciliado: new FormControl(null, null),
      to_order: new FormControl(null, null),
      //OBS para todos
      observaciones: new FormControl(null, null),
      sigla: new FormControl(null, this.siglaValidator),

      //no se usa
      atributosadic: new FormControl(null, null),
      vip: new FormControl(null, null), prospecto: new FormControl(null, null),
      informar_facturacion: new FormControl(null, null),
    })

    this.ListarParametros()
    // Suscripción a los cambios del select tipoCliente
    this.tipoClienteSubscription = this.groupPoppupDG.get('tipoCliente')?.valueChanges.subscribe(value => {
      this.toggleDatosComercialesValidators(value);
    });
    // Inicializar la validación al cargar el componente
    // this.toggleDatosComercialesValidators(this.groupPoppupDG.get('tipoCliente')?.value);

    // Suscripción a los cambios de tipopersona
    this.tipoPersonaSubscription = this.groupPoppupDG.get('tipopersona').valueChanges.subscribe(value => {
      // Filtra y actualiza la lista de documentos según el tipo de persona
      this.filterTipoDocList(value);
      // Limpia el valor actual de tipodocumento
      // this.groupPoppupDG.get('tipodocumento').reset(null);
      this.updateValidatorsByPersonType(value);

    });
    // 2. Suscripción a cambios en 'tipodocumento'
    this.tipoDocumentoSubscription = this.groupPoppupDG.get('tipodocumento').valueChanges.subscribe(value => {
      this.updateValidatorsByDocType(value);
    });

    // Suscripción a los cambios del multiSelect de Segmentos
    this.segmentoSubscription = this.groupPoppupDG.get('segmentoNuevo')?.valueChanges.subscribe(selectedSegments => {
      if (!selectedSegments || selectedSegments.length === 0) {
        this.selectedSegmentDetails.clear();
        this.ListarDetallesSegmento = [];
        this.groupPoppupDG.get('detallesSegmento')?.setValue(null);
        return;
      }

      // 1. Reconstruir los detalles disponibles
      const newSegmentDetails = new Map<number, any[]>();
      let allRequiredDetails: any[] = [];
      selectedSegments.forEach(segmentValue => {
        const details = this.detallesSegmentoData[segmentValue] || [];
        newSegmentDetails.set(segmentValue, details);
        allRequiredDetails = [...allRequiredDetails, ...details];
      });

      // 2. Actualizar el listado de opciones del segundo select
      this.ListarDetallesSegmento = allRequiredDetails.filter(
        (item, index, self) => index === self.findIndex((t) => t.value === item.value)
      );

      // 3. Reconstruir los valores del control de detalles
      const currentDetails: any[] = this.groupPoppupDG.get('detallesSegmento')?.value || [];

      // Mantener solo los detalles que pertenecen a segmentos aún seleccionados
      const keptDetails = currentDetails.filter(detail =>
        selectedSegments.some(seg =>
          (this.detallesSegmentoData[seg] || []).some(d => d.value === detail.value)
        )
      );

      // Agregar el primer detalle de los segmentos que aún no tienen ninguno seleccionado
      const addedDefaults = selectedSegments
        .map(segmentValue => {
          const details = this.detallesSegmentoData[segmentValue] || [];
          if (details.length === 0) return null;

          const alreadySelected = keptDetails.some(d =>
            (this.detallesSegmentoData[segmentValue] || []).some(dd => dd.value === d.value)
          );

          return alreadySelected ? null : details[0];
        })
        .filter(d => d !== null);

      // Combinar manteniendo y agregando
      const finalDetails = [...keptDetails, ...addedDefaults];

      // Actualizar el formControl solo si hay cambios
      this.groupPoppupDG.get('detallesSegmento')?.setValue(finalDetails);

      // 4. Actualizar el mapa
      this.selectedSegmentDetails = newSegmentDetails;
    });


    // Suscripción a cambios del multiSelect de Detalles
    this.detallesSegmentoSubscription = this.groupPoppupDG.get('detallesSegmento')?.valueChanges.subscribe(selectedDetails => {
      //  console.log("Detalles seleccionados:", selectedDetails);
    });

    this.groupPoppupD = new FormGroup({
      correofinanzas: new FormControl(null, this.multiEmailTrimmedValidator), ctaintersoles: new FormControl(null, null),
      ctainterdolares: new FormControl(null, null), ctadetracciones: new FormControl(null, null),
      asumedetraccion: new FormControl(null, null),
      esMandato: new FormControl(null, null), esOtrosTraficos: new FormControl(null, null),
      esSli: new FormControl(null, null), esExportaciones: new FormControl(null, null)
    })
    this.groupPoppupB = new FormGroup({
      bloqueado: new FormControl(null, null), usuariobloqueo: new FormControl(null, null),
      fechabloqueoo: new FormControl(null, null), comentariobloqueo: new FormControl(null, null),
    })
    this.group = new FormGroup({
      numdocumento: new FormControl(null, null), razonsocial: new FormControl(null, null)
    })
    this.groupPS = new FormGroup({
      servicios: new FormControl(null, null),
    })
    this.groupPoppupE = new FormGroup({
      tipoentidad: new FormControl({ value: null, disabled: true }),
      numdocumento: new FormControl({ value: null, disabled: true }),
      razonsocial: new FormControl({ value: null, disabled: true })
    })

    // --- Inicialización del nuevo FormGroup "Datos Comerciales" ---
    this.groupDatosComerciales = new FormGroup({
      // pruebas: new FormControl(false, null),
      contactoPrincipal: new FormGroup({
        nombre: new FormControl(null, [Validators.required, this.minLettersValidator]),
        apellido: new FormControl(null, [Validators.required, this.minLettersValidator]),
        puesto: new FormControl(null, this.minLettersValidator),
        telefono: new FormControl(null, [Validators.required, this.phoneValidator]),
        cumpleanos: new FormControl(null), // opcional
        email: new FormControl(null, [Validators.required, this.multiEmailTrimmedValidator]),
        checkOpcional: new FormControl(false, null),
        replicateFromPrincipalall: new FormControl(false, null),
      }),
      checkOpcionalILC: new FormControl(false, null),
      internationalLogisticsContacts: new FormArray([
        this.createLogisticsContactGroup({ id: uuidv4() })
      ]),
      billingContact: new FormGroup({
        name: new FormControl(null, [Validators.required, this.minLettersValidator]),
        lastName: new FormControl(null, [Validators.required, this.minLettersValidator]),
        position: new FormControl(null, this.minLettersValidator),
        phone: new FormControl(null, [Validators.required, this.phoneValidator]),
        email: new FormControl(null, [Validators.required, this.multiEmailTrimmedValidator]),
        birthday: new FormControl(null), // opcional
        checkOpcional: new FormControl(false, null),

      }),
      checkOpcionalOC: new FormControl(false, null),
      operationsContacts: new FormArray([
        this.createOperationsContactGroup({ id: uuidv4() })
      ]),
      checkOpcionalCustomerProfile: new FormControl(false, null),
    });

    // En tu ngOnInit() o en el constructor
    this.groupDatosComerciales.get('contactoPrincipal.checkOpcional')?.valueChanges.subscribe(isOptional => {
      this.toggleValidators(this.groupDatosComerciales.get('contactoPrincipal') as FormGroup, isOptional);
    });


    this.groupDatosComerciales.get('contactoPrincipal.replicateFromPrincipalall')?.valueChanges.subscribe(isOptional => {
      this.toggleValidators(this.groupDatosComerciales.get('contactoPrincipal') as FormGroup, isOptional);
    });


    this.groupDatosComerciales.get('billingContact.checkOpcional')?.valueChanges.subscribe(isOptional => {
      this.toggleValidators(this.groupDatosComerciales.get('billingContact') as FormGroup, isOptional);
    });

    this.groupDatosComerciales.get('checkOpcionalILC')?.valueChanges.subscribe(isOptional => {
      this.toggleArrayValidators(this.groupDatosComerciales.get('internationalLogisticsContacts') as FormArray, isOptional, 'logistics');
    });

    this.groupDatosComerciales.get('checkOpcionalOC')?.valueChanges.subscribe(isOptional => {
      this.toggleArrayValidators(this.groupDatosComerciales.get('operationsContacts') as FormArray, isOptional, 'operations');
    });
    // 👇 SUSCRIPCIONES DE SINCRONIZACIÓN
    this.subscribeFieldSync('contactonombre', 'contactoPrincipal.nombre');
    this.subscribeFieldSync('contactoapellidos', 'contactoPrincipal.apellido');
    // this.subscribeFieldSync('correo', 'contactoPrincipal.email');
    this.subscribeFieldSync('telefono_movil', 'contactoPrincipal.telefono');
    this.subscribeFieldSync('fechanacimientog', 'contactoPrincipal.cumpleanos');

    this.subscribeFieldSync('correo_facturacion', 'billingContact.email');
    this.subscribeFieldSync('telefono_fijo', 'billingContact.phone');

    // Sincronización bidireccional entre inputs y FormArrays
    const logisticsArray = this.groupDatosComerciales.get('internationalLogisticsContacts') as FormArray;
    const operationsArray = this.groupDatosComerciales.get('operationsContacts') as FormArray;

    //comento esto para que no sincronize los correos mcarhuavilca
    // this.subscribeEmailFieldSync('correo', logisticsArray, operationsArray);
    // this.subscribeEmailFieldSync('correoexport', logisticsArray, operationsArray);
    // this.subscribeEmailFieldSync('correo_otros_traficos', logisticsArray, operationsArray);

    this.setupPrincipalReplication();
    // this.syncReplicateFromLogistics();
    // this.hasAnyValue('initial');
    this.setupEmailSync();
  }

  private subscribeFieldSync(fromPath: string, toPath: string) {
    const fromCtrl = this.groupPoppupDG.get(fromPath);
    const toCtrl = this.groupDatosComerciales.get(toPath);

    if (!fromCtrl || !toCtrl) return;

    // 👉 Cuando cambia el valor en el popup
    fromCtrl.valueChanges.subscribe(value => {
      if (toCtrl.value !== value) {
        toCtrl.setValue(value, { emitEvent: false });
      }
    });

    // 👉 Cuando cambia el valor en el formulario comercial
    toCtrl.valueChanges.subscribe(value => {
      if (fromCtrl.value !== value) {
        fromCtrl.setValue(value, { emitEvent: false });
      }
    });
  }

  private subscribeEmailFieldSync(
    inputName: 'correo' | 'correoexport' | 'correo_otros_traficos',
    logisticsArray: FormArray,
    operationsArray: FormArray
  ): Subscription {
    const inputCtrl = this.groupPoppupDG.get(inputName);
    if (!inputCtrl) return new Subscription();

    return inputCtrl.valueChanges.pipe(debounceTime(400)).subscribe((rawValue: string) => {
      const value = (rawValue || '').trim();

      // Seleccionar array destino
      const targetArray =
        inputName === 'correo_otros_traficos' ? operationsArray : logisticsArray;

      // Determinar tipo según input
      const type =
        inputName === 'correo'
          ? 'mandato'
          : inputName === 'correoexport'
            ? 'exportacion'
            : 'otrosTraficos';

      // Mantener contactos de otros tipos
      const preservedContacts = targetArray.value.filter(
        (v: any) => !v.emailTypes?.[type]
      );

      // Regex para validar correos
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      // Dividir por ";", ignorar los vacíos
      const parts = value.split(';').map(e => e.trim()).filter(e => e);

      // Solo considerar como válidos los que cumplan con el formato de correo
      const validEmails = parts.filter(e => emailRegex.test(e));

      // Si el usuario está escribiendo algo aún no válido, no hacer nada
      const lastPart = parts[parts.length - 1];
      const isTypingIncomplete = lastPart && !emailRegex.test(lastPart);
      if (isTypingIncomplete) return;

      // Si el texto termina con ";", espera al siguiente correo
      if (value.endsWith(';')) return;

      // ✅ Actualizar contactos de este tipo
      const newContacts = validEmails.map(email => ({
        id: uuidv4(),
        email,
        emailTypes: {
          exportacion: type === 'exportacion',
          otrosTraficos: type === 'otrosTraficos',
          mandato: type === 'mandato',
        },
      }));

      // Si no hay cambios reales, no actualizar
      const existingEmails = targetArray.value
        .filter((v: any) => v.emailTypes?.[type])
        .map((v: any) => v.email?.trim());
      const newEmails = newContacts.map(c => c.email);
      const hasChanges =
        existingEmails.length !== newEmails.length ||
        existingEmails.some((e, i) => e !== newEmails[i]);

      if (!hasChanges) return;

      // 🔄 Reconstruir el array con preservados + nuevos de este tipo
      targetArray.clear();

      preservedContacts.forEach(c =>
        targetArray.push(
          inputName === 'correo_otros_traficos'
            ? this.createOperationsContactGroup(c)
            : this.createLogisticsContactGroup(c)
        )
      );

      newContacts.forEach(c =>
        targetArray.push(
          inputName === 'correo_otros_traficos'
            ? this.createOperationsContactGroup(c)
            : this.createLogisticsContactGroup(c)
        )
      );
    });
  }

  private setupEmailSync() {
    //COMENTO ESTO PARA QUE NO REPLIQUE LOS CAMBIOS EN LA SECCION DATOS COMERCIALES mcarhuavilca

    console.log('comentado')
    // const logisticsArray = this.groupDatosComerciales.get('internationalLogisticsContacts') as FormArray;
    // const operationsArray = this.groupDatosComerciales.get('operationsContacts') as FormArray;

    // // Importante: cancelar suscripciones previas si existieran
    // if (this.emailSubscriptions) {
    //   this.emailSubscriptions.forEach(sub => sub.unsubscribe());
    // }
    // this.emailSubscriptions = [];

    // // Crear nuevas suscripciones 
    //  this.emailSubscriptions.push(
    //    this.subscribeEmailFieldSync('correo', logisticsArray, operationsArray)
    // );
    // this.emailSubscriptions.push(
    //    this.subscribeEmailFieldSync('correoexport', logisticsArray, operationsArray)
    //  );
    // this.emailSubscriptions.push(
    //  this.subscribeEmailFieldSync('correo_otros_traficos', logisticsArray, operationsArray)
    // );
  }

  private handleMultipleEmails(
    emailString: string,
    formArray: FormArray,
    addContactFn: () => void,
    createGroupFn: (data?: any) => FormGroup,
    type: 'exportacion' | 'otrosTraficos' | 'mandato'
  ) {

    const emails = emailString.split(';').map(e => e.trim()).filter(e => e);
    if (emails.length === 0) return;

    // formArray.clear();

    emails.forEach(email => {
      //validar que email no sea "sincorreo@gmail.com", en caso true ejecutar return
      if (email === " ") return
      const contactGroup = createGroupFn({
        id: uuidv4(),
        email,
        emailTypes: {
          exportacion: type === 'exportacion',
          otrosTraficos: type === 'otrosTraficos',
          mandato: type === 'mandato',
        },
      });

      formArray.push(contactGroup);
    });
  }

  private subscribeMultiEmailSync(popupPath: string, formArrayPath: string) {
    const popupCtrl = this.groupPoppupDG.get(popupPath);
    const arrayCtrl = this.groupDatosComerciales.get(formArrayPath) as FormArray;

    if (!popupCtrl || !arrayCtrl) return;

    // 👉 Cuando cambia el input concatenado (por ejemplo "correoexport")
    popupCtrl.valueChanges.subscribe(value => {
      if (!value) return;

      const emails = value.split(';').map(e => e.trim()).filter(e => e);
      arrayCtrl.clear();

      emails.forEach(email => {
        const contact = this.createEmailContactGroup(email, popupPath);
        arrayCtrl.push(contact);
      });
    });

    // 👉 Cuando cambian los contactos individuales (array)
    arrayCtrl.valueChanges.subscribe(value => {
      const emails = value
        .map(v => v?.email?.trim())
        .filter(e => e)
        .join(';');
      if (popupCtrl.value !== emails)
        popupCtrl.setValue(emails, { emitEvent: false });
    });
  }

  private createEmailContactGroup(email: string, sourcePath: string): FormGroup {
    const isExport = sourcePath === 'correoexport';
    const isOtros = sourcePath === 'correo_otros_traficos';

    return new FormGroup({
      id: new FormControl(uuidv4()),
      nombre: new FormControl(null),
      apellido: new FormControl(null),
      puesto: new FormControl(null),
      telefono: new FormControl(null),
      birthday: new FormControl(null),
      email: new FormControl(email),
      emailTypes: new FormGroup({
        exportacion: new FormControl(isExport),
        otrosTraficos: new FormControl(isOtros),
      }),
    });
  }

  // Para FormGroups (como 'contactoPrincipal' o 'billingContact')
  toggleValidators(formGroup: FormGroup, isOptional: boolean) {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      // Ignora el control del checkbox y otros que no necesitan validación de "required"
      if (key === 'checkOpcional' || key === 'cumpleanos' || key === 'birthday' || key === 'replicateFromPrincipalall') {
        return;
      }

      if (isOptional) {
        // Si es opcional, remueve todos los validadores
        control?.clearValidators();
      } else {
        // Vuelve a aplicar los validadores originales
        if (key === 'telefono' || key === 'phone') {
          control?.setValidators([Validators.required, this.phoneValidator]);
        } else if (key === 'email') {
          control?.setValidators([Validators.required, this.multiEmailTrimmedValidator]);
        } else if (key === 'puesto' || key == "position") {
          control?.setValidators(this.minLettersValidator);
        } else {
          // Aplica validadores por defecto
          control?.setValidators([Validators.required, this.minLettersValidator]);
        }
      }
      control?.updateValueAndValidity();
    });
  }

  // Para FormArrays (como 'internationalLogisticsContacts' y 'operationsContacts')
  toggleArrayValidators(formArray: FormArray, isOptional: boolean, type: 'logistics' | 'operations') {
    // Itera sobre cada FormGroup dentro del FormArray
    formArray.controls.forEach(formGroup => {
      const group = formGroup as FormGroup;
      Object.keys(group.controls).forEach(key => {
        const control = group.get(key);
        // Si el control está deshabilitado (ej. por la réplica), no hagas nada
        if (control?.disabled) {
          return;
        }

        if (isOptional) {
          // Si es opcional, remueve todos los validadores
          control?.clearValidators();
        } else {
          // Vuelve a aplicar los validadores originales
          // if (key === 'name' || key === 'lastName' || key === 'position') {
          if (key === 'name' || key === 'lastName') {
            control?.setValidators([Validators.required, this.minLettersValidator]);
          } else if (key === 'phone') {
            control?.setValidators([Validators.required, this.phoneValidator]);
          } else if (key === 'email') {
            control?.setValidators([Validators.required, this.multiEmailTrimmedValidator]);
          } else if (key === 'emailTypes' && type === 'logistics') {
            // Solo aplica este validador para contactos de logística
            control?.setValidators([this.atLeastOneEmailTypeValidator]);


            if (group.get("email").value != null) {
              if ((control.get('mandato').value == false || control.get('mandato').value == null) && (control.get('exportacion').value == false || control.get('exportacion').value == null) && (control.get('otrosTraficos').value == false || control.get('otrosTraficos').value == null)) {



                this.messageService.add({
                  key: 'toast3',
                  severity: 'warn',
                  summary: 'Atención',
                  detail: 'falta marcar tipo de correo.'
                });
                //   this.messageService.clear();

              }
            }
          }
        }
        control?.updateValueAndValidity({

        });
      });
    });
  }

  // Lifecycle hook to prevent memory leaks
  ngOnDestroy(): void {
    if (this.tipoPersonaSubscription) {
      this.tipoPersonaSubscription.unsubscribe();
    }
    if (this.segmentoSubscription) {
      this.segmentoSubscription.unsubscribe();
    }
    if (this.detallesSegmentoSubscription) {
      this.detallesSegmentoSubscription.unsubscribe();
    }
    if (this.tipoDocumentoSubscription) this.tipoDocumentoSubscription.unsubscribe();
    if (this.tipoClienteSubscription) {
      this.tipoClienteSubscription.unsubscribe();
    }
  }

  toggleDatosComercialesValidators(value: string) {
    if (value === '004') {
      // Si es "Cliente comercial", activa las validaciones
      this.groupDatosComerciales.get('campo1')?.setValidators(Validators.required);
      this.groupDatosComerciales.get('campo2')?.setValidators(Validators.required);
      this.groupDatosComerciales.enable();
      this.groupPoppupDG.get('fechacredito').disable()
      this.groupPoppupDG.get('diascreditos').disable()
      this.groupPoppupDG.get('nodomiciliado').disable()
      this.groupPoppupDG.get('to_order').disable()

      // if(this.groupPoppupDG.get('contactonombre').value.trim()){this.groupDatosComerciales.get("contactoPrincipal.nombre")?.setValue(this.groupPoppupDG.get('contactonombre').value.trim());}
      // if(this.groupPoppupDG.get('contactoapellidos').value.trim()){this.groupDatosComerciales.get("contactoPrincipal.apellido")?.setValue(this.groupPoppupDG.get('contactoapellidos').value.trim());}
      // if(this.groupPoppupDG.get('correo').value.trim()){this.groupDatosComerciales.get("contactoPrincipal.email")?.setValue(this.groupPoppupDG.get('correo').value.trim());}
      // if(this.groupPoppupDG.get('telefono_movil').value.trim()){this.groupDatosComerciales.get("contactoPrincipal.telefono")?.setValue(this.groupPoppupDG.get('telefono_movil').value.trim());}
      // if(this.groupPoppupDG.get('fechanacimientog').value){this.groupDatosComerciales.get("contactoPrincipal.cumpleanos")?.setValue(this.groupPoppupDG.get('fechanacimientog').value);}


      // if(this.groupPoppupDG.get('telefono_fijo').value.trim()){this.groupDatosComerciales.get("billingContact.email")?.setValue(this.groupPoppupDG.get('telefono_fijo').value.trim());}
      // if(this.groupPoppupDG.get('correo_facturacion').value.trim()){setValue(this.nextsoft_entC_EmailReceptorFE)}
      // if(this.groupPoppupDG.get('correoexport').value.trim()){setValue(this.nextsoft_entC_CorreoContactoExpo)}
      // if(this.groupPoppupDG.get('correo_otros_traficos').value.trim()){setValue(this.nextsoft_entC_EMail2)}

      if (this.modo === "CREAR") {
        this.groupDatosComerciales.get('contactoPrincipal.checkOpcional')?.setValue(false)
        this.groupDatosComerciales.get('checkOpcionalILC')?.setValue(true)
        this.groupDatosComerciales.get('billingContact.checkOpcional')?.setValue(true)
        this.groupDatosComerciales.get('checkOpcionalOC')?.setValue(true)
        this.groupDatosComerciales.get('checkOpcionalCustomerProfile')?.setValue(true)
      }

    } else {
      // Si es cualquier otro, desactiva las validaciones y el control
      this.groupDatosComerciales.get('campo1')?.clearValidators();
      this.groupDatosComerciales.get('campo2')?.clearValidators();
      this.groupDatosComerciales.disable(); // Opcional, para evitar interacciones
      this.groupPoppupDG.get('fechacredito').enable()
      this.groupPoppupDG.get('diascreditos').enable()
      this.groupPoppupDG.get('nodomiciliado').enable()
      this.groupPoppupDG.get('to_order').enable()

      // if(this.nextsoft_entC_NombreContacto){this.groupPoppupDG.get('contactonombre').setValue(this.nextsoft_entC_NombreContacto)}
      // if(this.nextsoft_entC_ApellidoContacto){this.groupPoppupDG.get('contactoapellidos').setValue(this.nextsoft_entC_ApellidoContacto)}
      // if(this.nextsoft_fechaNacimientog){this.groupPoppupDG.get('fechanacimientog').setValue(this.nextsoft_fechaNacimientog)}
      // if(this.nextsoft_entC_EMail){this.groupPoppupDG.get('correo').setValue(this.nextsoft_entC_EMail)}
      // if(this.nextsoft_entC_EmailReceptorFE){this.groupPoppupDG.get('correo_facturacion').setValue(this.nextsoft_entC_EmailReceptorFE)}
      // if(this.nextsoft_entC_CorreoContactoExpo){this.groupPoppupDG.get('correoexport').setValue(this.nextsoft_entC_CorreoContactoExpo)}
      // if(this.nextsoft_entC_EMail2){this.groupPoppupDG.get('correo_otros_traficos').setValue(this.nextsoft_entC_EMail2)}
      // if(this.nextsoft_entC_Tel1){this.groupPoppupDG.get('telefono_fijo').setValue(this.nextsoft_entC_Tel1)}
      // if(this.nextsoft_entC_Tel2){this.groupPoppupDG.get('telefono_movil').setValue(this.nextsoft_entC_Tel2)}

      if (this.modo === "CREAR") {
        this.groupDatosComerciales.get('contactoPrincipal.checkOpcional')?.setValue(false)
        this.groupDatosComerciales.get('checkOpcionalILC')?.setValue(false)
        this.groupDatosComerciales.get('billingContact.checkOpcional')?.setValue(false)
        this.groupDatosComerciales.get('checkOpcionalOC')?.setValue(false)
        this.groupDatosComerciales.get('checkOpcionalCustomerProfile')?.setValue(false)
      }
    }

    // Actualizar la validez de los controles
    this.groupDatosComerciales.get('campo1')?.updateValueAndValidity();
    this.groupDatosComerciales.get('campo2')?.updateValueAndValidity();
  }

  private resetConditionalFields(tipo: string): void {
    const juridicaFields = ['razonsocial', 'razoncomercial', 'estadoSunat'];
    const naturalFields = ['apellidopaterno', 'apellidomaterno', 'nombres', 'sexo', 'area', 'cargo', 'fechanacimiento', 'fechaingreso'];

    // Si el tipo es Jurídica, resetea los campos de Natural
    if (tipo === 'J') {
      naturalFields.forEach(field => {
        this.groupPoppupDG.get(field)?.reset(null);
      });
    }
    // Si el tipo es Natural, resetea los campos de Jurídica
    else if (tipo === 'P') {
      juridicaFields.forEach(field => {
        this.groupPoppupDG.get(field)?.reset(null);
      });
    }
  }

  private filterTipoDocList(tipo: string): void {
    if (tipo === 'J') {
      // Si es Jurídica, muestra RUC, SIN RUC y OTROS
      this.listTipoDocFiltrado = this.ListaTodosTipoDoc.filter(doc => doc.codigo === '001' || doc.codigo === '004' || doc.codigo === '005');
    } else if (tipo === 'N') {
      // Si es Natural, muestra DNI, PASAPORTE y OTROS
      this.listTipoDocFiltrado = this.ListaTodosTipoDoc.filter(doc => doc.codigo === '001' ||  doc.codigo === '002' || doc.codigo === '003' || doc.codigo === '005');
    }
    // Si la lista tiene elementos, inicializa el formControl con el primer valor
    if (this.listTipoDocFiltrado.length > 0) {
      this.groupPoppupDG.get('tipodocumento')?.setValue(this.listTipoDocFiltrado[0].codigo);
    } else {
      this.groupPoppupDG.get('tipodocumento')?.setValue(null);
    }
  }

  // 👉 Validador personalizado para uno o más correos separados por ";"
  multipleEmailValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value?.trim();
    if (!value) return null; // No requerido → válido si está vacío

    // Divide los correos por ';' y valida cada uno con una expresión regular estándar
    const emails = value.split(';').map(e => e.trim()).filter(e => e.length > 0);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const allValid = emails.every(email => emailRegex.test(email));

    return allValid ? null : { invalidEmail: true };
  }

  singleEmailValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value?.trim();
    if (!value) return null;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValid = emailRegex.test(value) && !value.includes(';') && !value.includes(',');
    return isValid ? null : { invalidEmail: true };
  }

  siglaValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value?.trim();
    if (!value) return null; // No requerido → válido si está vacío

    if (value.length < 3) {
      return { minlength: { requiredLength: 3, actualLength: value.length } };
    }
    if (value.length > 10) {
      return { maxlength: { requiredLength: 10, actualLength: value.length } };
    }
    return null;
  }

  // Validador para RUC
  rucValidator(control: FormControl): { [key: string]: any } | null {
    const value = control.value;
    if (value) {
      const ruc = value.toString().trim();
      if (!/^\d{11}$/.test(ruc) || (ruc.charAt(0) !== '1' && ruc.charAt(0) !== '2')) {
        return { 'invalidRuc': true };
      }
    }
    return null;
  }

  // Validador para DNI
  dniValidator(control: FormControl): { [key: string]: any } | null {
    const value = control.value;
    if (value && !/^\d{8}$/.test(value.toString().trim())) {
      return { 'invalidDni': true };
    }
    return null;
  }

  // Aplica los validadores según el tipo de persona (Jurídica o Natural)
  private updateValidatorsByPersonType(tipo: string): void {
    const juridicaControls = ['razonsocial', 'razoncomercial', 'estadoSunat'];
    const naturalControls = ['apellidopaterno', 'apellidomaterno', 'nombres', 'sexo', 'area', 'cargo', 'fechanacimiento', 'fechaingreso'];

    // Limpia los validadores y el estado de los campos de Jurídica y Natural.
    juridicaControls.forEach(field => {
      this.groupPoppupDG.get(field)?.clearValidators();
      this.groupPoppupDG.get(field)?.markAsUntouched(); // Limpia el estado touched
      this.groupPoppupDG.get(field)?.updateValueAndValidity();
    });
    naturalControls.forEach(field => {
      this.groupPoppupDG.get(field)?.clearValidators();
      this.groupPoppupDG.get(field)?.markAsUntouched(); // Limpia el estado touched
      this.groupPoppupDG.get(field)?.updateValueAndValidity();
    });

    if (tipo === 'J') {
      // Jurídica: hace sus campos obligatorios con validador de letras
      juridicaControls.forEach(field => {
        this.groupPoppupDG.get(field)?.setValidators([Validators.required, this.minLettersOrNumbersValidator]);
        this.groupPoppupDG.get(field)?.updateValueAndValidity();
      });
    } else if (tipo === 'P') {
      // Natural: hace sus campos obligatorios con validador de letras
      naturalControls.forEach(field => {
        const validators = [Validators.required];
        if (field !== 'sexo' && field !== 'fechanacimiento' && field !== 'fechaingreso') {
          validators.push(this.minLettersValidator);
        }
        this.groupPoppupDG.get(field)?.setValidators(validators);
        this.groupPoppupDG.get(field)?.updateValueAndValidity();
      });
      // Asignar el valor por defecto para 'sexo'
      this.groupPoppupDG.get('sexo')?.setValue('M');
    }
    this.groupPoppupDG.get('numerodocumento')?.reset(null);
  }

  // Aplica los validadores de documento según el tipo seleccionado
  private updateValidatorsByDocType(codigoDoc: string): void {
    const numeroDocControl = this.groupPoppupDG.get('numerodocumento');
    if (!numeroDocControl) return;

    // Limpia los validadores anteriores
    numeroDocControl.clearValidators();

    // Aplica los validadores según el tipo de documento
    if (codigoDoc === '001') { // RUC
      numeroDocControl.enable();
      numeroDocControl.setValidators([Validators.required, this.rucValidator]);
    } else if (codigoDoc === '002') { // DNI
      numeroDocControl.enable();
      numeroDocControl.setValidators([Validators.required, this.dniValidator]);
    } else if (codigoDoc === '004') { //SIN RUC
      numeroDocControl.disable();
      numeroDocControl.clearValidators();
      numeroDocControl.setValidators([]); // No requerido
    } else { // Otros documentos (pasaporte, etc.)
      numeroDocControl.enable();
      numeroDocControl.setValidators([Validators.required, this.minDigitsValidator(3)]);
    }

    // Actualiza la validez
    numeroDocControl.updateValueAndValidity();
  }

  private showValidationMessages(): void {
    this.messageService.clear(); // Limpia los mensajes anteriores

    const invalidControls: string[] = [];

    // Paso 1: Identifica y cuenta todos los controles inválidos
    Object.keys(this.groupPoppupDG.controls).forEach(key => {
      const control = this.groupPoppupDG.get(key) as FormControl;

      // El 'touched' es importante para evitar errores al cargar el formulario
      if (control.invalid && (control.dirty || control.touched)) {
        invalidControls.push(key);
      }
    });

    // Paso 2: Decide qué tipo de mensaje mostrar basado en el conteo de errores
    if (invalidControls.length > 4) {
      // Si hay más de 4 errores, muestra un mensaje general
      this.messageService.add({
        key: 'toast1',
        severity: 'warn',
        summary: 'Atención',
        detail: 'Por favor, llene los campos marcados para continuar.'
      });
    } else if (invalidControls.length > 0) {
      // Si hay entre 1 y 4 errores, muestra los mensajes específicos
      invalidControls.forEach(key => {
        const control = this.groupPoppupDG.get(key) as FormControl;
        const errors = control.errors;
        let errorMessage = '';

        if (errors) {
          const fieldName = this.getFieldName(key);

          if (errors['required']) {
            errorMessage = `'${fieldName}' es obligatorio.`;
          } else if (errors['minLetters']) {
            errorMessage = `'${fieldName}' debe contener al menos 3 letras.`;
          } else if (errors['minDigits']) {
            const requiredLength = errors['minDigits'].requiredLength;
            errorMessage = `'${fieldName}' debe tener al menos ${requiredLength} dígitos.`;
          } else if (errors['invalidRuc']) {
            errorMessage = `'${fieldName}' no es un RUC válido. Debe ser numérico, tener 11 dígitos y empezar con 1 o 2.`;
          } else if (errors['invalidDni']) {
            errorMessage = `'${fieldName}' no es un DNI válido. Debe ser numérico y tener 8 dígitos.`;
          } else if (errors['invalidEmail']) {// 🔹 Nuevo caso para emails múltiples
            errorMessage = `'${fieldName}' tiene formato inválido. Use ';' para separar varios correos.`;
          } else if (errors['invalidEmails']) {
            errorMessage = `'${fieldName}' contiene uno o más correos electrónicos inválidos.`;
          }

          if (errorMessage) {
            this.messageService.add({
              key: 'toast1',
              severity: 'error',
              summary: 'Error de Validación',
              detail: errorMessage
            });
          }
        }
      });
    }
  }

  /**
   * Helper para obtener un nombre de campo más amigable
   * @param key La clave del FormControl (ej: 'apellidopaterno')
   * @returns El nombre formateado (ej: 'Apellido Paterno')
   */
  private getFieldName(key: string): string {
    const names = {
      tipodocumento: 'Tipo de Documento',
      numerodocumento: 'Número de Documento',
      razonsocial: 'Razón Social',
      razoncomercial: 'Razón Comercial',
      apellidopaterno: 'Apellido Paterno',
      apellidomaterno: 'Apellido Materno',
      nombres: 'Nombres',
      sexo: 'Sexo',
      area: 'Área',
      cargo: 'Cargo',
      fechanacimiento: 'Fecha de Nacimiento',
      fechaingreso: 'Fecha de Ingreso',
      direccion: 'Dirección',
    };
    return names[key] || key;
  }

  /**
   * Marca recursivamente todos los controles de un FormGroup como 'touched'.
   * Esto es crucial para que PrimeNG aplique los estilos de validación.
   */
  private markAllAsTouched(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      if (control instanceof FormGroup) {
        this.markAllAsTouched(control);
      } else {
        control?.markAsTouched();
      }
    });
  }

  search() {
    const loadingScreen = this.util.showLoadingScreen({ message: "Buscando datos ..." });
    const Request: ListarEntidadesRequest = <ListarEntidadesRequest>{}
    Request.pintENTC_Codigo = null
    Request.pvchENTC_NomCompleto = this.group.get('razonsocial').value;
    Request.pvchTIPE_Codigo = this.codigoEntidad;
    Request.pvchENTC_DocIden = this.group.get('numdocumento').value;
    this.dataTable = []
    this.mantcomercial.ListarEntidades(Request).subscribe(response => {
      if (response.datos.status === 200) {
        this.dataTable = response.datos.result;
        loadingScreen.close();
      } else {
        loadingScreen.close();
        this.dataTable = []
        this.util.ShowMessage({ titulo: "ERROR", mensaje: "No se encontraron datos", icono: "pi pi-exclamation-triangle", tipo: "warning" });
      }
    }, err => {
      loadingScreen.close();
      this.dataTable = []
      this.util.ShowMessage({ titulo: err.error?.meta?.mensaje, tipo: 'warning', icono: 'pi pi-exclamation-triangle' });
    })
  }

  validarEstadoQunac() {

    const ruc = this.groupPoppupDG.get("numerodocumento").value.toString().trim();

    if (!/^\d{11}$/.test(ruc) || (ruc.charAt(0) !== '1' && ruc.charAt(0) !== '2')) {
      return;
    }

    this.proformaService.ConsultarEmbarqueQunac({ ruc }).subscribe({
      next: (response) => {
        // Validar si la respuesta y los datos son válidos antes de continuar
        if (response.datos.status === 200) {
          this.messageService.clear();
          this.messageService.add({
            key: 'toast1',
            severity: 'info',
            summary: 'Respuesta de Qunac',
            detail: response.meta.mensaje
          });
          this.groupPoppupDG.get('detalleQunac').setValue(response.datos.resultado);
          //  console.log("estado qunac ", response.datos.estado)
          if (response.datos.estado) {
            this.groupPoppupDG.get('estadoQunac').setValue(response.datos.estado);
          }
        }
      },
      error: (err) => {
        this.messageService.clear();
        if (err.error.datos.status === 404) {
          this.messageService.add({
            key: 'toast2',
            severity: 'error',
            summary: 'Qunac',
            detail: 'El número del documento no se encuentra en la base de datos de Qunac'
          });
        } else {

          this.messageService.add({
            key: 'toast2',
            severity: 'error',
            summary: 'Qunac',
            detail: 'Ocurrió un error al buscar el ruc en la base de datos de Qunac.'
          });
        }

      }
    });
  }

  validarDocumento() {
    const values = this.groupPoppupDG.value
    const Request: ValidarDocIdentidadRequest = <ValidarDocIdentidadRequest>{}
    Request.pintENTC_Codigo = 0
    Request.pchrTIPO_TabTDI = 'TDI'
    Request.pchrTIPO_CodTDI = values['tipodocumento']
    Request.pvchENTC_DocIden = values['numerodocumento']

    this.mantcomercial.ValidarEntidadSunat(Request).subscribe(response => {
      if (response.datos.status === 200) {
        this.cargarDatosEdicion('', response.datos.result[0])
        this.messageService.clear();
        this.messageService.add({
          key: 'toast2',
          severity: 'info',
          summary: 'CLIENTE YA REGISTRADO',
          detail: 'El documento de identidad ya se encuentra registrado.',
          life: 10000
        });
      }
    }, (errorServicio => {
      if (values['tipodocumento'] === '001') {
        const requestSunat: sunatRequest = <sunatRequest>{}
        requestSunat.razonsocial = values["razonSocial"]
        requestSunat.ruc = values["numerodocumento"]

        this.proformaService.listarSunat(requestSunat).subscribe({
          next: async (response) => {
            // Validar si la respuesta y los datos son válidos antes de continuar
            if (!response?.datos?.result?.length) {
              this.messageService.clear();
              this.messageService.add({
                key: 'toast2',
                severity: 'error',
                summary: 'Error',
                detail: 'El documento de identidad no se encuentra registrado en SUNAT, por favor verifique.'
              });
              return;
            }

            const sunatData = response.datos.result[0];

        
            if (values['tipopersona'] === 'N'){
                 const nombresCompletos = sunatData.nombre_o_razon_social ? sunatData.nombre_o_razon_social.split(' ') : [];
              const apellidoPaterno = nombresCompletos.length > 0 ? nombresCompletos[0] : '';
              const apellidoMaterno = nombresCompletos.length > 1 ? nombresCompletos[1] : '';
              const nombres = nombresCompletos.length > 2 ? nombresCompletos.slice(2).join(' ') : '';
              this.groupPoppupDG.get('apellidopaterno')?.setValue(apellidoPaterno);
              this.groupPoppupDG.get('apellidomaterno')?.setValue(apellidoMaterno);
              this.groupPoppupDG.get('nombres')?.setValue(nombres);

            }else {
              const nombre_o_razon_social = sunatData.nombre_o_razon_social?.replace(/\\/g, '') || '';
            const direccion_completa = sunatData.direccion_completa || '';
           
            this.groupPoppupDG.get('razonsocial')?.setValue(nombre_o_razon_social);
            this.groupPoppupDG.get('razoncomercial')?.setValue(nombre_o_razon_social);
            this.groupPoppupDG.get('direccion')?.setValue(direccion_completa);
            }
            // Usar optional chaining y nullish coalescing para un acceso seguro a las propiedades
            const estado_sunat = sunatData.estado_del_controbuyente || '';
            this.groupPoppupDG.get('estadoSunat')?.setValue(estado_sunat);

            // Lógica para el ubigeo
            const ubigeo = sunatData.ubigeo;
            const ubigeoFormateado = ubigeo?.length === 6 ? `${ubigeo.slice(0, 2)}.${ubigeo.slice(2, 4)}.${ubigeo.slice(4, 6)}` : ubigeo;
            const tipo_codpais = "179"; // Perú por defecto

            // Asegúrate de que listPais esté poblada
            const pais = this.listPais.find(r => r.codigo?.toUpperCase() === tipo_codpais.toUpperCase())?.codigo;

            if (pais) {
              this.groupPoppupDG.get('pais')?.setValue(pais);

              // Ahora llamamos a las funciones de ubigeo de forma secuencial y asíncrona
              const partes = ubigeoFormateado?.split(".");
              if (partes?.length === 3) {
                const departamento = partes[0];
                const provincia = `${partes[0]}.${partes[1]}`;
                const distrito = ubigeoFormateado;

                // Esperar a que cada llamada asíncrona complete antes de continuar
                await this.onPaisSeleccionadoAsync(pais, 'fiscal');
                this.groupPoppupDG.get('departamento')?.setValue(departamento);

                await this.onDepartamentoSeleccionadoAsync(departamento, 'fiscal');
                this.groupPoppupDG.get('provincia')?.setValue(provincia);

                await this.onprovinciaSeleccionadaAsync(provincia, 'fiscal');
                this.groupPoppupDG.get('distrito')?.setValue(distrito);
              }
            }

            // this.informacionSunat("disable")
            this.messageService.clear();
            this.messageService.add({
              key: 'toast1',
              severity: 'success',
              summary: 'OK',
              detail: 'El documento de identidad se encuentra registrado en SUNAT.'
            });
          },
          error: (err) => {
            this.messageService.clear();
            this.messageService.add({
              key: 'toast2',
              severity: 'error',
              summary: 'Error',
              detail: 'El documento de identidad no se encuentra registrado en SUNAT, por favor verifique.'
            });
          }
        });
      } else if (values['tipodocumento'] === '002') {
        this.proformaService.consultaDNI({ dni: values['numerodocumento'], token: null }).subscribe({
          next: (response) => {
            // Validar si la respuesta y los datos son válidos antes de continuar
            if (response.datos.status === 200) {
              this.messageService.clear();
              this.messageService.add({
                key: 'toast1',
                severity: 'success',
                summary: 'RENIEC',
                detail: 'El documento de identidad se encuentra registrado en RENIEC.'
              });
              // Llenar los campos de apellido y nombre
              const dniData = response.datos.result[0];
              // console.log("data dni ", dniData)
              // Separar nombres y apellidos de dniData.nombre_completo
              const nombresCompletos = dniData.nombre_completo ? dniData.nombre_completo.split(' ') : [];
              const apellidoPaterno = nombresCompletos.length > 0 ? nombresCompletos[0] : '';
              const apellidoMaterno = nombresCompletos.length > 1 ? nombresCompletos[1] : '';
              const nombres = nombresCompletos.length > 2 ? nombresCompletos.slice(2).join(' ') : '';
              this.groupPoppupDG.get('apellidopaterno')?.setValue(apellidoPaterno);
              this.groupPoppupDG.get('apellidomaterno')?.setValue(apellidoMaterno);
              this.groupPoppupDG.get('nombres')?.setValue(nombres);
              // this.groupPoppupDG.get('sexo')?.setValue(dniData.sexo || '');
              // this.groupPoppupDG.get('fechanacimiento')?.setValue(dniData.fecha_nacimiento ? new Date(dniData.fecha_nacimiento) : null);
            }
          },
          error: (err) => {
            if (err.error.datos.status === 404) {
              this.messageService.clear();
              this.messageService.add({
                key: 'toast2',
                severity: 'error',
                summary: 'Error',
                detail: 'El documento de identidad no se encuentra registrado en RENIEC, por favor verifique.'
              });
            }
          }
        });
      }
    }))

  }

  // informacionSunat(modo: string) {
  //   if (modo === "enable") {
  //     this.groupPoppupD.get('estadoSunat').enable();
  //     this.groupPoppupD.get('razonsocial').enable();
  //     this.groupPoppupD.get('direccion').enable();
  //     this.groupPoppupD.get('departamento').enable();
  //     this.groupPoppupD.get('provincia').enable();
  //     this.groupPoppupD.get('distrito').enable();
  //   } else {
  //     this.groupPoppupD.get('estadoSunat').disable();
  //     this.groupPoppupD.get('razonsocial').disable();
  //     this.groupPoppupD.get('direccion').disable();
  //     this.groupPoppupD.get('departamento').disable();
  //     this.groupPoppupD.get('provincia').disable();
  //     this.groupPoppupD.get('distrito').disable();
  //   }
  // }


  async onPaisSeleccionadoAsync(valor: string, seccion: string) {
    if (!valor) {
      if (seccion === 'fiscal') {
        this.listDepartamento = [];
        this.listProvincia = [];
        this.listDistrito = [];
      } else { // seccion === 'comercial'
        this.listDepartamentoComercial = [];
        this.listProvinciaComercial = [];
        this.listDistritoComercial = [];
      }
      return;
    }
    const request: ListarUbigeosRequest = {
      pvchUBIG_Codigo: null,
      pchrTIPO_CodPais: Number(valor),
      pchrTIPO_TabPais: 'PAI'
    };
    try {
      const response = await this.mantcomercial.ListarUbigeos(request).toPromise();
      const departamentos = response.datos.result.filter(item => item.ubiG_CodPadre === null);
      if (seccion === 'fiscal') {
        this.listDepartamento = departamentos;
      } else {
        this.listDepartamentoComercial = departamentos;
      }
    } catch (err) {
      if (seccion === 'fiscal') {
        this.listDepartamento = [];
        this.listProvincia = [];
        this.listDistrito = [];
      } else {
        this.listDepartamentoComercial = [];
        this.listProvinciaComercial = [];
        this.listDistritoComercial = [];
      }
      console.error(`Error al cargar departamentos para ${seccion}`, err);
    }
  }

  async onDepartamentoSeleccionadoAsync(valor: string, seccion: string) {
    if (!valor) {
      if (seccion === 'fiscal') {
        this.listProvincia = [];
        this.listDistrito = [];
      } else {
        this.listProvinciaComercial = [];
        this.listDistritoComercial = [];
      }
      return;
    }
    const request: ListarUbigeosRequest = {
      pvchUBIG_Codigo: null,
      pchrTIPO_CodPais: (seccion === 'fiscal') ? this.groupPoppupDG.get('pais').value : this.groupPoppupDG.get('paisComercial').value,
      pchrTIPO_TabPais: 'PAI'
    };
    try {
      const response = await this.mantcomercial.ListarUbigeos(request).toPromise();
      const provincias = response.datos.result.filter(item => item.ubiG_CodPadre === valor);
      if (seccion === 'fiscal') {
        this.listProvincia = provincias;
      } else {
        this.listProvinciaComercial = provincias;
      }
    } catch (err) {
      if (seccion === 'fiscal') {
        this.listProvincia = [];
        this.listDistrito = [];
      } else {
        this.listProvinciaComercial = [];
        this.listDistritoComercial = [];
      }
      console.error(`Error al cargar provincias para ${seccion}`, err);
    }
  }

  async onprovinciaSeleccionadaAsync(valor: string, seccion: string) {
    if (!valor) {
      if (seccion === 'fiscal') {
        this.listDistrito = [];
      } else {
        this.listDistritoComercial = [];
      }
      return;
    }
    const request: ListarUbigeosRequest = {
      pvchUBIG_Codigo: null,
      pchrTIPO_CodPais: (seccion === 'fiscal') ? this.groupPoppupDG.get('pais').value : this.groupPoppupDG.get('paisComercial').value,
      pchrTIPO_TabPais: 'PAI'
    };
    try {
      const response = await this.mantcomercial.ListarUbigeos(request).toPromise();
      const distritos = response.datos.result.filter(item => item.ubiG_CodPadre === valor);
      if (seccion === 'fiscal') {
        this.listDistrito = distritos;
      } else {
        this.listDistritoComercial = distritos;
      }
    } catch (err) {
      if (seccion === 'fiscal') {
        this.listDistrito = [];
      } else {
        this.listDistritoComercial = [];
      }
      console.error(`Error al cargar distritos para ${seccion}`, err);
    }
  }

  onPaisSeleccionado(event: any, seccion: string, tipo: string) {
    let valor;
    if (tipo === 'EVE') {
      valor = event.value;
    } else if (tipo === 'INI') {
      valor = event;
    }

    if (valor != null) {
      const request: ListarUbigeosRequest = <ListarUbigeosRequest>{};
      request.pvchUBIG_Codigo = null;
      request.pchrTIPO_CodPais = valor;
      request.pchrTIPO_TabPais = 'PAI';

      this.mantcomercial.ListarUbigeos(request).subscribe(response => {
        const departamento = response.datos.result.filter(item => item.ubiG_CodPadre === null);
        if (seccion === 'fiscal') {
          this.listDepartamento = departamento;
          this.groupPoppupDG.get('departamento')?.setValue(null); // Limpia los campos dependientes
          this.groupPoppupDG.get('provincia')?.setValue(null);
          this.groupPoppupDG.get('distrito')?.setValue(null);
        } else if (seccion === 'comercial') {
          this.listDepartamentoComercial = departamento;
          this.groupPoppupDG.get('departamentoComercial')?.setValue(null);
          this.groupPoppupDG.get('provinciaComercial')?.setValue(null);
          this.groupPoppupDG.get('distritoComercial')?.setValue(null);
        }
      }, err => {
        if (seccion === 'fiscal') {
          this.listDepartamento = [];
          this.listProvincia = [];
          this.listDistrito = [];
        } else if (seccion === 'comercial') {
          this.listDepartamentoComercial = [];
          this.listProvinciaComercial = [];
          this.listDistritoComercial = [];
        }
      });
    } else {
      // Si el valor es nulo, limpiar las listas correspondientes
      if (seccion === 'fiscal') {
        this.listDepartamento = [];
        this.listProvincia = [];
        this.listDistrito = [];
      } else if (seccion === 'comercial') {
        this.listDepartamentoComercial = [];
        this.listProvinciaComercial = [];
        this.listDistritoComercial = [];
      }
    }
  }

  onDepartamentoSeleccionado(event: any, seccion: string, tipo: string) {
    let valor;
    if (tipo === 'EVE') {
      valor = event.value;
    } else if (tipo === 'INI') {
      valor = event;
    }

    if (valor != null) {
      const departamentoSeleccionado = valor;
      const request: ListarUbigeosRequest = <ListarUbigeosRequest>{};
      request.pvchUBIG_Codigo = null;
      // Obtiene el país de su respectiva sección
      request.pchrTIPO_CodPais = (seccion === 'fiscal') ? this.groupPoppupDG.get('pais').value : this.groupPoppupDG.get('paisComercial').value;
      request.pchrTIPO_TabPais = 'PAI';

      this.mantcomercial.ListarUbigeos(request).subscribe(response => {
        const provincias = response.datos.result.filter(item => item.ubiG_CodPadre === departamentoSeleccionado);
        if (seccion === 'fiscal') {
          this.listProvincia = provincias;
          this.groupPoppupDG.get('provincia')?.setValue(null);
          this.groupPoppupDG.get('distrito')?.setValue(null);
        } else if (seccion === 'comercial') {
          this.listProvinciaComercial = provincias;
          this.groupPoppupDG.get('provinciaComercial')?.setValue(null);
          this.groupPoppupDG.get('distritoComercial')?.setValue(null);
        }
      }, err => {
        if (seccion === 'fiscal') {
          this.listProvincia = [];
          this.listDistrito = [];
        } else if (seccion === 'comercial') {
          this.listProvinciaComercial = [];
          this.listDistritoComercial = [];
        }
      });
    } else {
      if (seccion === 'fiscal') {
        this.listProvincia = [];
        this.listDistrito = [];
      } else if (seccion === 'comercial') {
        this.listProvinciaComercial = [];
        this.listDistritoComercial = [];
      }
    }
  }

  onprovinciaSeleccionada(event: any, seccion: string, tipo: string) {
    let valor;
    if (tipo === 'EVE') {
      valor = event.value;
    } else if (tipo === 'INI') {
      valor = event;
    }

    if (valor != null) {
      const provinciaseleccionada = valor;
      const request: ListarUbigeosRequest = <ListarUbigeosRequest>{};
      request.pvchUBIG_Codigo = null;
      // Obtiene el país de su respectiva sección
      request.pchrTIPO_CodPais = (seccion === 'fiscal') ? this.groupPoppupDG.get('pais').value : this.groupPoppupDG.get('paisComercial').value;
      request.pchrTIPO_TabPais = 'PAI';

      this.mantcomercial.ListarUbigeos(request).subscribe(response => {
        const distritos = response.datos.result.filter(item => item.ubiG_CodPadre === provinciaseleccionada);
        if (seccion === 'fiscal') {
          this.listDistrito = distritos;
          this.groupPoppupDG.get('distrito')?.setValue(null);
        } else if (seccion === 'comercial') {
          this.listDistritoComercial = distritos;
          this.groupPoppupDG.get('distritoComercial')?.setValue(null);
        }
      }, err => {
        if (seccion === 'fiscal') {
          this.listDistrito = [];
        } else if (seccion === 'comercial') {
          this.listDistritoComercial = [];
        }
      });
    } else {
      if (seccion === 'fiscal') {
        this.listDistrito = [];
      } else if (seccion === 'comercial') {
        this.listDistritoComercial = [];
      }
    }
  }
  entC_Codigo: number | null;
  modo: string = 'CREAR';
  tabControl

  // Este método público es el que el padre llamará
  open(data?: any) {
    this.activeIndex = 0;
    this.procesoAsignacion = false
    this.opcion3 = false

    if (data) {
      this.entC_Codigo = data.entC_Codigo;
      this.modo = 'EDITAR';
      this.procesoAgrupacion = false;
      this.cargarDatosEdicion("", data);

      //! La búsqueda de datos comerciales solo se haría para los clientes que son tipo '004' (Clientes Comerciales)
      //! Ya que cuando se actualiza de comercial a otro tipo, se eliminan los datos comerciales (considerar)
      if (data.tipoCliente === '004') {
        this.obtenerDatosComerciales(data).then(() => {
          // 👇 ejecuta sincronización después de poblar los datos
          this.syncReplicateFromLogistics();
          this.setupPrincipalReplication();
        });
      } else {
        //
        this.groupDatosComerciales.patchValue({
          contactoPrincipal: { checkOpcional: true },
          billingContact: { checkOpcional: true },
          checkOpcionalILC: true,
          checkOpcionalOC: true,
          checkOpcionalCustomerProfile: true
        }, { emitEvent: true }); // Usar emitEvent para que se disparen las suscripciones
      }
    } else {
      this.entC_Codigo = null;
      this.modo = 'CREAR';
      // Si no hay datos, es modo creación
      this.cargarDatosCreacion();

    }
  }

  async obtenerDatosComerciales(data: any) {
    const response = await lastValueFrom(
      this.proformaService.GetComercialData({ ENTC_Codigo: data.entC_Codigo })
    );

    if (response.datos.status === 200) {
      //colocar la data response.datos.result en el formgroup de datos comerciales
      const data = response.datos.result;
      //("datos comerciales", data)

      // --- LÓGICA CLAVE: Actualizar los checkboxes basados en los datos recibidos ---
      const isPrincipalOptional = data.contactoPrincipal === null;
      const isBillingOptional = data.billingContact === null;
      const isLogisticsOptional =
        data.internationalLogisticsContacts === null ||
        (Array.isArray(data.internationalLogisticsContacts) &&
          data.internationalLogisticsContacts.length === 0);
      const isOperationsOptional =
        data.operationsContacts === null ||
        (Array.isArray(data.operationsContacts) &&
          data.operationsContacts.length === 0);

      // Actualizar los valores de los checkboxes en el formulario
      this.groupDatosComerciales.patchValue({
        contactoPrincipal: { checkOpcional: isPrincipalOptional },
        billingContact: { checkOpcional: isBillingOptional },
        checkOpcionalILC: isLogisticsOptional,
        checkOpcionalOC: isOperationsOptional
      }, { emitEvent: true }); // Usar emitEvent para que se disparen las suscripciones

      // Limpiar los FormArrays antes de llenarlos
      const logisticsArray = this.groupDatosComerciales.get('internationalLogisticsContacts') as FormArray;
      const operationsArray = this.groupDatosComerciales.get('operationsContacts') as FormArray;
      logisticsArray.clear();
      operationsArray.clear();

      const entC_NombreContacto = this.groupPoppupDG.get('contactonombre').value?.trim()
      const entC_ApellidoContacto = this.groupPoppupDG.get('contactoapellidos').value?.trim()
      const entC_EMail = this.groupPoppupDG.get('correo').value?.trim() || this.row?.entC_EMail;
      const entC_Telef2 = this.groupPoppupDG.get('telefono_movil').value?.trim()//movil
      const fechaNacimiento = this.groupPoppupDG.get('fechanacimientog').value

      const entC_EmailReceptorFE = this.groupPoppupDG.get('correo_facturacion').value?.trim() || '';//Facturacion
      const entC_Telef1 = this.groupPoppupDG.get('telefono_fijo').value?.trim()//fijo
      const entC_CorreoContactoExpo = this.groupPoppupDG.get('correoexport').value?.trim() || this.row?.entC_CorreoContactoExpo //Exportacion
      const entC_EMail2 = this.groupPoppupDG.get('correo_otros_traficos').value?.trim() || this.row?.entC_EMail2; //otros traficos

      // Llenar los campos de un solo contacto solo si no son nulos
      if (!isPrincipalOptional) {
        const principalContact = data.contactoPrincipal;
        principalContact.cumpleanos = principalContact.cumpleanos ? new Date(principalContact.cumpleanos) : null;
        this.groupDatosComerciales.get('contactoPrincipal')?.patchValue(principalContact);
      } else {
        if (entC_NombreContacto) {
          this.groupDatosComerciales
            .get("contactoPrincipal.nombre")
            ?.setValue(entC_NombreContacto);
        }
        if (entC_ApellidoContacto) {
          this.groupDatosComerciales
            .get("contactoPrincipal.apellido")
            ?.setValue(entC_ApellidoContacto);
        }

        // if (entC_EMail) {
        //   this.groupDatosComerciales
        //     .get("contactoPrincipal.email")
        //     ?.setValue(entC_EMail);
        // }
        if (entC_Telef2) {
          this.groupDatosComerciales
            .get("contactoPrincipal.telefono")
            ?.setValue(entC_Telef2);
        }
        if (fechaNacimiento) {
          this.groupDatosComerciales
            .get("contactoPrincipal.cumpleanos")
            ?.setValue(fechaNacimiento);
        }
      }

      if (!isBillingOptional) {
        const billingContact = data.billingContact;
        billingContact.birthday = billingContact.birthday ? new Date(billingContact.birthday) : null;
        this.groupDatosComerciales.get('billingContact')?.patchValue(billingContact);
      } else {
        if (entC_EmailReceptorFE) {
          this.groupDatosComerciales
            .get("billingContact.email")
            ?.setValue(entC_EmailReceptorFE);
        }
        if (entC_Telef1) {
          this.groupDatosComerciales
            .get("billingContact.phone")
            ?.setValue(entC_Telef1);
        }
      }

      // Llenar los FormArrays solo si tienen datos
      if (!isLogisticsOptional) {
        data.internationalLogisticsContacts.forEach(contact => {
          logisticsArray.push(this.createLogisticsContactGroup({
            ...contact,
            id: contact.id.toString(),
            birthday: contact.birthday ? new Date(contact.birthday) : null
          }));
        });
      } else {
        // --- 1️⃣ Mandato (correo principal) ---
        if (entC_EMail?.includes(';')) {
          this.handleMultipleEmails(
            entC_EMail,
            logisticsArray,
            this.addNewLogisticsContact.bind(this),
            this.createLogisticsContactGroup.bind(this),
            'mandato'
          );
        } else if (entC_EMail) {
          this.addNewLogisticsContact();
          const firstMandato = logisticsArray.at(0) as FormGroup;
          firstMandato.get('email')?.setValue(entC_EMail);
          firstMandato.get('emailTypes.mandato')?.setValue(true);
        }
        // --- 2️⃣ Exportación ---
        if (entC_CorreoContactoExpo?.includes(';')) {
          this.handleMultipleEmails(
            entC_CorreoContactoExpo,
            logisticsArray,
            this.addNewLogisticsContact.bind(this),
            this.createLogisticsContactGroup.bind(this),
            'exportacion'
          );
        } else if (entC_CorreoContactoExpo) {
          this.addNewLogisticsContact();
          const firstLogistics = logisticsArray.at(logisticsArray.length - 1) as FormGroup;
          firstLogistics.get('email')?.setValue(entC_CorreoContactoExpo);
          firstLogistics.get('emailTypes.exportacion')?.setValue(true);
        }
      }

      if (!isOperationsOptional) {
        data.operationsContacts.forEach(contact => {
          operationsArray.push(this.createOperationsContactGroup({
            ...contact,
            id: contact.id.toString(),
            birthday: contact.birthday ? new Date(contact.birthday) : null
          }));
        });
      } else {
        //Manejar para multiples correos que vienen como "correo1@gmail.com;correo2@hotmail.com;correo3@outlook.com"
        if (entC_EMail2?.includes(';')) {
          // 👉 Manejo de múltiples correos otros tráficos
          this.handleMultipleEmails(
            entC_EMail2,
            operationsArray,
            this.addNewOperationsContact.bind(this),
            this.createOperationsContactGroup.bind(this),
            'otrosTraficos'
          );
        } else {
          // 👉 Solo un correo
          this.addNewOperationsContact();
          const firstOperations = operationsArray.at(0) as FormGroup;
          if (entC_EMail2) {
            firstOperations.get('email')?.setValue(entC_EMail2);
            firstOperations.get('emailTypes.otrosTraficos')?.setValue(true);
          }
        }
      }
      // ✅ Sincronización inversa (cuando el usuario edita contactos → actualiza input)
      // this.subscribeArrayToInputSync(logisticsArray, 'correoexport');
      // this.subscribeArrayToInputSync(operationsArray, 'correo_otros_traficos');
      this.subscribeArrayToInputSync(logisticsArray, operationsArray);
      this.setupEmailSync(); // 👈 Reasigna suscripciones al finalizar
      // console.log("groupDatosComerciales", this.groupDatosComerciales.getRawValue())
      //  console.log("(value) onSubmitComercial", this.groupDatosComerciales.value)
      this.syncReplicateFromLogistics()
    }
    await this.obtenerArchivos()
  }

  // private subscribeArrayToInputSync(
  //   formArray: FormArray,
  //   inputName: 'correoexport' | 'correo_otros_traficos'
  // ) {
  //   formArray.valueChanges.subscribe((value: any[]) => {
  //     // Filtrar según el tipo de email asociado
  //     const filteredEmails = value
  //       .filter(v => {
  //         const types = v?.emailTypes || {};
  //         if (inputName === 'correoexport') {
  //           return types.exportacion === true;
  //         } else if (inputName === 'correo_otros_traficos') {
  //           return types.otrosTraficos === true;
  //         }
  //         return false;
  //       })
  //       .map(v => v?.email?.trim())
  //       .filter(email => !!email);

  //     const concatenated = filteredEmails.join(';');

  //     const inputCtrl = this.groupPoppupDG.get(inputName);
  //     if (inputCtrl && inputCtrl.value !== concatenated) {
  //       inputCtrl.setValue(concatenated, { emitEvent: false });
  //     }
  //   });
  // }

  private subscribeArrayToInputSync(
    logisticsArray: FormArray,
    operationsArray: FormArray,
    initial: boolean = true
  ) {
    const updateEmails = () => {
      let allContacts = [];
      if (initial) {
        allContacts = [
          ...(logisticsArray?.value || []),
          ...(operationsArray?.value || []),
        ];
      } else {
        allContacts = [
          ...(logisticsArray?.getRawValue() || []),
          ...(operationsArray?.getRawValue() || []),
        ];
      }

      // --- Correos por tipo ---
      const exportEmails = allContacts
        .filter(v => v?.emailTypes?.exportacion)
        .map(v => v?.email?.trim())
        .filter(Boolean);

      const otrosTraficosEmails = allContacts
        .filter(v => v?.emailTypes?.otrosTraficos)
        .map(v => v?.email?.trim())
        .filter(Boolean);

      const mandatoEmails = allContacts
        .filter(v => v?.emailTypes?.mandato)
        .map(v => v?.email?.trim())
        .filter(Boolean);

      // --- Concatenar ---
      const exportConcat = exportEmails.join(';');
      const otrosTraficosConcat = otrosTraficosEmails.join(';');
      const mandatoConcat = mandatoEmails.join(';');

      // --- Asignar a los controles ---
      const exportCtrl = this.groupPoppupDG.get('correoexport');
      const otrosCtrl = this.groupPoppupDG.get('correo_otros_traficos');
      const mandatoCtrl = this.groupPoppupDG.get('correo');

      if (exportCtrl && exportCtrl.value !== exportConcat)
        exportCtrl.setValue(exportConcat, { emitEvent: false });

      if (otrosCtrl && otrosCtrl.value !== otrosTraficosConcat)
        otrosCtrl.setValue(otrosTraficosConcat, { emitEvent: false });

      if (mandatoCtrl && mandatoCtrl.value !== mandatoConcat)
        mandatoCtrl.setValue(mandatoConcat, { emitEvent: false });
    };

    logisticsArray.valueChanges.subscribe(() => updateEmails());
    operationsArray.valueChanges.subscribe(() => updateEmails());
    updateEmails();
  }

  cargarDatosCreacion() {
    this.estadoEditar = false;
    this.visible = true
    this.visiblebtn = true
    this.entcCod = 0
    this.groupDatosComerciales.reset();
    this.internationalLogisticsContactsArray.clear();
    this.operationsContactsArray.clear();
    this.addNewLogisticsContact()
    this.addNewOperationsContact()
    this.archivosSeleccionado = [];
    this.uploadedFilesComercial = [];
    this.group.reset();
    this.payloadEjecutivoCrear = {}
    this.payloadEjecutivoActualizar = {
      entc_codigo: 0,
      grupo_id: 0
    }
    this.procesoAgrupacion = true
    this.listadoCodigoClientesEjecutivo = []
    this.modoAgrupacion = ""
    this.clienteSeleccionado = null
    this.groupPoppupDG.reset()
    this.groupPoppupD.reset()
    this.groupPoppupB.reset()
    this.groupPoppupE.reset()
    this.setupEmailSync(); // 👈 También aquí
    this.groupPoppupDG.get('tipopersona').setValue("J")
    this.dataTableCuentasBancarias = []
    this.dataTableServicios = []
    this.dataTableLimiteCredito = []
    this.dataTableAuditoria = []
    this.dataTableDireccion = []
    this.dataTableArchivos = []
    this.uploadedFiles = []
    this.dataTableRelacionados = [];
    this.dataTableServicios = []
    this.dataTableAuditoriaServicios = []
    this.listaDatosEntidad = [];
    this.groupPoppupDG.get('activo').setValue(true)
    this.groupPoppupDG.get('vip').setValue(false);
    // this.groupPoppupDG.get('diascreditos').setValue(0);
    // this.groupPoppupDG.get('nodomiciliado').setValue(false);
    // this.groupPoppupDG.get('diascreditos').disabled();
    // this.groupPoppupDG.get('nodomiciliado').disabled();
    // this.groupPoppupDG.get('fechacredito').disabled();
    // this.groupPoppupDG.get('to_order').disabled();

    this.groupPoppupDG.get('prospecto').setValue(false);
    this.groupPoppupDG.get('serviciologistico').setValue(false);
    this.groupPoppupD.get('esMandato').setValue(false);
    this.groupPoppupD.get('esOtrosTraficos').setValue(false);
    this.groupPoppupD.get('esSli').setValue(false);
    this.groupPoppupD.get('esExportaciones').setValue(false);
    this.groupPoppupD.get('esMandato').disable();
    this.groupPoppupD.get('esOtrosTraficos').disable();
    this.groupPoppupD.get('esSli').disable();
    this.groupPoppupD.get('esExportaciones').disable();
    this.cargarInputBloqueo(false);
    const RequestLC: ListarLimiteCreditoRequest = <ListarLimiteCreditoRequest>{}
    RequestLC.pintENTC_Codigo = 0
    RequestLC.psinTIPE_Codigo = this.codigoEntidad;
    this.dataTableLimiteCredito = []
    this.mantcomercial.BuscarLimiteCliente(RequestLC).subscribe(response => {
      if (response.datos.status === 200) {
        this.dataTableLimiteCredito = response.datos.result;
        this.ListaTipoLimiteCredito = this.dataTableLimiteCredito.map(r => ({ label: r.enlI_TiposDescripcion, value: r.enlI_Tipos }))
        this.metadataTableLimiteCredito[0].dropdown = this.ListaTipoLimiteCredito;
      }
    })
  }

  listadoEdit(entcCodigo) {
    const RequestCB: ListarCuentasBancariasRequest = <ListarCuentasBancariasRequest>{}
    RequestCB.pintENTC_Codigo = entcCodigo
    this.dataTableCuentasBancarias = []
    this.mantcomercial.ListarCuentasBancarias(RequestCB).subscribe(response => {
      if (response.datos.status === 200) { this.dataTableCuentasBancarias = response.datos.result }
    })
    const RequestLC: ListarLimiteCreditoRequest = <ListarLimiteCreditoRequest>{}
    RequestLC.pintENTC_Codigo = entcCodigo
    RequestLC.psinTIPE_Codigo = this.codigoEntidad;
    this.dataTableLimiteCredito = []
    this.mantcomercial.BuscarLimiteCliente(RequestLC).subscribe(response => {
      if (response.datos.status === 200) {
        this.dataTableLimiteCredito = response.datos.result.map(r => {
          return {
            ...r,
            enlI_FecInicio: r.enlI_FecInicio != null ? new Date(r.enlI_FecInicio) : null,
            enlI_FecVencimiento: r.enlI_FecVencimiento != null ? new Date(r.enlI_FecVencimiento) : null
          }
        })
        this.ListaTipoLimiteCredito = this.dataTableLimiteCredito.map(r => ({ label: r.enlI_TiposDescripcion, value: r.enlI_Tipos }))
        this.metadataTableLimiteCredito[0].dropdown = this.ListaTipoLimiteCredito;
      }
    })
    const RequestAU: ListarAuditoriaRequest = <ListarAuditoriaRequest>{}
    RequestAU.pintENTC_Codigo = entcCodigo
    this.dataTableAuditoria = []
    this.mantcomercial.ListarAuditoria(RequestAU).subscribe(response => {
      if (response.datos.status === 200) { this.dataTableAuditoria = response.datos.result }
    })
    const RequestAR: ListarArchivoEntidadRequest = <ListarArchivoEntidadRequest>{}
    RequestAR.ENAR_Codigo = 0
    RequestAR.ENTC_Codigo = entcCodigo
    this.uploadedFiles = []
    this.mantcomercial.ListarArchivosEntidad(RequestAR).subscribe(response => {
      if (response.datos.status === 200) {
        this.dataTableArchivos = response.datos.result
        this.uploadedFiles = this.dataTableArchivos.map(r => ({
          codigo: r.enaR_Codigo, tipotran: 'U', image: null, usuario: r.audI_UsrCrea, fecha: r.audI_FecCrea, nombre: r.enaR_NombreArchivo, url: r.enaR_Archivo
        }))
      }
    })
    //!Funcion para obtener datos generales comerciales
    this.proformaService.ObtenerDatosComerciales({ entc_codigo: this.entC_Codigo }).subscribe({
      next: async (response) => {
        if (response.datos.status === 200) {
          const { almacen, direccionComercial, paisComercial, departamentoComercial, provinciaComercial, distritoComercial, segmento_nuevo, detalles_segmento } = response.datos.result;
          this.groupPoppupDG.get('almacen')?.setValue(almacen);
          this.groupPoppupDG.get('direccionComercial')?.setValue(direccionComercial);
          this.groupPoppupDG.get('segmentoNuevo').setValue(segmento_nuevo);
          this.groupPoppupDG.get('detallesSegmento').setValue(detalles_segmento);
          // console.log(this.groupPoppupDG.get('detallesSegmento').value)
          if (paisComercial) {
            this.groupPoppupDG.get('paisComercial')?.setValue(paisComercial);

            // 1. Cargar y asignar el Departamento
            if (departamentoComercial) {
              await this.onPaisSeleccionadoAsync(paisComercial, 'comercial');
              this.groupPoppupDG.get('departamentoComercial')?.setValue(departamentoComercial);

              // 2. Cargar y asignar la Provincia
              if (provinciaComercial) {
                await this.onDepartamentoSeleccionadoAsync(departamentoComercial, 'comercial');
                this.groupPoppupDG.get('provinciaComercial')?.setValue(provinciaComercial);

                // 3. Cargar y asignar el Distrito
                if (distritoComercial) {
                  await this.onprovinciaSeleccionadaAsync(provinciaComercial, 'comercial');
                  this.groupPoppupDG.get('distritoComercial')?.setValue(distritoComercial);
                }
              }
            }
          }
        }

      },
      error: (err) => {
        if (err.error.datos.status !== 404) {
          const mensaje = err.error?.meta?.mensaje || 'Ocurrió un error al obtener los datos generales.';
          // this.messageService.add({ key: 'toast1', severity: 'error', summary: 'Error', detail: mensaje });
          console.info('Ocurrió un error al obtener los datos generales: ', err)
        }
      }
    });

    const RequestDO: ConsultarDireccionEntidadRequest = <ConsultarDireccionEntidadRequest>{}
    RequestDO.pintENTC_Codigo = entcCodigo
    this.dataTableDireccion = []
    this.mantcomercial.ConsultarDireccionEntidad(RequestDO).subscribe(async (response) => {
      if (response.datos.status === 200) {
        this.dataTableDireccion = response.datos.result
        // console.log("dataTableDireccion", this.dataTableDireccion)
        for (const row of this.dataTableDireccion) {
          if (row && row.dirE_Codigo === 1) {
            this.groupPoppupDG.get('direccion')?.setValue(row.dirE_Direccion);

            // 1. Asignar el país
            const pais = this.listPais.find(r => r.codigo.toUpperCase() === row.tipO_CodPais.toUpperCase())?.codigo;
            this.groupPoppupDG.get('pais')?.setValue(pais);

            // 2. Cargar y asignar el Departamento
            const partes = row.ubiG_Codigo?.split(".");
            const departamentoCodigo = partes[0];
            const provinciaCodigo = `${partes[0]}.${partes[1]}`;
            const distritoCodigo = row.ubiG_Codigo;

            // Llama a la versión asíncrona de la función y espera que se complete
            await this.onPaisSeleccionadoAsync(pais, 'fiscal');

            const departamento = this.listDepartamento.find(r => r.ubiG_Codigo === departamentoCodigo)?.ubiG_Codigo;
            this.groupPoppupDG.get('departamento')?.setValue(departamento);

            // 3. Cargar y asignar la Provincia
            // Llama a la versión asíncrona de la función y espera que se complete
            await this.onDepartamentoSeleccionadoAsync(departamento, 'fiscal');

            const provincia = this.listProvincia.find(r => r.ubiG_Codigo === provinciaCodigo)?.ubiG_Codigo;
            this.groupPoppupDG.get('provincia')?.setValue(provincia);

            // 4. Cargar y asignar el Distrito
            // Llama a la versión asíncrona de la función y espera que se complete
            await this.onprovinciaSeleccionadaAsync(provincia, 'fiscal');

            const distrito = this.listDistrito.find(r => r.ubiG_Codigo === distritoCodigo)?.ubiG_Codigo;
            this.groupPoppupDG.get('distrito')?.setValue(distrito);
          }
        }
      }
    })

  }

  cargarInputBloqueo(event) {
    // console.log(event)
    if (event === true) {
      this.groupPoppupB.get('usuariobloqueo').setValue(this.nomUsuario)
      this.groupPoppupB.get('fechabloqueoo').setValue(new Date())
      this.groupPoppupB.get('usuariobloqueo').enable();
      this.groupPoppupB.get('fechabloqueoo').enable();
    } else {
      this.groupPoppupB.get('usuariobloqueo').setValue(null)
      this.groupPoppupB.get('fechabloqueoo').setValue(null)
      this.groupPoppupB.get('usuariobloqueo').disable();
      this.groupPoppupB.get('fechabloqueoo').disable();
    }
  }
  prueba: boolean = true
  correoface: string
  telfijo: string
  telmovil: string
  web: string
  row: ListarEntidades
  // nextsoft_entC_NombreContacto: string | null;
  // nextsoft_entC_ApellidoContacto: string | null;
  // nextsoft_entC_EMail: string | null;
  // nextsoft_entC_EmailReceptorFE: string | null;
  // nextsoft_entC_CorreoContactoExpo: string | null;
  // nextsoft_entC_EMail2: string | null;
  // nextsoft_entC_Tel1: string | null;
  // nextsoft_entC_Tel2: string | null;
  // nextsoft_fechaNacimientog: Date | null;

  cargarDatosEdicion(value, row: any) {
    this.listaDatosEntidad = row;
    this.estadoEditar = true;
    this.prueba = false
    this.visiblebtn = false
    this.visible = true
    this.dataTableCuentasBancarias = []
    this.dataTableLimiteCredito = []
    this.dataTableAuditoria = []
    this.dataTableDireccion = []
    this.dataTableArchivos = []
    this.uploadedFiles = []
    this.archivosSeleccionado = []
    this.dataTableServicios = []
    this.groupDatosComerciales.reset();
    this.internationalLogisticsContactsArray.clear();
    this.operationsContactsArray.clear();
    this.groupPoppupDG.reset()
    this.groupPoppupD.reset()
    this.groupPoppupB.reset()
    this.groupPoppupE.reset()
    this.groupPoppupDG.get('tipopersona').setValue("J")
    if (row) {
      //DATOS GENERALES
      this.entcCod = row.entC_Codigo
      this.row = row
      //  console.log("row", row)
      this.listadoEdit(row.entC_Codigo)
      if (row.tipoCliente) { this.groupPoppupDG.get('tipoCliente').setValue(row.tipoCliente) }
      if (row.entC_Codigo) { this.groupPoppupDG.get('codigo').setValue(row.entC_Codigo) }
      if (row.entC_Activo) { this.groupPoppupDG.get('activo').setValue(row.entC_Activo) }
      if (row.entC_Activo) { this.groupPoppupDG.get('activo').setValue(row.entC_Activo) }
      if (row.entC_TipEnt) { this.groupPoppupDG.get('tipopersona').setValue(row.entC_TipEnt) }
      if (row.tipO_CodTDI) {
        const td = this.ListaTodosTipoDoc.find(r => r.codigo.toUpperCase() === row.tipO_CodTDI.toUpperCase())?.codigo
        this.groupPoppupDG.get('tipodocumento').setValue(td)
      }
      if (row.entC_DocIden) { this.groupPoppupDG.get('numerodocumento').setValue(row.entC_DocIden) }
      if (row.entC_RazonSocial) { this.groupPoppupDG.get('razonsocial').setValue(row.entC_RazonSocial) }
      if (row.entC_NomComercial) { this.groupPoppupDG.get('razoncomercial').setValue(row.entC_NomComercial) }
      if (row.nombreGerente) { this.groupPoppupDG.get('nomgerente').setValue(row.nombreGerente) }
      if (row.fechaAniversario) { this.groupPoppupDG.get('fechaAniversariog').setValue(new Date(row.fechaAniversario)) }
      if (row.entC_ApePat) { this.groupPoppupDG.get('apellidopaterno').setValue(row.entC_ApePat) }
      if (row.entC_ApeMat) { this.groupPoppupDG.get('apellidomaterno').setValue(row.entC_ApeMat) }
      if (row.entC_Nombres) { this.groupPoppupDG.get('nombres').setValue(row.entC_Nombres) }
      if (row.entC_Sexo) { this.groupPoppupDG.get('sexo').setValue(row.entC_Sexo) }
      if (row.entC_Area) { this.groupPoppupDG.get('area').setValue(row.entC_Area) }
      if (row.entC_Cargo) { this.groupPoppupDG.get('cargo').setValue(row.entC_Cargo) }
      if (row.entC_FecNac) { this.groupPoppupDG.get('fechanacimiento').setValue(new Date(row.entC_FecNac)) }
      if (row.entC_FecIng) { this.groupPoppupDG.get('fechaingreso').setValue(new Date(row.entC_FecIng)) }
      //
      if (row.entC_NombreContacto?.trim()) { this.groupPoppupDG.get('contactonombre').setValue(row.entC_NombreContacto?.trim()) }
      if (row.entC_ApellidoContacto?.trim()) { this.groupPoppupDG.get('contactoapellidos').setValue(row.entC_ApellidoContacto?.trim()) }
      if (row.fechaNacimiento) { this.groupPoppupDG.get('fechanacimientog').setValue(new Date(row.fechaNacimiento)) }
      if (row.entC_EMail?.trim()) { this.groupPoppupDG.get('correo').setValue(row.entC_EMail?.trim()) }
      if (row.entC_EmailReceptorFE?.trim()) { this.groupPoppupDG.get('correo_facturacion').setValue(row.entC_EmailReceptorFE?.trim()) }//Facturacion
      if (row.entC_CorreoContactoExpo?.trim()) { this.groupPoppupDG.get('correoexport').setValue(row.entC_CorreoContactoExpo?.trim()) }//Exportacion

      if (row.entC_EmailReceptorFE?.trim()) { this.groupPoppupDG.get('correo_facturacion2').setValue(row.entC_EmailReceptorFE?.trim()) }//Facturacion
      if (row.entC_CorreoContactoExpo?.trim()) { this.groupPoppupDG.get('correoexport2').setValue(row.entC_CorreoContactoExpo?.trim()) }//Exportacion


      if (row.entC_EMail2?.trim()) { this.groupPoppupDG.get('correo_otros_traficos').setValue(row.entC_EMail2?.trim()) }//otros traficos
      if (row.entC_Telef1?.trim()) { this.groupPoppupDG.get('telefono_fijo').setValue(row.entC_Telef1?.trim()) } //fijo
      if (row.entC_Telef2?.trim()) { this.groupPoppupDG.get('telefono_movil').setValue(row.entC_Telef2?.trim()) }//movil

      if (row.entC_EMail?.trim()) { this.groupPoppupDG.get('correo2').setValue(row.entC_EMail?.trim()) }
      if (row.entC_EMail2?.trim()) { this.groupPoppupDG.get('correo_otros_traficos2').setValue(row.entC_EMail2?.trim()) }//otros traficos


      //
      if (row.entC_FechaCredito) { this.groupPoppupDG.get('fechacredito').setValue(new Date(row.entC_FechaCredito)) }
      if (row.entC_DiasCredito) { this.groupPoppupDG.get('diascreditos').setValue(row.entC_DiasCredito) }
      if (row.entC_Obser) { this.groupPoppupDG.get('observaciones').setValue(row.entC_Obser) }
      if (row.entC_Siglas) { this.groupPoppupDG.get('sigla').setValue(row.entC_Siglas) }
      if (row.entC_Domiciliado) { this.groupPoppupDG.get('nodomiciliado').setValue(row.entC_Domiciliado) }
      if (row.entC_VIP) { this.groupPoppupDG.get('vip').setValue(row.entC_VIP) }
      if (row.entC_ServicioLogistico) { this.groupPoppupDG.get('serviciologistico').setValue(row.entC_ServicioLogistico) }
      if (row.entC_Prospecto) { this.groupPoppupDG.get('prospecto').setValue(row.entC_Prospecto) }
      if (row.tipO_CodSEG) {
        const ts = this.ListarTodosSegmento.find(r => r.codigo.toUpperCase() === row.tipO_CodSEG.toUpperCase())?.codigo
        this.groupPoppupDG.get('segmento').setValue(ts)
      }


      if (row.entC_Web) { this.groupPoppupDG.get('web').setValue(row.entC_Web) }
      if (row.entC_ToOrder) { this.groupPoppupDG.get('to_order').setValue(row.entC_ToOrder) }

      //SERVICIOS
      this.mantcomercial.BuscarEntidadServicioDBO({ pintENTC_Codigo: this.entcCod }).subscribe({
        next: (response) => {
          if (response.datos.status === 200) {
            this.dataTableServicios = response.datos.result;
          }
        },
        error: (err) => {
          this.dataTableServicios = [];
          if (err?.datos?.status === 404) {
            this.messageService.add({ key: 'toast2', severity: 'info', summary: 'Info', detail: 'No se encontraron servicios asociados a la entidad.' });
          } else {
            this.messageService.add({ key: 'toast2', severity: 'error', summary: 'Error', detail: err.error?.meta?.mensaje || 'Ocurrió un error al cargar los servicios.' });
          }
        }
      });

      // this.dataTableServicios = row['listadoserviciosentidad'];
      // this.dataTableAuditoriaServicios = row['listadoauditoriaserviciosentidad']; //lo trae desde el row (osea desde la búsqueda inicial)

      this.mantcomercial.getAuditoriaServiciosByEntidad({ entidad: this.entcCod || 0 }).subscribe({
        next: (response) => {
          if (response.datos.status === 200) {
            this.dataTableAuditoriaServicios = response.datos.result;
          }
        },
        error: (err) => {
          this.dataTableAuditoriaServicios = [];
          // this.messageService.add({ key: 'toast1', severity: 'error', summary: 'Error', detail: err.error?.meta?.mensaje || 'Ocurrió un error al cargar los relacionados.' });
        }
      });

      this.mantcomercial.BuscarRelacionadosPorEntidadPadre({ pintENTC_CodPadre: this.entcCod || 0 }).subscribe({
        next: (response) => {
          if (response.datos.status === 200) {
            this.dataTableRelacionados = response.datos.result;
          }
        },
        error: (err) => {
          this.dataTableRelacionados = [];
          this.messageService.add({ key: 'toast1', severity: 'error', summary: 'Error', detail: err.error?.meta?.mensaje || 'Ocurrió un error al cargar los relacionados.' });
        }
      });
      // this.dataTableRelacionados = row['listadoasociados'];
      // RELACIONADOS
      if (row.tipE_Codigo) { this.groupPoppupE.get('tipoentidad').setValue(row.tipE_Codigo.toString()) }
      if (row.entC_DocIden) { this.groupPoppupE.get('numdocumento').setValue(row.entC_DocIden) }
      if (row.entC_RazonSocial) { this.groupPoppupE.get('razonsocial').setValue(row.entC_RazonSocial) }

      //OTROS DATOS
      if (row.entC_EmailFinanzas) { this.groupPoppupD.get('correofinanzas').setValue(row.entC_EmailFinanzas) }
      if (row.entC_InterbancarioSol) { this.groupPoppupD.get('ctaintersoles').setValue(row.entC_InterbancarioSol) }
      if (row.entC_InterbancarioDol) { this.groupPoppupD.get('ctainterdolares').setValue(row.entC_InterbancarioDol) }
      if (row.entC_CuentaDetraccion) { this.groupPoppupD.get('ctadetracciones').setValue(row.entC_CuentaDetraccion) }
      if (row.entC_ProvAsumeDetraccion) { this.groupPoppupD.get('asumedetraccion').setValue(row.entC_ProvAsumeDetraccion) }

      if (row.entC_Mandato) { this.groupPoppupD.get('esMandato').setValue(row.entC_Mandato) }
      if (row.entC_OtrosTraficos) { this.groupPoppupD.get('esOtrosTraficos').setValue(row.entC_OtrosTraficos) }
      if (row.entC_SLI) { this.groupPoppupD.get('esSli').setValue(row.entC_SLI) }
      if (row.entC_Exportacion) { this.groupPoppupD.get('esExportaciones').setValue(row.entC_Exportacion) }
      this.groupPoppupD.get('esMandato').disable();
      this.groupPoppupD.get('esOtrosTraficos').disable();
      this.groupPoppupD.get('esSli').disable();
      this.groupPoppupD.get('esExportaciones').disable();

      //BLOQUEO
      if (row.entC_BloqueoFinanzasProveedor) {
        this.groupPoppupB.get('bloqueado').setValue(row.entC_BloqueoFinanzasProveedor);
        this.cargarInputBloqueo(row.entC_BloqueoFinanzasProveedor);
      }
      if (row.entC_UsrBloqueoProveedor) { this.groupPoppupB.get('usuariobloqueo').setValue(row.entC_UsrBloqueoProveedor) }
      if (row.entC_FecBloqueoProveedor) { this.groupPoppupB.get('fechabloqueoo').setValue(new Date(row.entC_FecBloqueoProveedor)) }
      if (row.entC_ObsBloqueoProveedor) { this.groupPoppupB.get('comentariobloqueo').setValue(row.entC_ObsBloqueoProveedor) }
    }
  }
  uploadedFiles: any[] = [];
  onUpload(event) {
    if (event.files.length > 0) {
      for (let file of event.files) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const base64Data = (e.target.result as string).split(',')[1];
          const req = {
            items: [{
              codigo: 0,
              tipotran: 'I',
              image: URL.createObjectURL(file),
              usuario: this.nomUsuario,
              fecha: this.util.formatearfecha(new Date(), 'dd-mm-yyyy'),
              nombre: file.name,
              url: base64Data
            }]
          }

          this.uploadedFiles.push({
            codigo: req.items[0].codigo,
            tipotran: req.items[0].tipotran,
            image: req.items[0].image,
            usuario: req.items[0].usuario,
            fecha: req.items[0].fecha,
            nombre: req.items[0].nombre,
            url: req.items[0].url
          });

          this.uploadedFiles = [...this.uploadedFiles]
          //    console.log(this.uploadedFiles)
        }
        reader.readAsDataURL(file);
      }
    }
  }

  obtenerIconoTipoArchivo(nombreArchivo: string): string {
    const extension = nombreArchivo.split('.').pop()?.toLowerCase();
    switch (extension) {
      case 'pdf':
        return '../../../../../assets/iconos/pdf.svg';
      case 'doc':
        return '../../../../../assets/iconos/documento.svg'
      case 'docx':
        return '../../../../../assets/iconos/word.svg'
      case 'jpg':
        return '../../../../../assets/iconos/jpg.svg'
      case 'jpeg':
      case 'png':
        return 'assets/icons/image-icon.svg';
      case 'xls':
        return '../../../../../assets/iconos/excel.svg'
      case 'xlsx':
        return '../../../../../assets/iconos/excel.svg'
      default:
        return 'assets/icons/default-icon.svg';
    }
  }

  downloadArchivo(value, row: any) {
    if (!row.url) {
      console.error('No hay archivo disponible para descargar.');
      return;
    }
    const extension = row.nombre.split('.').pop();
    const mimeType = this.getMimeType(extension);
    const fileName = `${row.nombre}.${extension}`;

    const byteCharacters = atob(row.url);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  getMimeType(extension: string): string {
    const mimeTypes: { [key: string]: string } = {
      'png': 'image/png',
      'jpg': 'image/jpeg',
      'jpeg': 'image/jpeg',
      'gif': 'image/gif',
      'pdf': 'application/pdf',
      'txt': 'text/plain',
      'doc': 'application/msword',
      'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'xls': 'application/vnd.ms-excel',
      'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'zip': 'application/zip',
    };

    return mimeTypes[extension.toLowerCase()] || 'application/octet-stream';
  }

  // Función para eliminar un archivo
  deleteArchivo(row: any): void {
    // Encuentra el índice del elemento en el array
    const index = this.uploadedFiles.findIndex(file => file === row);

    if (index !== -1) {
      // Si el archivo ya estaba marcado para eliminación, lo revertimos a 'U'
      if (this.uploadedFiles[index].tipotran === 'D') {
        this.uploadedFiles[index].tipotran = 'U';
        // console.log('Archivo desmarcado para eliminación:', this.uploadedFiles[index]);
      } else {
        // Si el archivo no es nuevo y tiene un código, lo marcamos para eliminación
        if (this.uploadedFiles[index].codigo && this.uploadedFiles[index].codigo !== 0) {
          this.uploadedFiles[index].tipotran = 'D';
          // console.log('Archivo marcado para eliminación:', this.uploadedFiles[index]);
        } else {
          // Si el archivo es nuevo (sin código), lo borramos del listado local
          this.uploadedFiles.splice(index, 1);
          // console.log('Archivo nuevo eliminado del listado local:', row);
        }
      }
      // Recrear la referencia del array para que Angular actualice la vista
      this.uploadedFiles = [...this.uploadedFiles];
    }
  }

  verHistorial(value, row: any) {
    const Request: ListarHistorialRequest = <ListarHistorialRequest>{}
    Request.pintENTC_Codigo = this.entcCod
    Request.psinTIPE_Codigo = this.codigoEntidad;
    Request.pchrTIPO_TabMND = row.tipO_TabMND
    Request.pchrTIPO_CodMND = row.tipO_CodMND
    this.dataTableHistorial = []
    this.mantcomercial.ListarHistorialEntidad(Request).subscribe(response => {
      if (response.datos.status === 200) { this.dataTableHistorial = response.datos.result }
    })
  }
  ListaTranEntidad: TablaEntidadBloqueo[] = []
  ListaTranDirecEntidad: TablaDireccionEntidad[] = []

  dialogVisibleValidacion: boolean = false;

  dialogData = {
    titulo: '',
    mensaje: '',
    observacion: '',
    onAccept: () => { },
    onReject: () => { },
    onOpcion3: () => { },
    textoBtnOpcion1: 'Confirmar',
    textoBtnOpcion2: 'Cancelar',
    textoBtnOpcion3: null,
  };
  opcion3: boolean = false;

  async abrirDialogoConfirmacion(options: {
    titulo: string,
    mensaje: string,
    observacion?: string,
    textoBtnOpcion1?: string,
    textoBtnOpcion2?: string,
    textoBtnOpcion3?: string,
  }): Promise<boolean> {
    return new Promise((resolve) => {
      this.dialogData = {
        titulo: options.titulo,
        mensaje: options.mensaje,
        observacion: options?.observacion,
        textoBtnOpcion1: options.textoBtnOpcion1 || 'Sí, Confirmar',
        textoBtnOpcion2: options.textoBtnOpcion2 || 'No, Cancelar',
        textoBtnOpcion3: options.textoBtnOpcion3,
        onAccept: () => {
          this.dialogVisibleValidacion = false;
          resolve(true);
        },
        onReject: () => {
          this.dialogVisibleValidacion = false;
          // Si hay una tercera opción, onReject resuelve en `true`
          if (options.textoBtnOpcion3) {
            this.opcion3 = true
            resolve(true);
          } else {
            // Si no hay tercera opción, onReject resuelve en `false`
            resolve(false);
          }
        },
        onOpcion3: () => {
          this.dialogVisibleValidacion = false;
          // La tercera opción siempre resuelve en `false`
          resolve(false);
        }
      };
      this.dialogVisibleValidacion = true;
    });
  }

  clienteSeleccionado: any = null;

  onGroupSelectionChange(selectedItem: any): void {
    if (selectedItem) {
      //   console.log('Grupo seleccionado:', selectedItem);
      this.clienteSeleccionado = selectedItem;
      // Aquí puedes actualizar tu formControl u otra lógica
    } else {
      //    console.log('Selección borrada.');
      this.clienteSeleccionado = null;
    }
  }

  payloadEjecutivoCrear = {}
  payloadEjecutivoActualizar = {
    entc_codigo: 0,
    grupo_id: 0
  }
  procesoAgrupacion: boolean = true
  procesoAsignacion: boolean = false
  listadoCodigoClientesEjecutivo = []
  modoAgrupacion = ""
  requestBandejaAsignacion: ParamAsignacionClientesRequest;
  async validarEjecutivoAntesDeGuardar(accion: string): Promise<boolean> {
    //1. Buscar al cliente seleccionado
    const codigoCliente = this.clienteSeleccionado?.entC_Codigo
    const razonsocialCliente = this.groupPoppupDG.get('razonsocial')?.value

    // 1. Filtrar ejecutivos de la tabla relacionados
    const ejecutivos = this.dataTableRelacionados.filter(
      (rel) => rel.relA_TipoRelacion?.value === "3"
    );

    if (!codigoCliente && ejecutivos.length === 1) {
      const confirmado = await this.abrirDialogoConfirmacion({
        titulo: `Guardar Cliente`,
        mensaje: `¿Está seguro(a) de guardar el cliente sin agruparlo?`,
      });
      if (!confirmado) return false;
      //! Procedimiento normal de Guardar cliente sin agruparlo
      this.procesoAgrupacion = false
      return true;
    }

    if (!codigoCliente && ejecutivos.length === 0) {
      const confirmado = await this.abrirDialogoConfirmacion({
        titulo: 'Guardar Cliente',
        mensaje: '¿Está seguro(a) de guardar el cliente sin asignarle un grupo ni un ejecutivo?'
      });
      if (!confirmado) return false;
      //! Guardar sin grupo ni ejecutivo
      this.procesoAgrupacion = false
      return true;
    }

    // 3. Buscar cliente seleccionado
    // const clienteSeleccionado = this.listadoGrupos.find(
    //   (c) => c.entC_Codigo === codigoCliente
    // );
    // if(!clienteSeleccionado){
    //   this.messageService.add({ key: 'toast1', severity: 'error', summary: 'Error', detail: 'Ocurrió un error al buscar el cliente en el listado' });
    //   return false
    // }

    const codigoEjecutivo = this.clienteSeleccionado.codigoEjecutivo;

    if (ejecutivos.length > 1) {
      this.messageService.add({ key: 'toast1', severity: 'error', summary: 'Error', detail: 'No se puede asignar más de un ejecutivo a la vez.' });
      return false
    }
    if (codigoCliente && ejecutivos.length === 1) {
      // 6. Comparar el único ejecutivo en dataTableRelacionados con codigoEjecutivo
      const ejecutivoTabla = ejecutivos[0];
      if (codigoEjecutivo) {
        if (this.clienteSeleccionado.grupo_id === null && (ejecutivoTabla.entC_CodHijo?.toString() != codigoEjecutivo?.toString())) {
          const confirmado = await this.abrirDialogoConfirmacion({
            titulo: `Guardar Cliente`,
            mensaje: `El cliente ${this.clienteSeleccionado.razon_social} no tiene grupo y está asignado(a) a otro ejecutivo ${this.clienteSeleccionado.nomCompletoEjecutivo}. ¿Desea agruparlos con distintos ejecutivos?`,
            observacion: 'En caso quiera agruparlo con el mismo ejecutivo, deberá asignarle quitar el ejecutivo de la tabla.'
          });
          if (!confirmado) return false;
          //! Crear grupo y asignarle a ambos el grupo_id
          this.modoAgrupacion = "crear"
          this.listadoCodigoClientesEjecutivo = [this.clienteSeleccionado.entC_Codigo,
            //entC_Codigo del cliente nuevo
          ]
          this.payloadEjecutivoCrear = {
            nombre_grupo: `Grupo ${razonsocialCliente}`,
            descripcion: "Grupo creado desde la bandeja clientes",
            AUDI_UsrCrea: this.storage.get('codusuario'),
            lista_clientes: this.listadoCodigoClientesEjecutivo
          };
          return true;
        } else if (this.clienteSeleccionado.grupo_id != null && (ejecutivoTabla.entC_CodHijo?.toString() != codigoEjecutivo?.toString())) {
          const confirmado = await this.abrirDialogoConfirmacion({
            titulo: `Guardar Cliente`,
            mensaje: `El cliente ${this.clienteSeleccionado.razon_social} (del grupo ${this.clienteSeleccionado.nombre_grupo}) está asignado(a) a otro ejecutivo ${this.clienteSeleccionado.nomCompletoEjecutivo}. ¿Desea agruparlos con distintos ejecutivos?`,
            observacion: "- En caso no quiera agruparlo, deberá quitar la selección del grupo.\n" +
              "- En caso quiera agruparlo con el mismo ejecutivo, debe quitar el ejecutivo de la tabla.\n" +
              `- En caso quiere que ambos tengan el nuevo ejecutivo, deberá cambiar el ejecutivo del cliente ${this.clienteSeleccionado.razon_social} desde el módulo de "Asignación Clientes".`
          });
          if (!confirmado) return false;
          //! Asignarle al nuevo cliente el grupo_id
          this.modoAgrupacion = "actualizar"
          this.payloadEjecutivoActualizar = {
            grupo_id: this.clienteSeleccionado.grupo_id,
            entc_codigo: 0
          };
          return true;
        } else if (this.clienteSeleccionado.grupo_id != null && (ejecutivoTabla.entC_CodHijo?.toString() === codigoEjecutivo?.toString())) {
          const confirmado = await this.abrirDialogoConfirmacion({
            titulo: `Guardar Cliente`,
            mensaje: `El cliente ${this.clienteSeleccionado.razon_social} (del grupo ${this.clienteSeleccionado.nombre_grupo}) está asignado(a) al mismo ejecutivo ${this.clienteSeleccionado.nomCompletoEjecutivo}. ¿Desea agruparlos?`,
          });
          if (!confirmado) return false;
          //! Asignarle el grupo_id al nuevo cliente
          this.modoAgrupacion = "actualizar"
          this.payloadEjecutivoActualizar = {
            grupo_id: this.clienteSeleccionado.grupo_id,
            entc_codigo: 0
          };
          return true;
        } else if (this.clienteSeleccionado.grupo_id === null && (ejecutivoTabla.entC_CodHijo?.toString() === codigoEjecutivo?.toString())) {
          const confirmado = await this.abrirDialogoConfirmacion({
            titulo: `Guardar Cliente`,
            mensaje: `El cliente seleccionado no tiene grupo, pero está asignado(a) al mismo ejecutivo ${this.clienteSeleccionado.nomCompletoEjecutivo}. ¿Desea agruparlo?`,
          });
          if (!confirmado) return false;
          //! Crear grupo y asignarle a ambos el grupo_id
          this.modoAgrupacion = "crear"
          this.listadoCodigoClientesEjecutivo = [this.clienteSeleccionado.entC_Codigo,
            //entC_Codigo del cliente nuevo
          ]
          this.payloadEjecutivoCrear = {
            nombre_grupo: `Grupo ${razonsocialCliente}`,
            descripcion: "Grupo creado desde la bandeja clientes",
            AUDI_UsrCrea: this.storage.get('codusuario'),
            lista_clientes: this.listadoCodigoClientesEjecutivo
          };
          return true;
        }
      } else {
        if (this.clienteSeleccionado.grupo_id === null) {
          const confirmado = await this.abrirDialogoConfirmacion({
            titulo: `Guardar Cliente`,
            mensaje: `El cliente ${this.clienteSeleccionado.razon_social} no tiene grupo ni ejecutivo asignado. ¿Desea agruparlo con el ejecutivo?`,
            textoBtnOpcion1: "Agrupar con ejecutivo",
            textoBtnOpcion2: "Agrupar sin ejecutivo",
            textoBtnOpcion3: "Cancelar"
          });
          if (!confirmado) return false;
          //! Crear grupo y actualizar el otro cliente
          this.modoAgrupacion = "crear"
          this.listadoCodigoClientesEjecutivo = [this.clienteSeleccionado.entC_Codigo,
            //entC_Codigo del cliente nuevo
          ]
          this.payloadEjecutivoCrear = {
            nombre_grupo: `Grupo ${razonsocialCliente}`,
            descripcion: "Grupo creado desde la bandeja clientes",
            AUDI_UsrCrea: this.storage.get('codusuario'),
            lista_clientes: this.listadoCodigoClientesEjecutivo
          };
          if (this.opcion3) return true
          //TODO: FUNCION PARA ASIGNAR
          this.procesoAsignacion = true
          const datos: AsignacionClienteDTO = {
            param_cliente_id: this.clienteSeleccionado.entC_Codigo,
            param_entidad_id: ejecutivos[0].entC_CodHijo,
            cod_rgm: ejecutivos[0].conS_RGM.value,
            cod_trf: ejecutivos[0].tipO_TRF.value,
            param_relaTipos: "VEN",
            tipo_entidad: 3,
          };

          this.requestBandejaAsignacion = {
            param_usrCrea: this.storage.get('codusuario'),
            datos: [datos],
          };
          return true;
        } else if (this.clienteSeleccionado.grupo_id != null) {
          const confirmado = await this.abrirDialogoConfirmacion({
            titulo: 'Grupo sin Ejecutivo',
            mensaje: `El cliente ${this.clienteSeleccionado.razon_social} (del grupo ${this.clienteSeleccionado.nombre_grupo}) no tiene ejecutivo, ¿desea asignarle el ejecutivo y agruparlos?`,
            textoBtnOpcion1: "Asignar ejecutivo y agrupar",
            textoBtnOpcion2: "No asignar y agrupar",
            textoBtnOpcion3: "Cancelar",
          });
          if (!confirmado) return false;
          this.modoAgrupacion = "actualizar"
          //! Asignarle el grupo_id al nuevo cliente
          this.payloadEjecutivoActualizar = {
            grupo_id: this.clienteSeleccionado.grupo_id,
            entc_codigo: 0,
          };
          if (this.opcion3) return true
          //TODO: FUNCION ASIGNAR
          this.procesoAsignacion = true
          const datos: AsignacionClienteDTO = {
            param_cliente_id: this.clienteSeleccionado.entC_Codigo,
            param_entidad_id: ejecutivos[0].entC_CodHijo,
            cod_rgm: ejecutivos[0].conS_RGM.value,
            cod_trf: ejecutivos[0].tipO_TRF.value,
            param_relaTipos: "VEN",
            tipo_entidad: 3,
          };
          this.requestBandejaAsignacion = {
            param_usrCrea: this.storage.get('codusuario'),
            datos: [datos],
          };
          return true;
        }
      }

      return false;
    } else if (codigoCliente && ejecutivos.length === 0) {
      //Va a validar grupo_id de clienteSeleccionado
      //En caso grupo_id sea diferente a null tenga, se ejecutará una función para agregarlo al grupo, enviando esa variable
      if (this.clienteSeleccionado.grupo_id === null && codigoEjecutivo === null) {
        const confirmado = await this.abrirDialogoConfirmacion({
          titulo: 'Cliente seleccionado sin grupo ni ejecutivo',
          mensaje: `El cliente ${this.clienteSeleccionado.razon_social} no tiene grupo ni ejecutivo, ¿desea agruparlo sin ejecutivo?`,
          observacion: "En caso no quiera agruparlo, deberá quitar la selección del grupo"
        });
        if (!confirmado) return false;
        this.modoAgrupacion = "crear"
        //!Crear grupo y asignarle a los dos clientes.
        this.listadoCodigoClientesEjecutivo = [this.clienteSeleccionado.entC_Codigo,
          //entC_Codigo del cliente nuevo
        ]
        this.payloadEjecutivoCrear = {
          nombre_grupo: `Grupo ${razonsocialCliente}`,
          descripcion: "Grupo creado desde la bandeja clientes",
          AUDI_UsrCrea: this.storage.get('codusuario'),
          lista_clientes: this.listadoCodigoClientesEjecutivo
        };
        return true;
      } else if (this.clienteSeleccionado.grupo_id != null && codigoEjecutivo === null) {
        const confirmado = await this.abrirDialogoConfirmacion({
          titulo: 'Grupo sin Ejecutivo',
          mensaje: `El cliente ${this.clienteSeleccionado.razon_social} (del grupo ${this.clienteSeleccionado.nombre_grupo}) no tiene ejecutivo, ¿desea agruparlo sin ejecutivo?`
        });
        if (!confirmado) return false;
        this.modoAgrupacion = "actualizar"
        //! Asignarle el grupo_id al nuevo cliente
        this.payloadEjecutivoActualizar = {
          grupo_id: this.clienteSeleccionado.grupo_id,
          entc_codigo: 0,
        };
        return true;
      } else if (this.clienteSeleccionado.grupo_id === null && codigoEjecutivo != null) {
        const confirmado = await this.abrirDialogoConfirmacion({
          titulo: `Guardar cliente`,
          mensaje: `El cliente ${this.clienteSeleccionado.razon_social} no tiene grupo, pero sí está asignado(a) al ejecutivo ${this.clienteSeleccionado.nomCompletoEjecutivo}. ¿Desea agruparlo con el ejecutivo (se colocará "Todos los tráficos" e "Importaciones" por defecto)?`,
          observacion: 'En caso quiera agruparlo con otro ejecutivo, deberá asignarle uno en la tabla "Relacionados"'
        });
        if (!confirmado) return false;
        //* Mandar a que coloque los datos en relacionados
        //! Agruparlo con el ejecutivo, pero se le mandará al tab "Relacionados" para que complete la información de RGM y TRF con el ejecutivo
        //! O un select para elegir el RGM y TRF.
        this.dataTableRelacionados.push({
          key: this.dataTableRelacionados.length + 1,
          relA_TipoRelacion: { label: "EJECUTIVO", value: "3", key: "VEN" },//Solo uno es necesario
          tipE_Hijo: { label: "EJECUTIVOS DE VENTA", value: "3" },//Solo uno es necesario
          entC_CodHijo: Number(codigoEjecutivo),
          tipO_TabTRF: "TRF",
          tipO_TRF: { label: "TODOS LOS TRAFICOS", value: "008" },
          conS_TabRGM: "RGM",
          conS_RGM: { label: "IMPORTACIONES", value: "001" },
          ESTADO_OBJ: accion,
        })
        //!Crear grupo y asignarle a los dos clientes.
        this.modoAgrupacion = "crear"
        this.listadoCodigoClientesEjecutivo = [this.clienteSeleccionado.entC_Codigo,
          //entC_Codigo del cliente nuevo
        ]
        this.payloadEjecutivoCrear = {
          nombre_grupo: `Grupo ${razonsocialCliente}`,
          descripcion: "Grupo creado desde la bandeja clientes",
          AUDI_UsrCrea: this.storage.get('codusuario'),
          lista_clientes: this.listadoCodigoClientesEjecutivo
        };
        return true;
      } else if (this.clienteSeleccionado.grupo_id != null && codigoEjecutivo != null) {
        const confirmado = await this.abrirDialogoConfirmacion({
          titulo: `Guardar Cliente`,
          mensaje: `El cliente ${this.clienteSeleccionado.razon_social} pertenece al grupo ${this.clienteSeleccionado.nombre_grupo} y está asignado(a) a ${this.clienteSeleccionado.nomCompletoEjecutivo}. ¿Desea agruparlo con ese ejecutivo (se colocará "Todos los tráficos" e "Importaciones" por defecto)?`,
          observacion: 'En caso quiera agruparlo con otro ejecutivo, deberá asignarle uno en la tabla "Relacionados"'
        });
        if (!confirmado) return false;
        //* Mandar a que coloque los datos en relacionados
        //! Agruparlo con el ejecutivo, pero se le mandará al tab "Relacionados" para que complete la información de RGM y TRF con el ejecutivo
        //! O un select para elegir el RGM y TRF.
        this.dataTableRelacionados.push({
          key: this.dataTableRelacionados.length + 1,
          relA_TipoRelacion: { label: "EJECUTIVO", value: "3", key: "VEN" },
          entC_CodHijo: Number(codigoEjecutivo),
          tipO_TabTRF: "TRF",
          tipO_TRF: { label: "TODOS LOS TRAFICOS", value: "008" },
          conS_TabRGM: "RGM",
          conS_RGM: { label: "IMPORTACIONES", value: "001" },
          ESTADO_OBJ: accion,
        })
        this.modoAgrupacion = "actualizar"
        this.payloadEjecutivoActualizar = {
          grupo_id: this.clienteSeleccionado.grupo_id,
          entc_codigo: 0,
        };
        return true;
      }
      return false;
    }
    return false;
  }

  async TransaccionEntidad(accion, row) {

    const values1 = this.groupPoppupDG.value
    const values2 = this.groupDatosComerciales.getRawValue()
    // console.log("groupPoppupDG", values1)
    // console.log("groupDatosComerciales", values2)
    // return
    // console.log("(getRawValue) onSubmitComercial", this.groupDatosComerciales.getRawValue())
    //  console.log("(value) onSubmitComercial", this.groupDatosComerciales.value)

    // return
    // console.log("this.listadoGrupos: ", this.listadoGrupos)
    // console.log("this.groupPoppupDG.value: ", this.groupPoppupDG.value)
    // console.log("this.grupoCliente: ", this.groupPoppupDG.get('grupoCliente')?.value)
    // return
    // const tnsValida = await this.validarTransaccion();
    // const emailValido = await this.validarEmail();
    // const direccionValida = await this.validarDirecciones();
    // if ((tnsValida == false || emailValido == false || direccionValida == false) && accion !== 'D') { return; }
    // Ejecuta las validaciones del formulario antes de continuar

    // if(!validacion) return

    // 1. Validar el primer formulario
    this.resetConditionalFields(this.groupPoppupDG.get('tipopersona').value);
    if (this.groupPoppupDG.invalid) {
      this.activeIndex = 0;
      // Muestra los mensajes de validación aunque no sea el submit del formulario
      this.markAllAsTouched(this.groupPoppupDG);
      this.showValidationMessages(); // Llama a la función para mostrar los errores
      return;
    }

    // const entC_NombreContacto = this.groupPoppupDG.get('contactonombre').value.trim()
    // const entC_ApellidoContacto = this.groupPoppupDG.get('contactoapellidos').value.trim()
    // const entC_EMail = this.groupPoppupDG.get('correo').value.trim()
    // const entC_Telef2 = this.groupPoppupDG.get('telefono_movil').value.trim()//movil
    // const fechaNacimiento = this.groupPoppupDG.get('fechanacimientog').value

    // const entC_EmailReceptorFE = this.groupPoppupDG.get('correo_facturacion').value.trim()//Facturacion
    // const entC_Telef1 = this.groupPoppupDG.get('telefono_fijo').value.trim()//fijo
    // const entC_CorreoContactoExpo = this.groupPoppupDG.get('correoexport').value.trim()//Exportacion
    // const entC_EMail2 = this.groupPoppupDG.get('correo_otros_traficos').value.trim() //otros traficos

    // let nextsoftNombre = entC_NombreContacto;
    // let nextsoftApellido = entC_ApellidoContacto;
    // let nextsoftEmail = entC_EMail;
    // let nextsoftTel2 = entC_Telef2;
    // let nextsoftFechaNacimientog = fechaNacimiento;
    // let nextsoftEmailReceptorFE = entC_EmailReceptorFE;
    // let nextsoft_entC_Tel1 = entC_Telef1;
    // let nextsoft_entC_CorreoContactoExpo = entC_CorreoContactoExpo;
    // let nextsoft_entC_EMail2 = entC_EMail2;

    // 2. Validar el segundo formulario
    if (this.groupPoppupDG.get('tipoCliente')?.value === '004') {
      // ✅ Validar los checkboxes y forzar toggle según valor actual
      const isPrincipalOptional = this.groupDatosComerciales.get('contactoPrincipal.checkOpcional')?.value;
      const isBillingOptional = this.groupDatosComerciales.get('billingContact.checkOpcional')?.value;
      const isLogisticsOptional = this.groupDatosComerciales.get('checkOpcionalILC')?.value;
      const isOperationsOptional = this.groupDatosComerciales.get('checkOpcionalOC')?.value;
      const isCustomerProfileOptional = this.groupDatosComerciales.get('checkOpcionalCustomerProfile')?.value; // Añadido para completar

      // Forzar validaciones correctas
      this.toggleValidators(this.groupDatosComerciales.get('contactoPrincipal') as FormGroup, isPrincipalOptional);
      this.toggleValidators(this.groupDatosComerciales.get('billingContact') as FormGroup, isBillingOptional);
      this.toggleArrayValidators(this.groupDatosComerciales.get('internationalLogisticsContacts') as FormArray, isLogisticsOptional, 'logistics');
      this.toggleArrayValidators(this.groupDatosComerciales.get('operationsContacts') as FormArray, isOperationsOptional, 'operations');
      if (this.groupDatosComerciales.invalid) {
        this.activeIndex = 1;
        this.markAllControlsAsTouched(this.groupDatosComerciales);
        this.showValidationMessagesForGroup(this.groupDatosComerciales);
        return;
      }
      // 🚨 INICIO DE LA NUEVA VALIDACIÓN CON DIALOG 🚨
      const seccionesOpcionales: { nombre: string, activo: boolean }[] = [
        { nombre: 'Contacto Principal', activo: isPrincipalOptional },
        { nombre: 'Contacto de Facturación', activo: isBillingOptional },
        { nombre: 'Contactos Logísticos Internacionales', activo: isLogisticsOptional },
        { nombre: 'Contactos de Operaciones', activo: isOperationsOptional },
        { nombre: 'Customer Profile (Archivo)', activo: isCustomerProfileOptional },
      ];

      // MODIFICACIÓN: Generar un string con saltos de línea para la lista.
      const seccionesNoGuardadasList = seccionesOpcionales
        .filter(s => s.activo)
        .map(s => `• ${s.nombre}`) // Añadimos un punto o guion para cada elemento
        .join('\n'); // Unimos los elementos con un salto de línea

      if (seccionesNoGuardadasList) {
        const confirmado = await this.abrirDialogoConfirmacion({
          titulo: 'Confirmación de Guardado',
          mensaje: `Existen secciones opcionales marcadas en Datos Comerciales.`,
          // MODIFICACIÓN: Usamos el string con saltos de línea en la observación.
          observacion: `Las siguientes secciones NO serán guardadas:\n${seccionesNoGuardadasList}`,
          textoBtnOpcion1: 'Continuar',
          textoBtnOpcion2: 'Cancelar',
        });

        if (!confirmado) {
          // El usuario ha pulsado 'No, Cancelar' en el diálogo
          this.activeIndex = 1;
          return; // Detiene el flujo de guardado
        }
      }
      // 🚨 FIN DE LA NUEVA VALIDACIÓN CON DIALOG 🚨

      if (!isCustomerProfileOptional) {
        //   console.log("archivosSeleccionado", this.archivosSeleccionado)
        //    console.log("uploadedFilesComercial", this.uploadedFilesComercial)
        if (accion === "I" && (this.archivosSeleccionado.length === 0 || !this.archivosSeleccionado[0].name)) {
          this.activeIndex = 1;
          this.messageService.add({
            key: 'toast1',
            severity: 'warn',
            summary: 'Customer Profile',
            detail: 'Necesita adjuntar el archivo customer profile.'
          });
          return
        }
        if (accion === "U") {
          if (this.sinArchivoInicial) {
            if (this.archivosSeleccionado.length === 0 || !this.archivosSeleccionado[0].name) {
              this.activeIndex = 1;
              this.messageService.add({
                key: 'toast1',
                severity: 'warn',
                summary: 'Customer Profile',
                detail: 'Necesita adjuntar el archivo customer profile.'
              });
              return
            }
          } else if (this.uploadedFilesComercial.length === 0 || !this.uploadedFilesComercial[0].nombreArchivo || !this.uploadedFilesComercial[0].metadatos.entc_codigo) {
            this.activeIndex = 1;
            this.messageService.add({
              key: 'toast1',
              severity: 'warn',
              summary: 'Customer Profile',
              detail: 'Necesita adjuntar el archivo customer profile.'
            });
            return
          }
        }
      }
    }

    if (this.modo === "CREAR" && this.groupPoppupDG.get('tipoCliente')?.value === '004') {
      const validacion = await this.validarEjecutivoAntesDeGuardar(accion)
      // console.log("validacion", validacion)
      // console.log("payloadEjecutivoCrear", this.payloadEjecutivoCrear)
      // console.log("payloadEjecutivoActualizar", this.payloadEjecutivoActualizar)
      // console.log("dataTableRelacionados", this.dataTableRelacionados)
      // console.log("listadoCodigoClientesEjecutivo", this.listadoCodigoClientesEjecutivo)

      if (!validacion) {
        this.activeIndex = 4;
        return
      }
    }

    row = this.listaDatosEntidad
    const values = this.groupPoppupDG.value
    //console.log("detallesSegmento", values.detallesSegmento)
    const valuesdatos = this.groupPoppupD.value
    const valuesbloqueo = this.groupPoppupB.value
    const RequestTrans: TransaccionEntidadBloqueoRequest = <TransaccionEntidadBloqueoRequest>{}
    RequestTrans.tablaDireccionEntidad = []
    const items = <TablaDireccionEntidad>{}
    items.ENTC_Codigo = this.entcCod || 0
    if (accion === 'I') {
      items.DIRE_Codigo = 0
    } else { items.DIRE_Codigo = 1 }
    items.DIRE_Direccion = values.direccion
    items.DIRE_Facturar = true
    items.DIRE_Referencia = null
    items.DIRE_Activo = true
    items.UBIG_Codigo = values.distrito
    items.TIPO_TabPais = 'PAI'
    items.TIPO_CodPais = values.pais
    items.AUDI_UsrCrea = this.nomUsuario
    items.AUDI_UsrMod = this.nomUsuario
    if (accion === 'I') {
      items.tipotran = 'I';
    } else if (accion === 'U') {
      if (values.direccion) {
        const direccionEnBD = this.dataTableDireccion.some(row => row && row.dirE_Codigo === 1);
        if (!direccionEnBD) {
          items.tipotran = 'I';
        } else {
          items.tipotran = 'U';
        }
      } else {
        items.tipotran = 'D';
      }
    }
    //NUEVO PARA COMERCIAL
    const { almacen, direccionComercial, paisComercial, departamentoComercial, provinciaComercial, distritoComercial, segmentoNuevo, detallesSegmento, tipoCliente } = values
    let requestComercial: any = {
      tipoCliente,
      almacen: almacen ? true : false,
      direccionComercial,
      paisComercial,
      departamentoComercial,
      provinciaComercial,
      distritoComercial,
      segmentoNuevo,
      detallesSegmento
    }
    if (tipoCliente === '004') {
      const logisticsArray = this.groupDatosComerciales.get('internationalLogisticsContacts') as FormArray;
      const operationsArray = this.groupDatosComerciales.get('operationsContacts') as FormArray;
      this.subscribeArrayToInputSync(logisticsArray, operationsArray, false);
    }

    RequestTrans.tablaDireccionEntidad.push(items)
    RequestTrans.tablaEntidadBloqueo = []
    const itement = <TablaEntidadBloqueo>{}
    itement.ENTC_Codigo = this.entcCod || 0
    itement.TIPO_TabTDI = 'TDI'
    itement.TIPO_CodTDI = this.groupPoppupDG.get('tipodocumento')?.value;
    itement.ENTC_TipEnt = values.tipopersona
    itement.ENTC_DocIden = values.numerodocumento
    itement.ENTC_Domiciliado = values.nodomiciliado == null ? false : values.nodomiciliado
    itement.ENTC_Nombres = values.nombres
    itement.ENTC_ApePat = values.apellidopaterno
    itement.ENTC_ApeMat = values.apellidomaterno
    if (values.apellidopaterno && values.nombres) {
      itement.ENTC_NomCompleto = `${itement.ENTC_ApePat || ''} ${itement.ENTC_ApeMat || ''} ${itement.ENTC_Nombres || ''}`.trim();
    } else if (values.razoncomercial) {
      itement.ENTC_NomCompleto = values.razoncomercial;
    } else if (values.razonsocial) {
      itement.ENTC_NomCompleto = values.razonsocial;
    } else { itement.ENTC_NomCompleto = null }
    itement.ENTC_NomComercial = values.razoncomercial
    itement.ENTC_RazonSocial = values.razonsocial
    itement.ENTC_Activo = values.activo || false
    itement.ENTC_FecNac = values.fechanacimiento
    itement.ENTC_FecIng = values.fechaingreso
    itement.ENTC_VIP = values.vip == null ? false : values.vip
    itement.ENTC_Notas = this.row?.entC_Notas || null
    itement.ENTC_Sexo = values.sexo
    //console.log("correo", this.groupPoppupDG.get('correo').value)
    //itement.ENTC_EMail = values.correo || this.groupPoppupDG.get('correo').value || " "//"sincorreo@gmail.com"
    itement.ENTC_EMail = this.groupPoppupDG.get('tipoCliente')?.value == '004' ? this.groupPoppupDG.get('correo2').value || " " : this.groupPoppupDG.get('correo').value || " "//"sincorreo@gmail.com"
    itement.ENTC_Web = values.web ?? ''
    itement.ENTC_Propio = this.row?.entC_Propio || false
    itement.ENTC_Telef1 = values.telefono_fijo ?? null
    itement.ENTC_Telef2 = values.telefono_movil ?? null
    itement.ENTC_Telef3 = null
    itement.ENTC_Telef4 = null
    itement.ENTC_Beneficiario = this.row?.entC_Beneficiario || null
    itement.ENTC_Area = values.area
    itement.ENTC_Cargo = values.cargo
    itement.USER_CodUsr = this.row?.useR_CodUser || null
    itement.TIPO_TabPai = 'PAI'
    itement.TIPO_CodPai = values.pais
    itement.TIPO_TabHol = this.row?.tipO_TabHol || null
    itement.TIPO_CodHol = this.row?.tipO_CodHol || null
    itement.CONS_CodTFT = this.row?.conS_CodTFT || null
    itement.CONS_TabTFT = this.row?.conS_TabTFT || null
    itement.TIPO_TabCiu = this.row?.tipO_TabCiu || null
    itement.TIPO_CodCiu = this.row?.tipO_CodCiu || null
    itement.ENTC_Prospecto = values.prospecto || false
    itement.TIPO_TabDTM = this.row?.tipO_TabDTM || null
    itement.TIPO_CodDTM = this.row?.tipO_CodDTM || null
    itement.ENTC_ValRebate = this.row?.entC_ValRebate || null
    itement.TIPO_TabMnd = this.row?.tipO_TabMnd || null
    itement.TIPO_CodMnd = this.row?.tipO_TabMnd || null
    itement.ENTC_ValTarja = this.row?.entC_ValTarja || null
    itement.ENTC_DiasCredito = values.diascreditos
    itement.ENTC_FechaCredito = values.fechacredito
    itement.ENTC_Tarja = this.row?.entC_Tarja || false
    itement.ENTC_CodAduana = this.row?.entC_CodAduana || null
    itement.CONS_CodCre = this.row?.conS_CodCre || null
    itement.CONS_TabCre = this.row?.conS_CodCre || null
    // console.log("correo_otros_traficos", this.groupPoppupDG.get('correo_otros_traficos').value)
    itement.ENTC_EMail2 = this.groupPoppupDG.get('tipoCliente')?.value == '004' ? this.groupPoppupDG.get('correo_otros_traficos2').value || " " : this.groupPoppupDG.get('correo_otros_traficos').value || " "//"sincorreo@gmail.com"

    itement.ENTC_Obser = values.observaciones
    itement.ENTC_Siglas = values.sigla ?? null
    itement.ENTC_InterbancarioSol = valuesdatos.ctaintersoles
    itement.ENTC_InterbancarioDol = valuesdatos.ctainterdolares
    itement.ENTC_CuentaDetraccion = valuesdatos.ctadetracciones
    itement.ENTC_ServicioLogistico = values.serviciologistico ?? false
    itement.ENTC_OcultarShipper = this.row?.entC_OcultarShipper || false
    itement.ENTC_ObsFinanzasCliente = this.row?.entC_ObsFinanzasCliente || null
    itement.ENTC_BloqueoFinanzasCliente = this.row?.entC_BloqueoFinanzasCliente || false
    itement.ENTC_UsrBloqueoCliente = this.row?.entC_UsrBloqueoCliente || null
    itement.ENTC_FecBloqueoCliente = this.row?.entC_FecBloqueoCliente || null
    itement.ENTC_EmailFinanzas = values.correofinanzas
    itement.ENTC_ObsBloqueoCliente = this.row?.entC_ObsBloqueoCliente || null
    itement.ENTC_OtrosTraficos = valuesdatos.esOtrosTraficos ?? false
    itement.ENTC_Mandato = valuesdatos.esMandato ?? false
    itement.ENTC_SLI = valuesdatos.esSli ?? false
    itement.ENTC_Exportacion = valuesdatos.esExportaciones ?? false
    itement.ENTC_UsrBloqueoProveedor = valuesbloqueo.usuariobloqueo
    itement.ENTC_FecBloqueoProveedor = valuesbloqueo.fechabloqueoo
    itement.ENTC_BloqueoFinanzasProveedor = valuesbloqueo.bloqueado || false
    itement.ENTC_ObsFinanzasProveedor = this.row?.entC_ObsFinanzasProveedor || null
    itement.ENTC_ObsBloqueoProveedor = valuesbloqueo.comentariobloqueo
    itement.ENTC_ProvAsumeDetraccion = valuesdatos.asumedetraccion || false
    itement.ENTC_ToOrder = values.to_order ?? false
    itement.AUDI_UsrCrea = this.nomUsuario
    itement.AUDI_UsrMod = this.nomUsuario
    // itement.ENTC_EmailReceptorFE = values.correo_facturacion
    itement.ENTC_EmailReceptorFE = this.groupPoppupDG.get('tipoCliente')?.value == '004' ? values.correo_facturacion2 : values.correo_facturacion

    itement.TIPO_CodSEG = values.segmento ?? null
    itement.ENTC_NombreContacto = values.contactonombre
    itement.ENTC_ApellidoContacto = values.contactoapellidos
    // console.log("correoexport", this.groupPoppupDG.get('correoexport').value)
    // itement.ENTC_CorreoContactoExpo = values.correoexport || this.groupPoppupDG.get('correoexport').value || " " //"sincorreo@gmail.com"

    itement.ENTC_CorreoContactoExpo = this.groupPoppupDG.get('tipoCliente')?.value == '004' ? this.groupPoppupDG.get('correoexport2').value : this.groupPoppupDG.get('correoexport').value || " " //"sincorreo@gmail.com"
    itement.nombreGerente = values.nomgerente
    itement.fechaNacimiento = values.fechanacimientog
    itement.fechaAniversario = values.fechaAniversariog

    RequestTrans.tablaEntidadBloqueo.push(itement)
    RequestTrans.TIPE_Codigo = this.codigoEntidad;
    RequestTrans.DIRE_Facturar = true
    RequestTrans.ENTC_Codigo = row.entC_Codigo != null ? row.entC_Codigo : values['codigo']
    RequestTrans.operacion = accion

    RequestTrans.tablaserviciosentidad = [];
    RequestTrans.tabladetalleservicio = [];
    RequestTrans.tablazonatransporte = [];
    RequestTrans.tablatipocarga = [];

    this.dataTableCuentasBancarias = this.dataTableCuentasBancarias.map(item => ({
      tipotran: item.ESTADO_OBJ || 'U',
      ENTC_Codigo: this.entcCod,
      TIPO_TabBCO: 'BCO',
      TIPO_CodBCO: item.tipO_CodBCO ? item.tipO_CodBCO : item.tipO_BCO?.value,
      tipO_BCO: item.tipO_BCO?.label,
      ENCB_TipoCuenta: item.encB_TipoCuenta ? item.encB_TipoCuenta : item.tipoCuenta?.value,
      tipoCuenta: item.tipoCuenta?.label || item.encB_TipoCuenta,
      ENCB_NroCuentaSol: item.encB_NroCuentaSol,
      ENCB_NroCuentaDol: item.encB_NroCuentaDol,
      AUDI_UsrCrea: this.nomUsuario,
      AUDI_UsrMod: this.nomUsuario
    }));

    RequestTrans.tablacuentasbancarias = this.dataTableCuentasBancarias

    this.InsertLimCredito = this.dataTableLimiteCredito.map(item => ({
      ENTC_Codigo: this.entcCod,
      TIPE_Codigo: this.codigoEntidad,
      ENLI_Tipos: "PRO",
      ENLI_Codigo: item.enlI_Codigo,
      ENLI_Monto: item.enlI_Monto || 0,
      ENLI_DiasDuracion: values.diascreditos,
      ENLI_Fecha: values.fechacredito,
      ENLI_Notas: item.enlI_Notas,
      ENLI_FecInicio: item.enlI_FecInicio != null && item.enlI_FecInicio != '' ? new Date(item.enlI_FecInicio) : null,
      ENlI_FecVencimiento: item.enlI_FecVencimiento != null && item.enlI_FecVencimiento != '' ? new Date(item.enlI_FecVencimiento) : null,
      ENLI_FormaPago: item.enlI_FormaPagoDescripcion?.value,
      TIPO_TabMND: 'MND',
      TIPO_CodMND: item.tipO_MND?.value,
      AUDI_UsrCrea: this.nomUsuario,
      AUDI_UsrMod: this.nomUsuario,
      ENLI_TipoFecVencimiento: null,
      ENLI_CliAutEmiCheqDiferidos: item.enlI_CliAutEmiCheqDiferidos ?? false,
      ENLI_CliConCredLibre: item.enlI_CliConCredLibre ?? false,
      tipotran: item.enlI_Codigo != null ? item.ESTADO_OBJ : 'I'
    }))

    RequestTrans.tablalimitecredito = this.InsertLimCredito

    this.InsertArchivos = this.uploadedFiles.map(item => ({
      ENAR_Codigo: item.codigo,
      ENTC_Codigo: this.entcCod,
      ENAR_Archivo: item.url,
      AUDI_UsrCrea: item.usuario,
      ENAR_NombreArchivo: item.nombre,
      ENAR_Extension: '.' + item.nombre.split('.').pop(),
      ID_OUT: 0,
      tipotran: item.tipotran
    }))

    RequestTrans.tablaarchivosentidad = this.InsertArchivos

    RequestTrans.tablaserviciosentidad = []
    this.dataTableServicios?.forEach((r, i) => {
      const items: TablaEntidadServicios = <TablaEntidadServicios>{};
      items.eseR_Codigo = r.eseR_Codigo ?? r.key;
      items.serV_Codigo = Number(r['serV_Nombre']?.value ?? r['serV_Codigo'] ?? 0);
      items.eseR_Valor = r['eseR_Valor'] ?? null;
      items.eseR_Exonerado = r['eseR_Exonerado'] == "" ? false : r['eseR_Exonerado'];
      items.entC_Codigo = row.entC_Codigo;
      items.audI_UsrCrea = this.nomUsuario;
      items.eseR_Cantidad = r['eseR_Cantidad'] != "" ? r['eseR_Cantidad'] : 0;
      items.tipO_TabMnd = 'MND';
      items.tipO_CodMnd = r['tipO_DescMND']?.value ?? r['tipO_CodMnd'] ?? null;
      items.conS_TabBas = 'BAS';
      items.conS_CodBas = r['conS_DescBAS']?.value ?? r['conS_CodBas'] ?? null
      if (r['ESTADO_OBJ'] == 'I' || r['ESTADO_OBJ'] == 'U' || r['ESTADO_OBJ'] == 'D') {
        items.ESTADO_OBJ = r['ESTADO_OBJ'];
        RequestTrans.tablaserviciosentidad.push(items);
      }
    });

    RequestTrans.tablaEntidadRelacionados = [];

    // if(this.groupPoppupDG.get('grupoCliente')?.value){
    //   // 1. Buscar cliente seleccionado
    //   const clienteSeleccionado = this.listadoGrupos.find(
    //     (c) => c.entC_Codigo === this.groupPoppupDG.get('grupoCliente')?.value
    //   );

    //   if (!clienteSeleccionado) {
    //     console.error("Cliente no encontrado en listadoGrupos");
    //     return false;
    //   }
    // }

    this.dataTableRelacionados?.forEach((r, i) => {
      const items: TablaEntidadRelacionados = <TablaEntidadRelacionados>{};
      items.relA_Codigo = r['relA_Codigo'] ?? null;
      items.entC_CodPadre = this.entcCod ?? 0;
      items.entC_CodHijo = Number(r['entC_CodHijo'])
      items.conS_TabRGM = r['conS_TabRGM'] ?? "RGM";
      items.conS_CodRGM = r['conS_RGM']?.value ?? r['conS_RGM'] ?? null;
      items.relA_Activo = r['relA_Activo'] == null ? true : r['relA_Activo'];
      items.audI_UsrCrea = this.nomUsuario;
      items.audI_UsrMod = this.nomUsuario;
      items.tipO_TabTRF = r['tipO_TabTRF'] ?? "TRF";
      items.tipO_CodTRF = r['tipO_TRF']?.value ?? r['tipO_CodTRF'] ?? r['tipO_TRF'];
      items.relA_Tipos = r['relA_TipoRelacion']?.key ?? r['relA_Tipos'] ?? null;
      items.relA_DepTemNegociaAgente = r['relA_DepTemNegociaAgente'] == null ? false : r['relA_DepTemNegociaAgente'];
      items.tipE_CodPadre = r['tipE_CodPadre'] ?? this.codigoEntidad;
      items.tipE_CodHijo = Number(r['tipE_CodHijo'] || r['tipE_Hijo']?.value || r['relA_TipoRelacion']?.value)
      items.relA_Observacion = r['relA_Observacion'] ?? null;
      items.ESTADO_OBJ = r['ESTADO_OBJ'];
      if (r['ESTADO_OBJ'] == 'I' || r['ESTADO_OBJ'] == 'U' || r['ESTADO_OBJ'] == 'D') {
        RequestTrans.tablaEntidadRelacionados.push(items);
      }
    });

    // Validar si existe tipE_CodHijo con valor 14 o 6
    const hasRestrictedType = RequestTrans.tablaEntidadRelacionados.some(item =>
      item.tipE_CodHijo === 14 || item.tipE_CodHijo === 6
    );
    if (hasRestrictedType) {
      const hasValidFile = RequestTrans.tablaarchivosentidad.some(item =>
        item.tipotran === 'I' && item.ENAR_NombreArchivo && item.ENAR_NombreArchivo.trim() !== ''
      );
      if (!hasValidFile) {
        this.activeIndex = 5;
        this.messageService.add({ key: 'toast1', severity: 'warn', summary: 'Advertencia', detail: 'Debe adjuntar el correo del cliente con el sustento de la relación del depósito temporal en la sección "Archivos".' });
        return;
      }
    }
    //console.log("Request FINAL 'I': ", RequestTrans)

    if (accion === 'D') {
      this.mantcomercial.TransaccionEntidadBloqueo(RequestTrans).subscribe(response => {
        if (response.datos.status === 200) {
          this.util.ShowMessage({ titulo: '', mensaje: 'Se eliminaron los datos correctamente.', tipo: 'ok' })
          const razonsocial = this.group.get('razonsocial').value;
          const numdocumento = this.group.get('numdocumento').value;
          this.ejecutarFuncionDelPadre()
          // if (razonsocial || numdocumento) { this.search(); }
        }
      }, err => {
        this.messageService.add({ key: 'toast1', severity: 'error', summary: 'Error', detail: err?.error?.meta?.mensaje });
      })
    } else {
      //  console.log("INSERCIÓN...")
      this.mantcomercial.TransaccionEntidadBloqueo(RequestTrans).subscribe(response => {
        if (response.datos.status === 200) {
          // console.log("response", response.datos.entc_codigo)
          const codCreado = Number(response.datos.entc_codigo)
          if (this.modo === "CREAR" && this.groupPoppupDG.get('tipoCliente')?.value === '004') {
            if (this.procesoAgrupacion) {
              let requestAgrupacion: ParamGrupoBandeja;
              if (this.modoAgrupacion === "crear") {
                this.listadoCodigoClientesEjecutivo.push(codCreado)
                requestAgrupacion = this.payloadEjecutivoCrear
              } else {
                this.payloadEjecutivoActualizar.entc_codigo = codCreado
                requestAgrupacion = this.payloadEjecutivoActualizar
              }
              this.proformaService.BandejaGrupoComercial(requestAgrupacion).subscribe({
                next: (response) => {
                  if (response.datos.status === 200) {
                    this.messageService.add({ key: 'toast1', severity: 'success', summary: 'Agrupacion', detail: "Agrupacion establecida correctamente" });
                  }
                },
                error: (err) => {
                  const mensaje = err.error?.meta?.mensaje || 'Ocurrió un error al agrupar.';
                  this.messageService.add({ key: 'toast1', severity: 'error', summary: 'Error al agrupar', detail: mensaje });
                }
              })
            }
            if (this.procesoAsignacion) {
              this.proformaService.BandejaAsignacionEjecutivos(this.requestBandejaAsignacion).subscribe({
                next: (response) => {
                  if (response.datos.status === 200) {
                    this.messageService.add({ key: 'toast1', severity: 'success', summary: 'Asignacion', detail: "Asignacion establecida correctamente" });
                  }
                },
                error: (err) => {
                  const mensaje = err.error?.meta?.mensaje || 'Ocurrió un error al asignar.';
                  this.messageService.add({ key: 'toast1', severity: 'error', summary: 'Error al asignar', detail: mensaje });
                }
              })
            }
          }


          // this.entC_Codigo = Number(response.datos.entc_codigo)
          const razonsocial = this.group.get('razonsocial').value;
          const numdocumento = this.group.get('numdocumento').value;
          const estadoQunac = this.groupPoppupDG.get('estadoQunac').value ?? false;
          if (values.tipodocumento === "001" &&
            (values.numerodocumento !== "" || values.numerodocumento !== null || values.numerodocumento !== undefined)) {
            //Insertamos en la tabla dgp.entidad_estado_sunat y dgp.clientes_comerciales
            this.proformaService.InsertarEstadoSunat({ entc_codigo: codCreado, ruc: values.numerodocumento, audi_usrcrea: this.storage.get('codusuario'), estadoQunac, tipoCliente: this.groupPoppupDG.get('tipoCliente')?.value })
              .subscribe({
                next: (response) => {
                  if (response.datos.status === 200) {
                    requestComercial = { ...requestComercial, entc_codigo: codCreado }
                    if (this.groupPoppupDG.get('tipoCliente')?.value === '004') {
                      this.proformaService.InsertarDatosComerciales(requestComercial).subscribe({
                        next: async (response) => {
                          if (response.datos.status === 200) {
                            this.messageService.add({ key: 'toast1', severity: 'success', summary: 'Datos Generales Comerciales', detail: "Se guardaron los datos generales comerciales" })
                            console.log("insertanto en comercial")
                            await this.onSubmitComercial(codCreado);
                            this.ejecutarFuncionDelPadre()
                            this.enviar_correo_facturacion(codCreado.toString());
                            this.visible = false;
                            this.group.reset();
                            this.groupPoppupDG.reset()
                            this.groupPoppupD.reset()
                            this.groupPoppupB.reset()
                            this.groupPS.reset()
                            this.groupPoppupE.reset()
                            this.groupDatosComerciales.reset();
                            this.internationalLogisticsContactsArray.clear();
                            this.operationsContactsArray.clear();
                            this.addNewLogisticsContact()
                            this.addNewOperationsContact()
                            this.archivosSeleccionado = [];
                            this.uploadedFilesComercial = [];
                            this.payloadEjecutivoCrear = {}
                            this.payloadEjecutivoActualizar = {
                              entc_codigo: 0,
                              grupo_id: 0
                            }
                            this.procesoAgrupacion = false
                            this.listadoCodigoClientesEjecutivo = []
                            this.modoAgrupacion = ""
                            this.clienteSeleccionado = null

                            this.util.ShowMessage({ titulo: 'Clientes Comerciales', mensaje: 'Se guardaron los datos correctamente.', tipo: 'ok' })
                            // if (razonsocial || numdocumento) { this.search(); }
                          }
                        },
                        error: (err) => {
                          const mensaje = err.error?.meta?.mensaje || 'Ocurrió un error al guardar los datos generales comerciales.';
                          this.messageService.add({ key: 'toast1', severity: 'error', summary: 'Datos Generales Comerciales', detail: mensaje });
                          console.error('Error en la creación:', err);
                        }
                      })
                    } else {
                      if (this.modo === 'EDITAR') {
                        const formData: ComercialDataRequest = {
                          ENTC_Codigo: this.entC_Codigo,
                          contactoPrincipal: null,
                          billingContact: null,
                          internationalLogisticsContacts: [],
                          operationsContacts: [],
                        };
                        this.proformaService.ActualizarDatosComerciales(formData).subscribe({
                          next: (response) => {
                            this.ejecutarFuncionDelPadre()
                            this.enviar_correo_facturacion(codCreado.toString());
                            this.visible = false;
                            this.group.reset();
                            this.groupPoppupDG.reset()
                            this.groupPoppupD.reset()
                            this.groupPoppupB.reset()
                            this.groupPS.reset()
                            this.groupPoppupE.reset()
                            this.groupDatosComerciales.reset();
                            this.internationalLogisticsContactsArray.clear();
                            this.operationsContactsArray.clear();
                            this.addNewLogisticsContact()
                            this.addNewOperationsContact()
                            this.archivosSeleccionado = [];
                            this.uploadedFilesComercial = [];
                            this.payloadEjecutivoCrear = {}
                            this.payloadEjecutivoActualizar = {
                              entc_codigo: 0,
                              grupo_id: 0
                            }
                            this.procesoAgrupacion = false
                            this.listadoCodigoClientesEjecutivo = []
                            this.modoAgrupacion = ""
                            this.clienteSeleccionado = null
                            this.util.ShowMessage({ titulo: 'Clientes', mensaje: 'Se guardaron los datos correctamente.', tipo: 'ok' })
                          },
                          error: (err) => {
                            const mensaje = err.error?.meta?.mensaje || 'Ocurrió un error al guardar los datos.';
                            this.messageService.add({ key: 'toast1', severity: 'error', summary: 'Error', detail: mensaje });
                            console.error('Error en la creación:', err);
                          }
                        });
                      } else {
                        this.ejecutarFuncionDelPadre()
                        this.enviar_correo_facturacion(codCreado.toString());
                        this.visible = false;
                        this.group.reset();
                        this.groupPoppupDG.reset()
                        this.groupPoppupD.reset()
                        this.groupPoppupB.reset()
                        this.groupPS.reset()
                        this.groupPoppupE.reset()
                        this.groupDatosComerciales.reset();
                        this.internationalLogisticsContactsArray.clear();
                        this.operationsContactsArray.clear();
                        this.addNewLogisticsContact()
                        this.addNewOperationsContact()
                        this.archivosSeleccionado = [];
                        this.uploadedFilesComercial = [];
                        this.payloadEjecutivoCrear = {}
                        this.payloadEjecutivoActualizar = {
                          entc_codigo: 0,
                          grupo_id: 0
                        }
                        this.procesoAgrupacion = false
                        this.listadoCodigoClientesEjecutivo = []
                        this.modoAgrupacion = ""
                        this.clienteSeleccionado = null
                        this.util.ShowMessage({ titulo: 'Clientes', mensaje: 'Se guardaron los datos correctamente.', tipo: 'ok' })
                      }

                    }
                  }
                },
                error: (err) => {
                  const mensaje = err.error?.meta?.mensaje || 'Ocurrió un error al guardar los estados de sunat.';
                  this.messageService.add({ key: 'toast1', severity: 'error', summary: 'Error al guardar datos de sunat', detail: mensaje });
                }
              })
          } else {
            this.proformaService.InsertarTipoCliente({ entc_codigo: codCreado, tipoCliente: this.groupPoppupDG.get('tipoCliente')?.value }).subscribe({
              next: async (response) => {
                if (response.datos.status === 200) {
                  this.visible = false;
                  this.util.ShowMessage({ titulo: 'Clientes', mensaje: 'Se guardaron los datos correctamente.', tipo: 'ok' })
                  this.ejecutarFuncionDelPadre()
                  this.enviar_correo_facturacion(codCreado.toString());
                  this.group.reset();
                  this.groupPoppupDG.reset()
                  this.groupPoppupD.reset()
                  this.groupPoppupB.reset()
                  this.groupPS.reset()
                  this.groupPoppupE.reset()
                  this.groupDatosComerciales.reset();
                  this.internationalLogisticsContactsArray.clear();
                  this.operationsContactsArray.clear();
                  this.addNewLogisticsContact()
                  this.addNewOperationsContact()
                  this.archivosSeleccionado = [];
                  this.uploadedFilesComercial = [];
                  this.payloadEjecutivoCrear = {}
                  this.payloadEjecutivoActualizar = {
                    entc_codigo: 0,
                    grupo_id: 0
                  }
                  this.procesoAgrupacion = false
                  this.listadoCodigoClientesEjecutivo = []
                  this.modoAgrupacion = ""
                  this.clienteSeleccionado = null
                }
              },
              error: (err) => {
                const mensaje = err.error?.meta?.mensaje || 'Ocurrió un error al guardar los datos generales.';
                this.messageService.add({ key: 'toast1', severity: 'error', summary: 'Datos Generales', detail: mensaje });
                console.error('Error en la creación:', err);
              }
            })

          }
          //itement.TIPO_CodTDI = response.datos.entc_codigo, values.tipodocumento y cod_ususario

        }
      }, err => {

        this.messageService.add({ key: 'toast1', severity: 'error', summary: 'Error al guardar cliente', detail: err?.error?.meta?.mensaje });
      })
    }
  }

  exportExcel() {
    let nuevadata = []
    this.dataTable.forEach(row => {
      const {
        entC_Codigo,
        tipO_CodTDI,
        entC_DocIden,
        entC_RazonSocial,
        entC_Activo,
        entC_EMail,
        entC_EmailReceptorFE,
        entC_Telef1,
        entC_Telef2,
        entC_CodSAP_C,
        entC_CodSAP_P,
        entC_FecActSAP,
        audI_UsrCrea,
        audI_FecCrea,
        audI_UsrMod,
        audI_FecMod
      } = row;
      const newItem = {
        "CÓDIGO": entC_Codigo,
        "TIPO DOC. IDENTIDAD": tipO_CodTDI,
        "N.I.T": entC_DocIden,
        "NOMBRE": entC_RazonSocial,
        "ACTIVO": entC_Activo === true ? 'SI' : 'NO',
        "CORREO": entC_EMail,
        "CORREO FACTURA ELECTRÓNICA": entC_EmailReceptorFE,
        "TEL. FIJO": entC_Telef1,
        "TEL. MÓVIL": entC_Telef2,
        "CLIENTE SAP": entC_CodSAP_C,
        "PROVEEDOR SAP": entC_CodSAP_P,
        "SINCRONIZACIÓN SAP": this.util.formatearfecha(entC_FecActSAP, 'dd-mm-yyyy'),
        "CREADO POR": audI_UsrCrea,
        "FECHA CREA": this.util.formatearfecha(audI_FecCrea, 'dd-mm-yyyy'),
        "MODIFICADO POR": audI_UsrMod,
        "FECHA MOD.": this.util.formatearfecha(audI_FecMod, 'dd-mm-yyyy')
      };
      nuevadata.push(newItem);
    });

    //  console.log(nuevadata)

    const data = [
      {
        data: nuevadata, cabeceras: []
      }
    ]
    this.util.ExportarExcel(data, 'MANTENIMIENTO PROVEEDORES.xlsx')
  }

  salir() {
    this.handleDialogClose()
    this.visible = false
  }

  verNumDoc(event) {
    // console.log(event)
    if (event.value === '002') {
      this.groupPoppupDG.get('tipopersona').setValue("N")
      this.visiblenumdoc = true
    }
    else if (event.value === '004') { this.visiblenumdoc = false } else { this.visiblenumdoc = true }
  }

  salirBandejaPrincipal() {
    const rutaComponente = '/mantenimiento-comercial';
    this.router.navigate([rutaComponente]);
  }

  sincronizarSAP(row) {
    this.funcionSincronizarSAP(row.row, 'C')
  }

  funcionSincronizarSAP(row: any, tipoSocio: string) {
    this.metadataTable[0].loading = true;
    const loadingScreen = this.util.showLoadingScreen({ message: "Sincronizando ..." });
    const Request: SincronizarEntidadSapRequest = <SincronizarEntidadSapRequest>{}
    Request.ENTC_Codigo = row.entC_Codigo
    Request.TIPE_Codigo = row.tipE_Codigo
    Request.TipoSocio = tipoSocio
    this.mantcomercial.SincronizarEntidadSAP(Request).subscribe(response => {
      if (response.datos.status === 200) {
        this.util.ShowMessage({ titulo: "Sincronización Exitosa", mensaje: response.meta.mensajeRespuesta, icono: "OK", tipo: "ok" });
        this.metadataTable[0].loading = false;
        // this.search();
        this.ejecutarFuncionDelPadre()
        loadingScreen.close();
      } else {
        this.util.ShowMessage({ titulo: "ERROR", mensaje: response.meta.mensajeRespuesta, icono: "pi pi-exclamation-triangle", tipo: "warning" });
        this.metadataTable[0].loading = false;
        loadingScreen.close();
      }
    }, err => {
      this.util.ShowMessage({ titulo: "ERROR", mensaje: err?.error?.meta?.mensaje, icono: "pi pi-exclamation-triangle", tipo: "warning" });
      loadingScreen.close();
      this.metadataTable[0].loading = false;
    })
  }

  InsertArchivos: any[] = []
  dataButtons = [
    { icon: 'pi pi-download', function: () => this.exportAuditoria() }
  ];
  exportAuditoria() {
    let nuevadata = []
    this.dataTableAuditoria.forEach(row => {
      const {
        operacion,
        direccionip,
        nombremaquina,
        nombreaplicacion,
        usuariosql,
        usuarioaplicacion,
        fechamodificacion,
        codigoentidad,
        docidentidad,
        codigodocidentidad,
        numdocidentidad,
        tipopersona,
        domiciliado,
        nombres,
        apellidopaterno,
        apellidomaterno,
        nombrecompleto,
        nombrecomercial,
        razonsocial,
        activo,
        fechanacimiento,
        fechaingreso,
        vip,
        notas,
        sexo,
        email,
        email2,
        web,
        propio,
        telefono1,
        telefono2,
        telefono3,
        telefono4,
        beneficiario,
        area,
        cargo,
        cuentausuario,
        pais,
        codigopais,
        holding,
        codigoholding,
        tipotarifa,
        codigotarifa,
        prospecto,
        rebate,
        moneda,
        codigomoneda,
        tipodeposito,
        codtipodeposito,
        tarja,
        realizatarja,
        diacredito,
        fechacredito,
        codigoaduana,
        observaciones,
        cuenintersoles,
        cueninterdolares,
        cuendetraccion,
        serviciologistico,
        ocultarshipper,
        obserfinanzas,
        otrostraficos,
        mandato,
        sli,
        exportacion,
        emailfinanzas,
        bloqueocliente,
        usubloqueacliente,
        fecbloqueocliente,
        obserbloqueocliente,
        bloqueoproveedor,
        usubloqueaproveedor,
        fecbloqueoproveedor,
        obserbloqueoproveedor,
        obserproveedor,
        asumedetraccion,
        usuariocrea,
        fechacrea,
        usuariomodifica,
        fechamodifica
      } = row;
      const newItem = {
        "Operación": operacion,
        "Dirección IP": direccionip,
        "Nombre Máquina": nombremaquina,
        "Nombre Apliación": nombreaplicacion,
        "Usuario SQL": usuariosql,
        "Usuario Aplicación": usuarioaplicacion,
        "Fecha Modificación": fechamodificacion || '',
        "Código Entidad": codigoentidad || '',
        "Doc. Identidad": docidentidad || '',
        "Código Doc. Identidad": codigodocidentidad || '',
        "Num. Doc. Identidad": numdocidentidad || '',
        "Tipo Persona": tipopersona || '',
        "Domiciliado": domiciliado === true ? 'SI' : 'NO',
        "Nombres": nombres || '',
        "Ape. Paterno": apellidopaterno || '',
        "Ape. Materno": apellidomaterno || '',
        "Nom. Completo": nombrecompleto || '',
        "Nom. Comercial": nombrecomercial || '',
        "Razón Social": razonsocial || '',
        "Activo": activo === true ? 'SI' : 'NO',
        "Fec. Nacimiento": fechanacimiento,
        "Fec. Ingreso": fechaingreso,
        "VIP": vip === true ? 'SI' : 'NO',
        "Notas": notas,
        "Sexo": sexo,
        "E-mail": email,
        "E-mail2": email2,
        "Web": web,
        "Propio": propio,
        "Teléfono 1": telefono1,
        "Teléfono 2": telefono2,
        "Teléfono 3": telefono3,
        "Teléfono 4": telefono4,
        "Beneficiario": beneficiario,
        "Área": area,
        "Cargo": cargo,
        "Cuenta Usuario": cuentausuario,
        "País": pais,
        "Cod. País": codigopais,
        "Holding": holding,
        "Cod. Holding": codigoholding,
        "Tipo Tarifa": tipotarifa,
        "Cod. Tarifa": codigotarifa,
        "Prospecto": prospecto === true ? 'SI' : 'NO',
        "Rebate": rebate,
        "Moneda": moneda,
        "Cod. Moneda": codigomoneda,
        "Tipo Depósito": tipodeposito,
        "Cod. Tipo Depósito": codtipodeposito,
        "Tarja": tarja,
        "Reaiza Tarja": realizatarja === true ? 'SI' : 'NO',
        "Día Crédito": diacredito,
        "Fec. Crédito": fechacredito,
        "Cod. Aduana": codigoaduana,
        "Observaciones": observaciones,
        "Cuen. Inter. Soles": cuenintersoles,
        "Cuen. Inter. Dólares": cueninterdolares,
        "Cuen. Detracción": cuendetraccion,
        "Servicio Logístico": serviciologistico === true ? 'SI' : 'NO',
        "Ocultar Shipper": ocultarshipper === true ? 'SI' : 'NO',
        "Obser. Finanzas": obserfinanzas,
        "Otros Tráficos": otrostraficos === true ? 'SI' : 'NO',
        "Mandato": mandato === true ? 'SI' : 'NO',
        "SLI": sli === true ? 'SI' : 'NO',
        "Exportación": exportacion === true ? 'SI' : 'NO',
        "E-mail Finanzas": emailfinanzas,
        "Bloqueo Cliente": bloqueocliente === true ? 'SI' : 'NO',
        "Usu. Bloquea Cliente": usubloqueacliente,
        "Fec. Bloqueo Cliente": fecbloqueocliente,
        "Obser. Bloqueo Cliente": obserbloqueocliente,
        "Bloqueo Proveedor": bloqueoproveedor === true ? 'SI' : 'NO',
        "Usu. Bloquea Proveedor": usubloqueaproveedor,
        "Fec. Bloqueo Proveedor": fecbloqueoproveedor,
        "Obser. Bloqueo Proveedor": obserbloqueoproveedor,
        "Obser. Proveedor": obserproveedor,
        "Asume Detracción": asumedetraccion,
        "Usuario Crea": usuariocrea,
        "Fec. Crea": fechacrea,
        "Usuario Modifica": usuariomodifica,
        "Fec. Modifica": fechamodifica
      };
      nuevadata.push(newItem);
    });

    // console.log(nuevadata)

    const data = [
      {
        data: nuevadata, cabeceras: []
      }
    ]
    this.util.ExportarExcel(data, 'AUDITORÍA PROVEEDOR.xlsx')
  }

  async validarTransaccion(): Promise<boolean> {
    let esValido = true;
    let mensajeError = "";

    const group = this.groupPoppupDG;
    const get = (campo: string) => group.get(campo)?.value;

    let controles = {
      // ENTC_Codigo: { requerido: get("ENTC_Codigo") == null, mensaje: "Debe ingresar el campo ENTC_Codigo" },
      TIPO_CodTDI: { requerido: !get("tipodocumento"), mensaje: "Debe seleccionar el campo tipo documento" },
      ENTC_TipEnt: { requerido: !get("tipopersona"), mensaje: "Debe ingresar el campo Tipo de Persona" },
      ENTC_DocIden: { requerido: !get("numerodocumento"), mensaje: "Debe ingresar el campo número de documento" },
      // ENTC_Domiciliado: { requerido: get("nodomiciliado") == null, mensaje: "Debe ingresar el campo No Domiciliado" },
      // ENTC_VIP: { requerido: get("vip") == null, mensaje: "Debe ingresar el campo VIP" },
    };

    if (this.natural) {
      const ctlr = { ENTC_Sexo: { requerido: !get("sexo"), mensaje: "Debe ingresar el campo Sexo" } };
      controles = { ...controles, ...ctlr };
    }

    // Validar campos básicos
    for (let campo in controles) {
      if (controles[campo].requerido) {
        group.get(campo)?.setErrors({ required: true });
        mensajeError += `* ${controles[campo].mensaje}\n`;
        esValido = false;
      } else {
        group.get(campo)?.setErrors(null);
      }
    }

    // Validar según tipo de entidad
    const tipEnt = get("tipopersona");
    if (tipEnt === "J") {
      if (!get("razonsocial")) {
        group.get("razonsocial")?.setErrors({ required: true });
        mensajeError += "* Debe ingresar el campo razón social\n";
        esValido = false;
      } else {
        group.get("razonsocial")?.setErrors(null);
      }
    } else {
      if (!get("nombres")) {
        group.get("nombres")?.setErrors({ required: true });
        mensajeError += "* Debe ingresar el campo nombre\n";
        esValido = false;
      } else {
        group.get("nombres")?.setErrors(null);
      }
    }

    // Validar crédito
    const diasCredito = get("diascreditos");
    const fechaCredito = get("fechacredito");

    if (diasCredito && diasCredito > 0 && !fechaCredito) {
      group.get("fechacredito")?.setErrors({ required: true });
      mensajeError += "* Debe ingresar el campo fecha crédito\n";
      esValido = false;
    } else {
      group.get("fechacredito")?.setErrors(null);
    }

    if (!diasCredito && fechaCredito) {
      group.get("diascreditos")?.setErrors({ required: true });
      mensajeError += "* Debe ingresar el campo días crédito\n";
      esValido = false;
    } else {
      group.get("diascreditos")?.setErrors(null);
    }

    if (!esValido) {
      this.messageService.add({ key: 'toast1', severity: 'error', summary: 'Completar campos obligatorios', detail: mensajeError });
    }

    return esValido;
  }

  async validarEmail(): Promise<boolean> {
    let l_correcto = true;
    let l_email1OK = true;
    let l_email2OK = true;
    let l_email3OK = true;

    let mensajeError = '';
    const delimiter = ';';

    // Validación de ENTC_EMail
    const ENTC_EMail = this.groupPoppupDG.get('correo')?.value;
    mensajeError = '';
    if (ENTC_EMail) {
      const correos = ENTC_EMail.split(delimiter);
      for (const correo of correos) {
        if (correo.trim() && !this.isValidEmail(correo.trim())) {
          l_email1OK = false;
        }
      }
      if (!l_email1OK) {
        mensajeError = 'El Formato del Correo es Incorrecto\n';
      }
    }

    // Validación de ENTC_EMail2
    const correo_otros_traficos = this.groupPoppupDG.get('correo_otros_traficos')?.value;
    if (correo_otros_traficos) {
      const correos2 = correo_otros_traficos.split(delimiter);
      for (const correo of correos2) {
        if (correo.trim() && !this.isValidEmail(correo.trim())) {
          l_email2OK = false;
        }
      }
      if (!l_email2OK) {
        mensajeError += 'El Formato del Correo de Otros Tráficos es Incorrecto\n';
      }
    }

    // Validación de ENTC_EmailReceptorFE
    const ENTC_EmailReceptorFE = this.groupPoppupDG.get('correo_facturacion')?.value;
    if (ENTC_EmailReceptorFE) {
      const correos3 = ENTC_EmailReceptorFE.split(delimiter);
      for (const correo of correos3) {
        if (correo.trim() && !this.isValidEmail(correo.trim())) {
          l_email3OK = false;
        }
      }
      if (!l_email3OK) {
        mensajeError += 'El Formato del Correo de Facturación es Incorrecto\n';
      }
    }

    if (!l_email1OK || !l_email2OK || !l_email3OK) {
      l_correcto = false;
      this.messageService.add({ key: 'toast1', severity: 'error', summary: 'El Formato de alguno de los correos ingresados es incorrecto', detail: mensajeError });
    }

    return l_correcto;
  }


  isValidEmail(emailList: string): boolean {
    const trimmed = (emailList || '').trim();
    if (!trimmed) return false;
    const emails = trimmed
      .split(/[\s,;]+/)
      .map(e => e.trim())
      .filter(e => e.length > 0);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    return emails.every(e => emailRegex.test(e));
  }

  validarDirecciones(): boolean {
    let l_correcto = true;
    let l_direccionFiscal = true;
    let l_direccionComercial = true;
    let mensajeError = '';

    const DIRE_Direccion = this.groupPoppupDG.get('direccion')?.value;
    const pais = this.groupPoppupDG.get('pais')?.value;

    if (pais) {
      if (!DIRE_Direccion) {
        l_direccionFiscal = false;
      }
    }

    // if (this.groupPoppupDG.TIPO_TabPaisFiscal && this.groupPoppupDG.TIPO_CodPaisFiscal) {
    //   if (!DIRE_Direccion) {
    //     l_direccionFiscal = false;
    //   }
    // }

    // if (this.groupPoppupDG.TIPO_TabPaisComercial && this.groupPoppupDG.TIPO_CodPaisComercial) {
    //   if (!this.groupPoppupDG.DIRE_DireccionComercial) {
    //     l_direccionComercial = false;
    //   }
    // }

    if (!l_direccionFiscal || !l_direccionComercial) {
      l_correcto = false;
      this.messageService.clear();
      this.messageService.add({ key: 'toast1', severity: 'error', summary: 'Campos obligatorios', detail: 'Debe ingresar una Dirección para poder guardar el registro' });
    }

    return l_correcto;
  }

  exportarAuditoriaServicios() {
    let nuevadata = []
    this.dataTableAuditoriaServicios.forEach(row => {
      const {
        operacion, direccion_IP, nombre_Maquina, nombre_Aplicacion, usuario_SQL, usuario_Aplicacion,
        fecha_Modificacion, codigo_Interno, cod_Servicio, cod_Entidad, valor, exonerado, cantidad, moneda,
        cod_Moneda, base_Calculo, cod_Base_Calculo, usuario_Crea, fec_Crea, usuario_Modifica, fec_Modifica
      } = row;
      const newItem = {
        "OPERACIÓN": operacion,
        "DIRECCIÓN IP": direccion_IP,
        "NOMBRE MÁQUINA": nombre_Maquina,
        "NOMBRE APLICACIÓN": nombre_Aplicacion,
        "USUARIO SQL": usuario_SQL,
        "USUARIO APLICACIÓN": usuario_Aplicacion,
        "FECHA MODIFICACIÓN": this.util.formatearfecha(fecha_Modificacion, 'dd/mm/yyyy'),
        "CÓDIGO INTERNO": codigo_Interno,
        "COD SERVICIO": cod_Servicio,
        "COD ENTIDAD": cod_Entidad,
        "VALOR": valor,
        "EXONERADO": exonerado === true ? 'SI' : 'NO',
        "CANTIDAD": cantidad,
        "MONEDA": moneda,
        "COD MONEDA": cod_Moneda,
        "BASE CÁLCULO": base_Calculo,
        "COD BASE CÁLCULO": cod_Base_Calculo,
        "USUARIO CREA": usuario_Crea,
        "FEC CREA": this.util.formatearfecha(fec_Crea, 'dd/mm/yyyy'),
        "USUARIO MODIFICA": usuario_Modifica,
        "FECHA MODIFICA": this.util.formatearfecha(fec_Modifica, 'dd/mm/yyyy')
      };
      nuevadata.push(newItem);
    });

    const data = [
      {
        data: nuevadata, cabeceras: []
      }
    ]
    this.util.ExportarExcel(data, 'AUDITORIA SERVICIOS AGENTES.xlsx')
  }

  onEntidadChange(event: { field: string; event: any, index: any; rowdata: any }) {
    let value: string = String(event.event.value.value);
    const index = event.index;
    const valueArray = value.includes('|') ? value.split('|') : [value];

    // const actualizarDropdown = (field: string, lista: any[]) => {
    //   const fieldToUpdate = this.metadataTableRelacionados.find(m => m.field === field);
    //   if (fieldToUpdate) { fieldToUpdate.dropdown = [...lista]; }
    // };

    if (event.field === 'relA_TipoRelacion') {
      this.ListaFiltradaTipoEntidadDP = valueArray.length > 1
        ? this.ListaTipoEntidadDP.filter(item => valueArray.includes(item.value))
        : this.ListaTipoEntidadDP.filter(item => item.value === value);

      this.actualizarDpMtRelacionados('tipE_Hijo', this.ListaFiltradaTipoEntidadDP);
      this.enviarValorDTRelacionados(this.ListaFiltradaTipoEntidadDP[0], index, 'tipE_Hijo');

      this.ListaFiltradaNombreEntidadesDP = valueArray.includes('6') || valueArray.includes('7')
        ? this.ListaNombreEntidadesDP.filter(item => item.tipo === 'AGE')
        : this.ListaNombreEntidadesDP.filter(item => {
          const tipos = {
            '15': 'DepositoVacio',
            '14': 'DepositoTemp',
            '3': 'EJEC',
            '4': 'CUS',
            '5': 'TRANSPORTISTA',
            '9': 'CONTACTO',
          };
          return item.tipo === tipos[value];
        });

      this.actualizarDpMtRelacionados('entC_RazonSocial', this.ListaFiltradaNombreEntidadesDP);
    }

    if (event.field === 'entC_RazonSocial') { // razon social/nombres
      if (value != null) {
        const Request: ListarEntidadesRequest = <ListarEntidadesRequest>{}
        Request.pintENTC_Codigo = Number(value);
        Request.pvchENTC_NomCompleto = null;
        Request.pvchTIPE_Codigo = event.rowdata.tipE_Hijo.value;
        Request.pvchENTC_DocIden = null;
        this.mantcomercial.ListarEntidades(Request).subscribe(response => {
          if (response.datos.status === 200) {
            const row = response.datos.result[0];
            this.enviarValorDTRelacionados(row.entC_EMail, index, 'entC_EMail');
            this.enviarValorDTRelacionados(row.entC_EmailReceptorFE, index, 'entC_EmailReceptorFE');
            this.enviarValorDTRelacionados(row.entC_Codigo, index, 'entC_CodHijo');
            this.enviarValorDTRelacionados(row.entC_DocIden, index, 'entC_DocIden');
          }
        })
      } else {
        this.enviarValorDTRelacionados(null, index, 'entC_EMail');
        this.enviarValorDTRelacionados(null, index, 'entC_EmailReceptorFE');
        this.enviarValorDTRelacionados(null, index, 'entC_CodHijo');
        this.enviarValorDTRelacionados(null, index, 'entC_DocIden');
      }
    }

  }

  async onServiciosChange(event: { field: string; event: any; index: any; rowdata: any }) {
    // console.log('evento', event)
    const index = event.index;
    let valorDP: string = String(event.event.value.value);
    const fieldCambiado = event.field;
    let nuevoValor;
    const rowdata = event.rowdata;
    if (fieldCambiado == "serV_Nombre") { // servicio
      if (valorDP != null) {
        const request = <consultarServiciosRequest>{}
        request.serv_codigo = Number(valorDP);
        this.mantcomercial.obtenerServiciosDetallado(request).subscribe((response) => {
          if (response.datos.status === 200) {
            const row = response.datos.result[0];
            let via = null;
            if (row.cons_codvia != null) {
              via = { label: row.cons_descvia, value: row.cons_codvia };
            }
            let regimen = null;
            if (row.cons_codrgm != null) {
              regimen = { label: row.cons_descrgm, value: row.cons_codrgm };
            }
            let lineaNegocio = null;
            if (row.cons_codlng != null) {
              lineaNegocio = { label: row.cons_desclng, value: row.cons_codlng };
            }
            this.enviarValorDTServicios(via, index, 'conS_DescVIA');
            this.enviarValorDTServicios(regimen, index, 'conS_DescRGM');
            this.enviarValorDTServicios(lineaNegocio, index, 'conS_DescLNG');
          }
        });

      }
    }
  }

  enviarValorDTServicios(value: any, index: any, field: string) {
    const nuevoValor = value;
    const eventToEmit = { field, event: { value: nuevoValor }, index };
    this.onDpChangeTblServicios.emit(eventToEmit);
  }

  enviarValorDTRelacionados(value: any, index: any, field: string) {
    const nuevoValor = value;
    const eventToEmit = { field, event: { value: nuevoValor }, index };
    this.onDpChangeTblRelacionados.emit(eventToEmit);
  }

  enviar_correo_facturacion(new_entc_codigo: string) {
    const informar_facturacion = this.groupPoppupDG.value.informar_facturacion;
    if (informar_facturacion == true) {

      const mailOrigen = this.correoUsuario;
      const mailTo = "facturacion@delfingroupco.com.pe";

      const request = <envioFinanzasNuevoClienteRequest>{};
      request.tbl_envioCorreo = [];
      request.formato = null;
      request.tbl_ruc = null;

      const requestc2 = <envioCorreosRequest>{};
      requestc2.destinatarios = 'ext_ichumpitaz@delfingroupco.com.pe';// mailTo
      requestc2.asunto_reunion = "CREACIÓN DE NUEVAS RAZONES SOCIALES TICKET N° [TICKET] [HBLS] [NOMBRE_CLIENTE_OV]";
      requestc2.tipo = null;
      requestc2.correoorigen = 'ext_mirus1@delfingroupco.com.pe';//mailOrigen;
      requestc2.copia = 'ext_mirus1@delfingroupco.com.pe'; // null
      requestc2.copiaoculta = null;
      requestc2.body = ""; // se obtiene en el backend
      requestc2.subject = requestc2.asunto_reunion;
      requestc2.fileContents = null;
      requestc2.fileNames = null;
      requestc2.bytesAtchivo = [];
      requestc2.nombrearchivos = [];
      requestc2.usuario = this.nomUsuario;
      request.tbl_envioCorreo.push(requestc2);

      const request_form = <formatoCorreoRequest>{};
      request_form.codigo = "001";
      request_form.nombre = "MantenimientoEntidades";
      request_form.sub_nombre = "CreacionNuevoClienteFacturacion";
      request.formato = request_form;

      const request_ruc = <registroNuevoRucRequest>{}
      request_ruc.tbl_ruc = [];
      request_ruc.usuario = this.nomUsuario;
      if (this.estadoEditar) {
        request_ruc.new_entc_codigo = this.groupPoppupDG.get('codigo').value;
      }
      else {
        request_ruc.new_entc_codigo = Number(new_entc_codigo);
      }

      const item_nuevo_ruc: itemsConfirmarRuc = { docv_codigo: 0, ruc: this.groupPoppupDG.get('numerodocumento').value }

      request_ruc.idticket = 0;
      request_ruc.tbl_ruc = [item_nuevo_ruc];

      request.tbl_ruc = request_ruc;

      this.mantcomercial.envioFinanzasNuevoCliente(request).subscribe(res => {
        if (res.datos.status === 200) {
          this.messageService.add({ key: 'toastGeneral', severity: 'success', summary: 'OK', detail: res?.meta?.mensaje });
        }
      }, err => {
        this.messageService.add({ key: 'toastGeneral', severity: 'error', summary: 'Error al informar a facturación', detail: err?.error?.meta?.mensaje });
      })

    }
  }

  @ViewChild('dtEntidadRef') dtEntidad!: DatatableComponent;
  actualizarDpMtRelacionados = (field: string, lista: any[]) => {
    const fieldToUpdate = this.metadataTableRelacionados.find(m => m.field === field);
    if (fieldToUpdate) { fieldToUpdate.dropdown = lista; }
    const metadataItem = this.dtEntidad.metadata.find(m => m.field === field);
    if (metadataItem) {
      metadataItem.dropdown = [...lista];
    }
    //   console.log(this.metadataTableRelacionados)
    this.cdr.detectChanges();
  };

  // Función que se ejecuta al cerrar el Dialog (o al ocultar la variable)
  public handleDialogClose(): void {
    // Cierra el dialog (esto es un ejemplo, usa tu propia lógica de cierre)
    // this.displayDialog = false;

    // 1. Ejecutar el reset en la tabla si la referencia está disponible
    if (this.dtEntidad) {
      this.dtEntidad.resetEditState();
    }
  }

  //COMERCIAL
  // --- Getters para acceder fácilmente a los FormArrays ---
  get internationalLogisticsContactsArray(): FormArray {
    return this.groupDatosComerciales.get('internationalLogisticsContacts') as FormArray;
  }

  get operationsContactsArray(): FormArray {
    return this.groupDatosComerciales.get('operationsContacts') as FormArray;
  }

  get contactoPrincipalForm(): FormGroup {
    return this.groupDatosComerciales.get('contactoPrincipal') as FormGroup;
  }

  get billingContactForm(): FormGroup {
    return this.groupDatosComerciales.get('billingContact') as FormGroup;
  }

  getFormGroup(control: AbstractControl): FormGroup {
    return control as FormGroup;
  }

  // --- Métodos para gestionar Contactos de Logística Internacional ---
  createLogisticsContactGroup(initialData?: Partial<InternationalLogisticsContact>): FormGroup {
    const id = initialData?.id?.toString() || uuidv4();
    const replicate = initialData?.replicateFromPrincipal || false;

    // --- Solución para la fecha: convertir la cadena a objeto Date ---
    const birthday = initialData?.birthday ? new Date(initialData.birthday) : null;

    const group = new FormGroup({
      id: new FormControl(id),
      replicateFromPrincipal: new FormControl(replicate),
      replicateToOperations: new FormControl(initialData?.replicateToOperations || false),
      name: new FormControl({ value: initialData?.name || null, disabled: replicate }, [Validators.required, this.minLettersValidator]),
      lastName: new FormControl({ value: initialData?.lastName || null, disabled: replicate }, [Validators.required, this.minLettersValidator]),
      //position: new FormControl({ value: initialData?.position || null, disabled: replicate }, [Validators.required, this.minLettersValidator]),
      position: new FormControl({ value: initialData?.position || null, disabled: replicate }, this.minLettersValidator),
      phone: new FormControl({ value: initialData?.phone || null, disabled: replicate }, [Validators.required, this.phoneValidator]),
      birthday: new FormControl({ value: birthday, disabled: replicate }), // opcional
      email: new FormControl({ value: initialData?.email || null, disabled: replicate }, [Validators.required, this.multiEmailTrimmedValidator]),
      emailTypes: new FormGroup({
        mandato: new FormControl(initialData?.emailTypes?.mandato || false),
        otrosTraficos: new FormControl(initialData?.emailTypes?.otrosTraficos || false),
        exportacion: new FormControl(initialData?.emailTypes?.exportacion || false),
      }, [this.atLeastOneEmailTypeValidator])
    });

    // 👉 cada contacto logístico se engancha para empujar cambios a operaciones
    this.setupLogisticsReplicationForContact(group);

    return group;
  }

  addNewLogisticsContact(): void {
    const newLogContact = this.createLogisticsContactGroup({ id: uuidv4() });
    this.internationalLogisticsContactsArray.push(newLogContact);

    // 🔄 sincronizar con todos los contactos de operaciones
    this.operationsContactsArray.controls.forEach(opGroup => {
      const replicateGroup = opGroup.get('replicateFromLogistics') as FormGroup;
      const logId = newLogContact.get('id')?.value;
      if (replicateGroup && !replicateGroup.get(`log_contact_${logId}`)) {
        replicateGroup.addControl(`log_contact_${logId}`, new FormControl(false));

        // 🚨 Nueva validación: si ya existe algún checkbox en true, este nuevo se deshabilita
        const alreadyReplicated = Object.keys(replicateGroup.controls).some(key => {
          const control = replicateGroup.get(key);
          return control?.value === true || control?.disabled;
        });
        if (alreadyReplicated) {
          replicateGroup.get(`log_contact_${logId}`)?.disable({ emitEvent: false });
        }
      }
    });
    this.syncReplicateFromLogistics()
  }

  removeLogisticsContact(index: number): void {
    if (this.internationalLogisticsContactsArray.length <= 1) return;

    // 1) Obtén el grupo e id ANTES de eliminarlo
    const removedGroup = this.internationalLogisticsContactsArray.at(index) as FormGroup;
    const removedId = removedGroup.get('id')?.value;

    // 2) Para cada contacto de operaciones, si estaba replicando de este id, simula "unchecked"
    this.operationsContactsArray.controls.forEach(opControl => {
      const replicateGroup = opControl.get('replicateFromLogistics') as FormGroup;
      const key = `log_contact_${removedId}`;

      if (replicateGroup.contains(key) && replicateGroup.get(key)?.value === true) {
        // Usa tu lógica existente de "unchecked" mientras el source aún existe
        this.replicateLogisticsToOperations(opControl as FormGroup, removedId, false);
      }

      // Quita el checkbox de ese source
      if (replicateGroup.contains(key)) {
        replicateGroup.removeControl(key);
      }
    });

    // 3) Ahora sí elimina el contacto de logística
    this.internationalLogisticsContactsArray.removeAt(index);

    // 4) Refresca los checkboxes de replicación
    this.syncReplicateFromLogistics();
  }



  // Equivalente a `replicateFromPrincipal`
  replicatePrincipalToAll(): void {
    const principalContact = this.groupDatosComerciales.get('contactoPrincipal') as FormGroup;

    //contactGroup.get('replicateFromPrincipal')?.setValue(checked, { emitEvent: false }); // Evita ciclo infinito

    // this.groupDatosComerciales
    //   .get('internationalLogisticsContacts.name')
    //   ?.setValue(principalContact.get('nombre')?.value);


    let isreplica = principalContact.get('replicateFromPrincipalall').value

    let contactGroup: FormGroup
    contactGroup = this.getFormGroup(this.groupDatosComerciales.get('internationalLogisticsContacts'))

    let contactGroup2: FormGroup
    contactGroup2 = this.getFormGroup(this.groupDatosComerciales.get('billingContact'))


    let contactGroup3: FormGroup
    contactGroup3 = this.getFormGroup(this.groupDatosComerciales.get('operationsContacts'))

    //const replicateGroup = opControl.get('replicateFromLogistics') as FormGroup;

    //const replicateControls = operationsContactGroup.get('replicateFromLogistics') as FormGroup;





    if (isreplica == true) {
      this.groupDatosComerciales.get('checkOpcionalILC')?.setValue(false)
      this.groupDatosComerciales.get('billingContact.checkOpcional')?.setValue(false)
      this.groupDatosComerciales.get('checkOpcionalOC')?.setValue(false)

      contactGroup.controls[0]?.get('name')?.setValue(principalContact.get('nombre')?.value);
      contactGroup.controls[0]?.get('lastName')?.setValue(principalContact.get('apellido')?.value);
      contactGroup.controls[0]?.get('position')?.setValue(principalContact.get('puesto')?.value);
      contactGroup.controls[0]?.get('phone')?.setValue(principalContact.get('telefono')?.value);
      contactGroup.controls[0]?.get('lastName')?.setValue(principalContact.get('apellido')?.value);
      contactGroup.controls[0]?.get('birthday')?.setValue(principalContact.get('cumpleanos')?.value);
      contactGroup.controls[0]?.get('email')?.setValue(principalContact.get('email')?.value);
      // contactGroup.get('emailTypes')?.setValue([]); // Limpia los tipos de correo al replicar



      contactGroup2?.get('name')?.setValue(principalContact.get('nombre')?.value);
      contactGroup2?.get('lastName')?.setValue(principalContact.get('apellido')?.value);
      contactGroup2?.get('position')?.setValue(principalContact.get('puesto')?.value);
      contactGroup2?.get('phone')?.setValue(principalContact.get('telefono')?.value);
      contactGroup2?.get('lastName')?.setValue(principalContact.get('apellido')?.value);
      contactGroup2?.get('birthday')?.setValue(principalContact.get('cumpleanos')?.value);
      contactGroup2?.get('email')?.setValue(principalContact.get('email')?.value);



      contactGroup3?.controls[0]?.get('name')?.setValue(contactGroup2.get('name')?.value);
      contactGroup3?.controls[0]?.get('lastName')?.setValue(contactGroup2.get('lastName')?.value);
      contactGroup3?.controls[0]?.get('position')?.setValue(contactGroup2.get('position')?.value);
      contactGroup3?.controls[0]?.get('phone')?.setValue(contactGroup2.get('phone')?.value);
      contactGroup3?.controls[0]?.get('lastName')?.setValue(contactGroup2.get('lastName')?.value);
      contactGroup3?.controls[0]?.get('birthday')?.setValue(contactGroup2.get('birthday')?.value);
      contactGroup3?.controls[0]?.get('email')?.setValue(contactGroup2.get('email')?.value);



    } else {

      this.groupDatosComerciales.get('checkOpcionalILC')?.setValue(true)
      this.groupDatosComerciales.get('billingContact.checkOpcional')?.setValue(true)
      this.groupDatosComerciales.get('checkOpcionalOC')?.setValue(true)

      contactGroup.controls[0]?.get('name')?.setValue('');
      contactGroup.controls[0]?.get('lastName')?.setValue('');
      contactGroup.controls[0]?.get('position')?.setValue('');
      contactGroup.controls[0]?.get('phone')?.setValue('');
      contactGroup.controls[0]?.get('lastName')?.setValue('');
      contactGroup.controls[0]?.get('birthday')?.setValue('');
      contactGroup.controls[0]?.get('email')?.setValue('');
      // contactGroup.get('emailTypes')?.setValue([]); // Limpia los tipos de correo al replicar



      contactGroup2?.get('name')?.setValue('');
      contactGroup2?.get('lastName')?.setValue('');
      contactGroup2?.get('position')?.setValue('');
      contactGroup2?.get('phone')?.setValue('');
      contactGroup2?.get('lastName')?.setValue('');
      contactGroup2?.get('birthday')?.setValue('');
      contactGroup2?.get('email')?.setValue('');


      contactGroup3?.get('name')?.setValue('');
      contactGroup3?.get('lastName')?.setValue('');
      contactGroup3?.get('position')?.setValue('');
      contactGroup3?.get('phone')?.setValue('');
      contactGroup3?.get('lastName')?.setValue('');
      contactGroup3?.get('birthday')?.setValue('');
      contactGroup3?.get('email')?.setValue('');



    }

    // contactGroup.get('name')?.enable();
    // contactGroup.get('lastName')?.enable();
    // contactGroup.get('position')?.enable();
    // contactGroup.get('phone')?.enable();
    // contactGroup.get('birthday')?.enable();
    // contactGroup.get('email')?.enable();
    // contactGroup.get('emailTypes')?.enable();
    // // Opcional: limpiar los valores al desmarcar la replicación
    // contactGroup.reset();

  }



  syncReplicateFromLogistics() {
    const logisticsIds = this.internationalLogisticsContactsArray.controls.map(c => c.get('id')?.value);

    this.operationsContactsArray.controls.forEach(opControl => {
      const replicateGroup = opControl.get('replicateFromLogistics') as FormGroup;

      logisticsIds.forEach(logId => {
        const key = `log_contact_${logId}`;
        if (!replicateGroup.contains(key)) {
          replicateGroup.addControl(key, new FormControl(false));
        }
      });
    });
  }

  // Equivalente a `replicateFromPrincipal`
  replicatePrincipalToLogistics(contactGroup: FormGroup, checked: boolean): void {
    const principalContact = this.groupDatosComerciales.get('contactoPrincipal') as FormGroup;

    contactGroup.get('replicateFromPrincipal')?.setValue(checked, { emitEvent: false }); // Evita ciclo infinito

    if (checked) {
      contactGroup.get('name')?.setValue(principalContact.get('nombre')?.value);
      contactGroup.get('lastName')?.setValue(principalContact.get('apellido')?.value);
      contactGroup.get('position')?.setValue(principalContact.get('puesto')?.value);
      contactGroup.get('phone')?.setValue(principalContact.get('telefono')?.value);
      contactGroup.get('birthday')?.setValue(principalContact.get('cumpleanos')?.value);
      contactGroup.get('email')?.setValue(principalContact.get('email')?.value);
      // contactGroup.get('emailTypes')?.setValue([]); // Limpia los tipos de correo al replicar

      contactGroup.get('name')?.disable();
      contactGroup.get('lastName')?.disable();
      contactGroup.get('position')?.disable();
      contactGroup.get('phone')?.disable();
      contactGroup.get('birthday')?.disable();
      contactGroup.get('email')?.disable();
      // contactGroup.get('emailTypes')?.disable();
    } else {
      contactGroup.get('name')?.enable();
      contactGroup.get('lastName')?.enable();
      contactGroup.get('position')?.enable();
      contactGroup.get('phone')?.enable();
      contactGroup.get('birthday')?.enable();
      contactGroup.get('email')?.enable();
      contactGroup.get('emailTypes')?.enable();
      // Opcional: limpiar los valores al desmarcar la replicación
      contactGroup.reset();
    }
  }


  replicatePrincipalFacturcion(contactGroup: FormGroup, checked: boolean): void {
    const principalContact = this.groupDatosComerciales.get('contactoPrincipal') as FormGroup;

    contactGroup.get('replicateFromPrincipal')?.setValue(checked, { emitEvent: false }); // Evita ciclo infinito

    if (checked) {
      contactGroup.get('name')?.setValue(principalContact.get('nombre')?.value);
      contactGroup.get('lastName')?.setValue(principalContact.get('apellido')?.value);
      contactGroup.get('position')?.setValue(principalContact.get('puesto')?.value);
      contactGroup.get('phone')?.setValue(principalContact.get('telefono')?.value);
      contactGroup.get('birthday')?.setValue(principalContact.get('cumpleanos')?.value);
      contactGroup.get('email')?.setValue(principalContact.get('email')?.value);
      // contactGroup.get('emailTypes')?.setValue([]); // Limpia los tipos de correo al replicar

      // contactGroup.get('name')?.disable();
      // contactGroup.get('lastName')?.disable();
      // contactGroup.get('position')?.disable();
      // contactGroup.get('phone')?.disable();
      // contactGroup.get('birthday')?.disable();
      // contactGroup.get('email')?.disable();
      // contactGroup.get('emailTypes')?.disable();
    } else {
      contactGroup.get('name')?.enable();
      contactGroup.get('lastName')?.enable();
      contactGroup.get('position')?.enable();
      contactGroup.get('phone')?.enable();
      contactGroup.get('birthday')?.enable();
      contactGroup.get('email')?.enable();
      contactGroup.get('emailTypes')?.enable();
      // Opcional: limpiar los valores al desmarcar la replicación
      contactGroup.reset();
    }
  }

  haceropcionallogistica(contactGroup: FormGroup, checked: boolean, phaceropcionallogistica): void {
    const principalContact = this.groupDatosComerciales.get('contactoPrincipal') as FormGroup;

    // contactGroup.get('replicateFromPrincipal')?.setValue(checked, { emitEvent: false }); // Evita ciclo infinito

    if (!checked) {
      contactGroup.get('name')?.setValue('');
      contactGroup.get('lastName')?.setValue('');
      contactGroup.get('position')?.setValue('');
      contactGroup.get('phone')?.setValue('');
      contactGroup.get('birthday')?.setValue('');
      contactGroup.get('email')?.setValue('');
      // contactGroup.get('emailTypes')?.setValue([]); // Limpia los tipos de correo al replicar

      contactGroup.get('name')?.disable();
      contactGroup.get('lastName')?.disable();
      contactGroup.get('position')?.disable();
      contactGroup.get('phone')?.disable();
      contactGroup.get('birthday')?.disable();
      contactGroup.get('email')?.disable();
      contactGroup.get('emailTypes')?.disable();
    } else {
      contactGroup.get('name')?.enable();
      contactGroup.get('lastName')?.enable();
      contactGroup.get('position')?.enable();
      contactGroup.get('phone')?.enable();
      contactGroup.get('birthday')?.enable();
      contactGroup.get('email')?.enable();
      contactGroup.get('emailTypes')?.enable();
      // Opcional: limpiar los valores al desmarcar la replicación
      contactGroup.reset();
    }
  }

  // --- Métodos para gestionar Contactos de Operaciones---
  createOperationsContactGroup(initialData?: Partial<OperationsContact>): FormGroup {
    const id = initialData?.id?.toString() || uuidv4();

    // Manejar el objeto de replicación de logística
    let replicateFromLogisticsControls = {};
    let selectedLogId: string | null = null;

    if (initialData?.replicateFromLogistics) {
      for (const key in initialData.replicateFromLogistics) {
        replicateFromLogisticsControls[key] = new FormControl(initialData.replicateFromLogistics[key]);
        if (initialData.replicateFromLogistics[key]) {
          selectedLogId = key.replace('log_contact_', '');
        }
      }
    } else {
      replicateFromLogisticsControls = this.internationalLogisticsContactsArray.controls.reduce((acc, control) => {
        const logId = control.get('id')?.value;
        acc[`log_contact_${logId}`] = new FormControl(false);
        return acc;
      }, {} as any);
    }

    const replicateFromLogistics = new FormGroup(replicateFromLogisticsControls);

    // NUEVA LÓGICA: Llama a la función de estado compartido si se carga un valor seleccionado
    if (selectedLogId) {
      this._setReplicationCheckboxesState(replicateFromLogistics, selectedLogId);
    }

    // El resto de la lógica de "shouldDisable" se mantiene igual
    const shouldDisable = selectedLogId !== null;

    // --- Solución para la fecha: convertir la cadena a objeto Date ---
    const birthday = initialData?.birthday ? new Date(initialData.birthday) : null;

    return new FormGroup({
      id: new FormControl({ value: id, disabled: true }),
      replicateFromLogistics: replicateFromLogistics,
      name: new FormControl({ value: initialData?.name || null, disabled: shouldDisable }, [Validators.required, this.minLettersValidator]),
      lastName: new FormControl({ value: initialData?.lastName || null, disabled: shouldDisable }, [Validators.required, this.minLettersValidator]),
      //  position: new FormControl({ value: initialData?.position || null, disabled: shouldDisable }, [Validators.required, this.minLettersValidator]),
      position: new FormControl({ value: initialData?.position || null, disabled: shouldDisable }, this.minLettersValidator),
      phone: new FormControl({ value: initialData?.phone || null, disabled: shouldDisable }, [Validators.required, this.phoneValidator]),
      birthday: new FormControl({ value: birthday || null, disabled: shouldDisable }),
      email: new FormControl({ value: initialData?.email || null, disabled: shouldDisable }, [Validators.required, this.multiEmailTrimmedValidator]),
      emailTypes: new FormGroup({
        mandato: new FormControl({ value: initialData?.emailTypes?.mandato || false, disabled: shouldDisable }),
        otrosTraficos: new FormControl({ value: initialData?.emailTypes?.otrosTraficos || false, disabled: shouldDisable }),
        exportacion: new FormControl({ value: initialData?.emailTypes?.exportacion || false, disabled: shouldDisable }),
      }, [this.atLeastOneEmailTypeValidator]),
    });
  }

  replicateLogisticsToOperations(operationsContactGroup: FormGroup, logContactId: string, checked: boolean): void {
    // Encuentra el contacto de logística correspondiente
    const logisticsContactGroup = this.internationalLogisticsContactsArray.controls.find(
      (control) => control.get('id')?.value === logContactId
    ) as FormGroup;


    if (!logisticsContactGroup) {
      return; // Si no se encuentra el contacto de logística, no se hace nada
    }
    // Deshabilita todos los otros checkboxes en la misma sección de replicación
    const replicateControls = operationsContactGroup.get('replicateFromLogistics') as FormGroup;

    Object.keys(replicateControls.controls).forEach(key => {
      if (key !== `log_contact_${logContactId}`) {
        replicateControls.get(key)?.disable({ emitEvent: false });
      }
    });

    // Habilita el control actual si es necesario (el checkbox)
    replicateControls.get(`log_contact_${logContactId}`)?.enable({ emitEvent: false });

    // console.log("Valores de logística antes de copiar:", logisticsContactGroup.value);
    //  console.log("Valores de operaciones antes de copiar:", operationsContactGroup.value);

    if (checked) {
      logisticsContactGroup.get('replicateToOperations')?.setValue(true, { emitEvent: false });
      // console.log("checked 1", checked);
      //  console.log("Replicando desde logística a operaciones para el contacto:", logContactId);
      // Replicar los campos del contacto de logística al de operaciones
      operationsContactGroup.get('name')?.setValue(logisticsContactGroup.get('name')?.value);
      operationsContactGroup.get('lastName')?.setValue(logisticsContactGroup.get('lastName')?.value);
      operationsContactGroup.get('position')?.setValue(logisticsContactGroup.get('position')?.value);
      operationsContactGroup.get('phone')?.setValue(logisticsContactGroup.get('phone')?.value);
      operationsContactGroup.get('birthday')?.setValue(logisticsContactGroup.get('birthday')?.value);
      operationsContactGroup.get('email')?.setValue(logisticsContactGroup.get('email')?.value);

      // Replicar los emailTypes
      const logisticsEmailTypes = logisticsContactGroup.get('emailTypes') as FormGroup;
      const operationsEmailTypes = operationsContactGroup.get('emailTypes') as FormGroup;
      Object.keys(logisticsEmailTypes.controls).forEach(key => {
        operationsEmailTypes.get(key)?.setValue(logisticsEmailTypes.get(key)?.value);
      });

      // Deshabilitar los campos del contacto de operaciones
      // operationsContactGroup.get('name')?.disable();
      // operationsContactGroup.get('lastName')?.disable();
      // operationsContactGroup.get('position')?.disable();
      // operationsContactGroup.get('phone')?.disable();
      // operationsContactGroup.get('birthday')?.disable();
      // operationsContactGroup.get('email')?.disable();
      // operationsContactGroup.get('emailTypes')?.disable(); // Se deshabilitan porque son parte de la replicación

      // 👉 Debug: mostrar estado actual de todos los checkboxes
      Object.keys(replicateControls.controls).forEach(key => {
        const control = replicateControls.get(key);
        console.log(
          `Checkbox ${key} - disabled: ${control?.disabled} - enabled: ${control?.enabled} - value: ${control?.value}`
        );
      });

    } else {
      logisticsContactGroup.get('replicateToOperations')?.setValue(false, { emitEvent: false });
      console.log("checked 2", checked);
      console.log("Replicando desde logística a operaciones para el contacto:", logContactId);
      // Si se deselecciona, habilita todos los campos
      operationsContactGroup.get('name')?.enable();
      operationsContactGroup.get('lastName')?.enable();
      operationsContactGroup.get('position')?.enable();
      operationsContactGroup.get('phone')?.enable();
      operationsContactGroup.get('birthday')?.enable();
      operationsContactGroup.get('email')?.enable();
      operationsContactGroup.get('emailTypes')?.enable();

      // Habilita todos los otros checkboxes de replicación
      Object.keys(replicateControls.controls).forEach(key => {
        replicateControls.get(key)?.enable({ emitEvent: false });
      });

      // 👉 Debug: mostrar estado actual de todos los checkboxes
      Object.keys(replicateControls.controls).forEach(key => {
        const control = replicateControls.get(key);
        console.log(
          `Checkbox ${key} - disabled: ${control?.disabled} - enabled: ${control?.enabled} - value: ${control?.value}`
        );
      });

      const preserveId = operationsContactGroup.get('id')?.value;

      // limpia solo los campos de datos
      operationsContactGroup.patchValue({
        name: null,
        lastName: null,
        position: null,
        phone: null,
        birthday: null,
        email: null,
        emailTypes: {
          mandato: false,
          otrosTraficos: false,
          exportacion: false
        }
      });

      // vuelve a poner el id (si no lo deshabilitaste arriba)
      operationsContactGroup.get('id')?.setValue(preserveId);
    }
  }

  addNewOperationsContact(): void {
    this.operationsContactsArray.push(this.createOperationsContactGroup());
  }

  hasReplication(contactGroup: AbstractControl): boolean {
    const replicateGroup = contactGroup.get('replicateFromLogistics') as FormGroup;
    return Object.values(replicateGroup?.value || {}).some((v: boolean) => v === true);
  }

  hasAnyValue(type: 'principal' | 'logistics' | 'operations' | 'initial', group?: FormGroup): boolean {
    if (type === 'initial') {
      return true;
    }
    let keys: string[] = [];

    switch (type) {
      case 'principal':
        keys = ['nombre', 'apellido', 'puesto', 'telefono', 'cumpleanos', 'email'];
        break;
      case 'logistics':
      case 'operations':
        keys = ['name', 'lastName', 'position', 'phone', 'birthday', 'email'];
        break;
    }

    return keys.some(key => {
      const control = group.get(key);
      if (!control) return false;
      const value = control.value;

      // Chequeo más estricto: ignora strings vacías o solo espacios
      return value !== null && value !== undefined && String(value).trim() !== '';
    });
  }

  removeOperationsContact(index: number): void {
    this.operationsContactsArray.removeAt(index);
  }

  private setupPrincipalReplication() {
    const principal = this.groupDatosComerciales.get('contactoPrincipal') as FormGroup;

    principal.valueChanges.subscribe(values => {
      this.internationalLogisticsContactsArray.controls.forEach((logContact: FormGroup) => {
        if (logContact.get('replicateFromPrincipal')?.value) {
          logContact.patchValue({
            name: values.nombre,
            lastName: values.apellido,
            position: values.puesto,
            phone: values.telefono,
            birthday: values.cumpleanos,
            email: values.email,
          }, { emitEvent: false });

          // 👇 Llamamos explícitamente a la replicación hacia operaciones
          this.pushLogisticsToOperations(logContact);
        }
      });
    });
  }

  // Nueva helper: fuerza actualización hacia operaciones
  private pushLogisticsToOperations(logContact: FormGroup) {
    const replicateToOps = logContact.get('replicateToOperations')?.value;
    if (!replicateToOps) return;

    const logId = logContact.get('id')?.value;
    const logValues = logContact.getRawValue();

    this.operationsContactsArray.controls.forEach((opContact: FormGroup) => {
      const replicateFromLogistics = opContact.get('replicateFromLogistics') as FormGroup;
      const replicate = replicateFromLogistics?.get(`log_contact_${logId}`)?.value;

      if (replicate) {
        opContact.patchValue({
          name: logValues.name,
          lastName: logValues.lastName,
          position: logValues.position,
          phone: logValues.phone,
          birthday: logValues.birthday,
          email: logValues.email,
        }, { emitEvent: false });

        const emailTypesGroup = opContact.get('emailTypes') as FormGroup;
        if (emailTypesGroup && logValues.emailTypes) {
          emailTypesGroup.patchValue(logValues.emailTypes, { emitEvent: false });
        }
      }
    });
  }

  private setupLogisticsReplicationForContact(logContact: FormGroup) {
    logContact.valueChanges.subscribe(() => {
      const replicateToOps = logContact.get('replicateToOperations')?.value;
      if (!replicateToOps) return;

      const logId = logContact.get('id')?.value;
      const logValues = logContact.getRawValue(); // ✅ siempre incluye todo, incluso disabled

      this.operationsContactsArray.controls.forEach((opContact: FormGroup) => {
        const replicateFromLogistics = opContact.get('replicateFromLogistics') as FormGroup;
        const replicate = replicateFromLogistics?.get(`log_contact_${logId}`)?.value;

        if (replicate) {
          // patch con valores completos
          opContact.patchValue({
            name: logValues.name,
            lastName: logValues.lastName,
            position: logValues.position,
            phone: logValues.phone,
            birthday: logValues.birthday,
            email: logValues.email,
          }, { emitEvent: false });

          // subgrupo emailTypes
          const emailTypesGroup = opContact.get('emailTypes') as FormGroup;
          if (emailTypesGroup && logValues.emailTypes) {
            emailTypesGroup.patchValue(logValues.emailTypes, { emitEvent: false });
          }
        }
      });
    });
  }


  private _setReplicationCheckboxesState(replicateControls: FormGroup, selectedId: string | null): void {
    Object.keys(replicateControls.controls).forEach(key => {
      // Si hay un ID seleccionado y la clave no coincide, deshabilita el control.
      // Si no hay ID seleccionado (uncheck), habilita todos los controles.
      const shouldBeDisabled = selectedId !== null && key !== `log_contact_${selectedId}`;
      if (shouldBeDisabled) {
        replicateControls.get(key)?.disable({ emitEvent: false });
      } else {
        replicateControls.get(key)?.enable({ emitEvent: false });
      }
    });
  }


  multiEmailTrimmedValidator(control: FormControl): { [key: string]: any } | null {
    if (control.value) {
      const emails = control.value.split(';').map((email: string) => email.trim());
      const invalidEmails = emails.filter((email: string) => !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email));
      return invalidEmails.length > 0 ? { 'invalidEmails': { value: control.value } } : null;
    }
    return null;
  }

  // Validador de teléfono peruano (9 dígitos solo numéricos)
  // phoneValidator(control: FormControl): { [key: string]: any } | null {
  //   const value = control.value;
  //   if (value && !/^\d{9}$/.test(value)) {
  //     return { invalidPhone: true };
  //   }
  //   return null;
  // }

  phoneValidator(control: FormControl): { [key: string]: any } | null {

    const value = control.value;

    if (!value) return null;

    // Permite + al inicio, números y espacios
    const phoneRegex = /^\+?\d[\d\s]*$/;

    if (!phoneRegex.test(value)) {
      return { invalidPhone: true };
    }

    return null;
  }

  // Validador de mínimo 3 letras (solo letras, no espacios ni números)
  minLettersValidator(control: FormControl): { [key: string]: any } | null {
    const value = control.value;
    if (value && (!/^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]+$/.test(value) || value?.trim()?.length < 2)) {
      return { minLetters: true };
    }
    return null;
  }

  minLettersOrNumbersValidator(control: AbstractControl): ValidationErrors | null {
    const value: string = control.value;
    const minimumCharacters: number = 3; // Aquí se define el mínimo de letras o números requeridos.

    // Si el valor es nulo, indefinido o una cadena vacía, lo consideramos válido
    // para permitir que `Validators.required` maneje la obligatoriedad.
    if (!value) {
      return null;
    }

    // 1. Eliminar todos los espacios en blanco de la cadena.
    // 2. Contar la longitud de la cadena resultante.
    const cleanedValue = value.replace(/\s/g, '');

    // Si la longitud de la cadena sin espacios es menor que el mínimo requerido,
    // devolvemos un objeto de error.
    if (cleanedValue.length < minimumCharacters) {
      return { minLettersOrNumbers: { required: minimumCharacters, actual: cleanedValue.length } };
    }

    // Si pasa la validación, devuelve null.
    return null;
  }

  // Validador: Mínimo 3 dígitos
  minDigitsValidator(min: number) {
    return (control: FormControl): { [key: string]: any } | null => {
      const value = control.value;
      if (value && (value.toString().trim().length < min || !/^\d+$/.test(value))) {
        return { 'minDigits': { requiredLength: min, actualLength: value.toString().trim().length } };
      }
      return null;
    };
  }
  validacionTypesEmails: boolean = false;
  // Validador personalizado para asegurar que al menos un checkbox de emailTypes esté seleccionado
  atLeastOneEmailTypeValidator = (group: FormGroup): ValidationErrors | null => {
    const { mandato, otrosTraficos, exportacion } = group.value;
    if (mandato || otrosTraficos || exportacion) {
      this.validacionTypesEmails = false
      return null
    }
    this.validacionTypesEmails = true
    return { atLeastOneEmailType: true };
  };

  // Método para manejar la creación al enviar el formulario
  async onSubmitComercial(codigoCreado?: number) {
    // console.log('Formulario Comercial value:', this.groupDatosComerciales.value);

    // console.log('Formulario Comercial getRawValue:', this.groupDatosComerciales.getRawValue());

    if (this.groupDatosComerciales.valid) {
      // console.log("validado en comercial")
      const formValue = this.groupDatosComerciales.getRawValue();
      const formData: ComercialDataRequest = {
        ENTC_Codigo: this.modo === 'EDITAR' ? this.entC_Codigo : codigoCreado,
        contactoPrincipal: formValue.contactoPrincipal.checkOpcional ? null : formValue.contactoPrincipal,
        billingContact: formValue.billingContact.checkOpcional ? null : formValue.billingContact,
        // Si el checkbox está desmarcado, se envían los arrays
        internationalLogisticsContacts: formValue.checkOpcionalILC ? [] : formValue.internationalLogisticsContacts,
        operationsContacts: formValue.checkOpcionalOC ? [] : formValue.operationsContacts,
      };

      // Ahora puedes eliminar los checkboxes del payload para que la API no los reciba
      if (formData.contactoPrincipal) {
        delete formData.contactoPrincipal.checkOpcional;
      }
      if (formData.billingContact) {
        delete formData.billingContact.checkOpcional;
      }
      let mensajeResultado = "";
      // console.log('Datos Comerciales a enviar:', formData);
      if (this.modo === 'EDITAR') {
        this.proformaService.ActualizarDatosComerciales(formData).subscribe({
          next: (response) => {
            mensajeResultado = response.meta.mensaje;
          },
          error: (err) => {
            const mensaje = err.error?.meta?.mensaje || 'Ocurrió un error al guardar los datos.';
            this.messageService.add({ key: 'toast1', severity: 'error', summary: 'Error', detail: mensaje });
            console.error('Error en la creación:', err);
          }
        });
        //!Solo hay validación si hay archivos seleccionados, pero si quiere eliminarlo y dejarlo si archivo, pues no se ha implementado.
        if (this.archivosSeleccionado.length > 0) {
          if (this.sinArchivoInicial) {
            const result = await this.guardarCustomerProfile(codigoCreado)
            if (result) {
              mensajeResultado += " y Customer Profile guardado exitosamente"
              this.salir()
              this.util.ShowMessage({
                titulo: "Éxito",
                autocerrar: true,
                tiempo: 5000,
                mensaje: mensajeResultado,
                tipo: "ok"
              })
              // Opcional: limpiar el formulario o redirigir
              this.groupDatosComerciales.reset();
              this.internationalLogisticsContactsArray.clear();
              this.operationsContactsArray.clear();
              this.addNewLogisticsContact()
              this.addNewOperationsContact()
            } else {
              mensajeResultado += " pero error al guardar Customer Profile"
              this.messageService.add({ key: 'toast1', severity: 'warn', summary: 'Warn', detail: mensajeResultado });
            }
          } else {
            const result = await this.actualizarCustomerProfile()
            if (result) {
              mensajeResultado += " y Customer Profile actualizado exitosamente"
              this.salir()
              this.util.ShowMessage({
                titulo: "Éxito",
                autocerrar: true,
                tiempo: 5000,
                mensaje: mensajeResultado,
                tipo: "ok"
              })
              // Opcional: limpiar el formulario o redirigir
              this.groupDatosComerciales.reset();
              this.internationalLogisticsContactsArray.clear();
              this.operationsContactsArray.clear();
              this.addNewLogisticsContact()
              this.addNewOperationsContact()
            } else {
              mensajeResultado += " pero error al actualizar Customer Profile"
              this.messageService.add({ key: 'toast1', severity: 'warn', summary: 'Warn', detail: mensajeResultado });
            }
          }
        }
      } else {
        this.proformaService.CrearDatosComerciales(formData).subscribe({
          next: (response) => {
            mensajeResultado = response.meta.mensaje || "Datos comerciales guardados exitosamente";
          },
          error: (err) => {
            const mensaje = err.error?.meta?.mensaje || 'Ocurrió un error al guardar los datos.';
            this.messageService.add({ key: 'toast1', severity: 'error', summary: 'Error al guardar', detail: mensaje });
            console.error('Error en la creación:', err);
          }
        });
        if (this.archivosSeleccionado.length > 0) {
          const result = await this.guardarCustomerProfile(codigoCreado)
          if (result) {
            mensajeResultado += " y Customer Profile guardado exitosamente"
            this.salir()
            this.util.ShowMessage({
              titulo: "Éxito",
              autocerrar: true,
              tiempo: 5000,
              mensaje: mensajeResultado,
              tipo: "ok"
            })
            // Opcional: limpiar el formulario o redirigir
            this.groupDatosComerciales.reset();
            this.internationalLogisticsContactsArray.clear();
            this.operationsContactsArray.clear();
            this.addNewLogisticsContact()
            this.addNewOperationsContact()
          } else {
            mensajeResultado += " pero error al guardar Customer Profile"
            this.messageService.add({ key: 'toast1', severity: 'warn', summary: 'Warn', detail: mensajeResultado });
          }
        }
      }
    }
  }
  private markAllControlsAsTouched(formGroup: FormGroup | FormArray): void {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      if (control instanceof FormGroup || control instanceof FormArray) {
        this.markAllControlsAsTouched(control);
      } else {
        control?.markAsTouched();
      }
    });
  }
  /**
   * Recorre recursivamente un FormGroup y muestra mensajes de validación.
   */
  private showValidationMessagesForGroup(formGroup: FormGroup): void {
    this.messageService.clear();
    const invalidControls: string[] = this.getInvalidControls(formGroup);

    if (invalidControls.length > 4) {
      this.messageService.add({
        key: 'toast1',
        severity: 'warn',
        summary: 'Atención',
        detail: 'Por favor, llene los campos marcados para continuar.'
      });
    } else if (invalidControls.length > 0) {
      invalidControls.forEach(key => {
        const control = this.getControlByPath(formGroup, key) as FormControl;
        const errors = control.errors;
        let errorMessage = '';

        if (errors) {
          const fieldName = this.getFieldNameComercial(key);

          if (errors['required']) {
            errorMessage = `'${fieldName}' es obligatorio.`;
          } else if (errors['minLetters']) {
            errorMessage = `'${fieldName}' debe contener al menos 3 letras.`;
          } else if (errors['phoneValidator']) {
            errorMessage = `'${fieldName}' no es un número de teléfono válido.`;
          } else if (errors['invalidEmails']) {
            errorMessage = `'${fieldName}' contiene uno o más correos electrónicos inválidos.`;
          } else if (errors['atLeastOneEmailTypeValidator']) {
            errorMessage = `'${fieldName}' debe tener al menos un tipo de correo electrónico seleccionado.`;
          }
          // Agrega más validadores según sea necesario
          if (this.validacionTypesEmails) {
            errorMessage = `Falta seleccionar un tipo de correo electrónico.`;
          }

          if (errorMessage) {
            this.messageService.add({
              key: 'toast1',
              severity: 'error',
              summary: 'Error de Validación',
              detail: errorMessage
            });
          }
        }
      });
    } else {
      let errorMessage2: string
      // Agrega más validadores según sea necesario
      if (this.validacionTypesEmails) {
        errorMessage2 = `Falta seleccionar un tipo de correo electrónico.`;
      }

      if (errorMessage2) {
        this.messageService.add({
          key: 'toast1',
          severity: 'error',
          summary: 'Error de Validación',
          detail: errorMessage2
        });
      }
    }
  }

  /**
   * Obtiene la ruta de todos los controles inválidos de un FormGroup.
   * La ruta permite identificar campos anidados (ej: 'contactoPrincipal.nombre').
   */
  // private getInvalidControls(formGroup: FormGroup | FormArray, parentPath: string = ''): string[] {
  //   let invalidControls: string[] = [];

  //   // Recorre los controles del FormGroup o FormArray
  //   Object.keys(formGroup.controls).forEach((key, index) => {
  //     const control = formGroup.get(key);
  //     // Si el control es parte de un FormArray, el path debe incluir el índice
  //     const path = (formGroup instanceof FormArray) ? `${parentPath}[${index}].${key}` : `${parentPath}${parentPath ? '.' : ''}${key}`;

  //     if (control instanceof FormGroup || control instanceof FormArray) {
  //       // Si el control es un grupo o un array, llama a la función de nuevo (recursión)
  //       invalidControls = invalidControls.concat(this.getInvalidControls(control, path));
  //     } else if (control?.invalid) {
  //       // Si el control es inválido, agrega su ruta a la lista
  //       invalidControls.push(path);
  //     }
  //   });

  //   return invalidControls;
  // }


  getInvalidControls(form: FormGroup | FormArray, parentPath: string = ''): string[] {
    let invalidControls: string[] = [];

    // Si es un FormGroup
    if (form instanceof FormGroup) {
      Object.keys(form.controls).forEach(key => {
        const control = form.get(key);
        const path = parentPath ? `${parentPath}.${key}` : key;

        if (control instanceof FormGroup || control instanceof FormArray) {
          invalidControls = invalidControls.concat(this.getInvalidControlsDetails(control, path));
        } else if (control && control.invalid) {
          //  console.log('❌ Inválido:', path);
          invalidControls.push(path);
        }
      });
    }

    // Si es un FormArray
    else if (form instanceof FormArray) {
      form.controls.forEach((control, index) => {
        const path = `${parentPath}[${index}]`;

        if (control instanceof FormGroup || control instanceof FormArray) {
          invalidControls = invalidControls.concat(this.getInvalidControlsDetails(control, path));
          // console.log('❌ Inválido:', path);
        } else if (control && control.invalid) {
          //  console.log('❌ Inválido:', path);
          invalidControls.push(path);
        }
      });
    }

    return invalidControls;
  }



  getInvalidControlsDetails(form: FormGroup | FormArray, parentPath: string = ''): string[] {
    let invalidControlsDetails: string[] = [];

    // Si es un FormGroup
    if (form instanceof FormGroup) {
      Object.keys(form.controls).forEach(key => {
        const control = form.get(key);
        const path = parentPath ? `${parentPath}.${key}` : key;

        if (control instanceof FormGroup || control instanceof FormArray) {
          //    console.log('❌ Inválido:', path);
          //  invalidControlsDetails = invalidControlsDetails.concat(this.getInvalidControls(control, path));
        } else if (control && control.invalid) {
          //   console.log('❌ Inválido:', path);
          invalidControlsDetails.push(path);
        }
      });
    }

    // Si es un FormArray
    else if (form instanceof FormArray) {
      form.controls.forEach((control, index) => {
        const path = `${parentPath}[${index}]`;

        if (control instanceof FormGroup || control instanceof FormArray) {
          //('❌ Inválido:', path);
          // invalidControlsDetails = invalidControlsDetails.concat(this.getInvalidControls(control, path));
          //console.log('❌ Inválido:', path);
        } else if (control && control.invalid) {
          // console.log('❌ Inválido:', path);
          invalidControlsDetails.push(path);
        }
      });
    }

    return invalidControlsDetails;
  }



  /**
   * Recupera un FormControl a partir de su ruta completa.
   */
  private getControlByPath(formGroup: FormGroup, path: string): FormControl | null {
    const parts = path.split('.');
    let control: any = formGroup;
    for (const part of parts) {
      if (control instanceof FormGroup || control instanceof FormArray) {
        control = control.get(part);
      } else {
        return null;
      }
    }
    return control;
  }

  private getFieldNameComercial(key: string): string {
    const names = {
      // Contacto Principal
      'contactoPrincipal.nombre': 'Nombre Contacto Principal',
      'contactoPrincipal.apellido': 'Apellido Contacto Principal',
      'contactoPrincipal.puesto': 'Puesto Contacto Principal',
      'contactoPrincipal.telefono': 'Teléfono Contacto Principal',
      'contactoPrincipal.email': 'Email Contacto Principal',
      // Contacto de Facturación
      'billingContact.name': 'Nombre Contacto Facturación',
      'billingContact.lastName': 'Apellido Contacto Facturación',
      'billingContact.position': 'Puesto Contacto Facturación',
      'billingContact.phone': 'Teléfono Contacto Facturación',
      'billingContact.email': 'Email Contacto Facturación',
    };

    // Manejo de nombres para FormArrays
    // Ejemplo: 'internationalLogisticsContacts[0].name'
    const logisticsMatch = key.match(/internationalLogisticsContacts\[(\d+)\].(.*)/);
    if (logisticsMatch) {
      const index = logisticsMatch[1];
      const field = logisticsMatch[2];
      const fieldNameMap = {
        'name': 'Nombre',
        'lastName': 'Apellido',
        'position': 'Puesto',
        'phone': 'Teléfono',
        'email': 'Email',
        'emailTypes': 'Tipos de Correo'
      };
      return `${fieldNameMap[field] || field} (Contacto Logístico ${parseInt(index, 10) + 1})`;
    }

    // Ejemplo: 'operationsContacts[0].name'
    const operationsMatch = key.match(/operationsContacts\[(\d+)\].(.*)/);
    if (operationsMatch) {
      const index = operationsMatch[1];
      const field = operationsMatch[2];
      const fieldNameMap = {
        'name': 'Nombre',
        'lastName': 'Apellido',
        'position': 'Puesto',
        'phone': 'Teléfono',
        'email': 'Email',
        'emailTypes': 'Tipos de Correo'
      };
      return `${fieldNameMap[field] || field} (Contacto de Operaciones ${parseInt(index, 10) + 1})`;
    }

    return names[key] || key;
  }

  //Archivo customer profile
  cargandoArchivos: boolean = false;
  archivosSeleccionado: File[] = [];
  // uploadedFilesComercial: File[] = []; // Para almacenar el archivo cargado

  // Obtiene una referencia al componente p-fileUpload en el HTML
  @ViewChild('fileUploader2') fileUploader2!: FileUpload;

  clearFileSelection() {
    // Llama al método 'clear()' del componente FileUpload
    this.fileUploader2.clear();
    // Limpia también tu array local de archivos
    this.archivosSeleccionado = [];
    // console.log("Archivos eliminados. Lista actual:", this.archivosSeleccionado);
  }

  //!Para eliminar el mensaje de validación de fileUpload, pero como no inserta el archivo, entonces no hay problema
  // clearFileSelection() {
  //   if (this.fileUploader2) {
  //     // Limpia archivos seleccionados
  //     this.fileUploader2.clear();

  //     // Limpia también los mensajes de validación de FileUpload
  //     (this.fileUploader2 as any).msgs = [];

  //     // Limpia el array local
  //     this.archivosSeleccionado = [];

  //     console.log("Archivos eliminados. Lista actual:", this.archivosSeleccionado);
  //   }
  // }

  onSend(event: FileSelectEvent) {
    const files = event.currentFiles;
    this.archivosSeleccionado = files//this.archivosSeleccionado = files
    //console.log("files", this.archivosSeleccionado)
  }

  async guardarCustomerProfile(entc_codigo: number): Promise<boolean | void> {
    // this.btnLoad = true;
    const audi_usrcrea = this.storage.get('codusuario');

    // 1. Guardar uno a uno en la BD
    for (const archivo of this.archivosSeleccionado) {
      const request = {
        entc_codigo: entc_codigo,
        ruta: archivo.name,
        audi_usrcrea: audi_usrcrea
      };

      try {
        await firstValueFrom(this.proformaService.CrearCustomerProfile(request));
      } catch (err) {
        this.messageService.add({ key: 'toast2', severity: 'error', summary: 'Error', detail: 'Error al registrar imagen en la base de datos.' });
        return false;
      }
    }

    // 2. Subir archivos al servidor
    const formData = new FormData();
    for (const archivo of this.archivosSeleccionado) {
      formData.append('archivosSeleccionados', archivo);
    }
    formData.append('carpeta', 'CUSTOMER_PROFILES\\' + entc_codigo.toString());
    formData.append('subcarpeta', 'COMERCIAL');

    this.comisiones.GuardarArchivos(formData).subscribe({
      next: (response: any) => {
        this.messageService.add({ key: 'toast2', severity: 'error', summary: 'Error', detail: 'Error al guardar el archivo físico' });
        return false;
      },
      error: (error) => {
        this.fileUploader.clear();//✅ limpia la UI
        this.archivosSeleccionado = [];
        return true;
      }
    });
  }
  sinArchivoInicial: boolean = false;
  uploadedFilesComercial: any[] = [];
  async obtenerArchivos(): Promise<boolean> {
    this.cargandoArchivos = true; // 🔄 Mostrar spinner
    const request = { entc_codigo: this.entC_Codigo };

    return await firstValueFrom(this.proformaService.ObtenerCustomerProfile(request))
      .then(res => {
        this.uploadedFilesComercial = res.datos.status === 200 ? res.datos.result : [];
        this.groupDatosComerciales.patchValue({
          checkOpcionalCustomerProfile: this.uploadedFilesComercial.length === 0
        }, { emitEvent: true }); // Usar emitEvent para que se disparen las suscripciones
        //(this.uploadedFilesComercial) //itemsObtenerClienteArchivo TIPADO
        this.sinArchivoInicial = this.uploadedFilesComercial.length === 0;
        return res.datos.status === 200;
      })
      .catch(() => {
        this.uploadedFilesComercial = [];
        return false;
      }).finally(() => {
        this.cargandoArchivos = false; // ✅ Ocultar spinner
      });
  }

  async actualizarCustomerProfile(): Promise<boolean | void> {
    const rutarelativa = this.uploadedFilesComercial[0].metadatos?.rutaimagen;
    // 1. Actualizar información en la BD
    for (const archivo of this.archivosSeleccionado) {
      const request = {
        entc_codigo: this.entC_Codigo,
        ruta: archivo.name,
        audi_usrcrea: this.storage.get('codusuario')
      };

      try {
        await firstValueFrom(this.proformaService.ActualizarCustomerProfile(request));
      } catch (err) {
        this.messageService.add({ key: 'toast2', severity: 'error', summary: 'Error', detail: 'Error al actualizar el archivo en la base de datos.' });
        return false;
      }
    }

    // 2. Eliminar físicamente
    const formData = new FormData();
    formData.append('rutarelativa', rutarelativa);

    const responseFS = await firstValueFrom(
      this.comisiones.eliminarArchivoFisico(formData)
    );

    if (responseFS.datos.status !== 200) {
      this.messageService.add({ key: 'toast2', severity: 'warn', summary: 'Warn', detail: 'Se actualizó en BD, pero falló al borrar el archivo físico.' });
      return false;
    }

    // 2. Subir archivos al servidor
    const formDataAgregar = new FormData();
    for (const archivo of this.archivosSeleccionado) {
      formDataAgregar.append('archivosSeleccionados', archivo);
    }
    formDataAgregar.append('carpeta', 'CUSTOMER_PROFILES\\' + this.entC_Codigo.toString());
    formDataAgregar.append('subcarpeta', 'COMERCIAL');

    this.comisiones.GuardarArchivos(formDataAgregar).subscribe({
      next: async (response: any) => {
        this.messageService.add({ key: 'toast2', severity: 'warn', summary: 'Warn', detail: 'Ocurrió un error al gusardar el archivo físico.' });
        return false;
      },
      error: async (error) => {
        this.fileUploader.clear();//✅ limpia la UI
        this.archivosSeleccionado = [];
        // this.btnLoad = false;
        // console.log(error)
        // this.util.ShowMessage({
        //   titulo: '',
        //   mensaje: 'Error al subir los archivos al servidor.',
        //   tipo: 'warning'
        // });
        return true;
      }
    });
  }

  descargarArchivo(file) {
    if (!file?.contenido) { console.error('No hay archivo disponible para descargar.'); return; }

    const extension = file.nombreArchivo.split('.').pop()?.toLowerCase() || '';
    const mimeType = this.util.getMimeType(extension);
    const fileName = file.nombreArchivo;

    const byteArray = Uint8Array.from(atob(file.contenido), char => char.charCodeAt(0));
    const blob = new Blob([byteArray], { type: mimeType });
    const url = window.URL.createObjectURL(blob);

    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = fileName;
    anchor.click();

    window.URL.revokeObjectURL(url);
  }

  onFileSelect(event: any): void {
    if (this.archivosSeleccionado.length > 0) {
      this.archivosSeleccionado = [];
    }
    const file = event.files[0];
    this.archivosSeleccionado.push(file);

    this.messageService.add({
      severity: 'info',
      summary: 'Archivo Seleccionado',
      detail: `Nombre: ${file.name}, Tamaño: ${file.size} bytes`
    });

    // Aquí puedes añadir la lógica para enviar el archivo a tu API
    // Por ejemplo: this.uploadFile(file);
  }

  onFileRemove(file: File): void {
    const fileName = file.name;
    this.archivosSeleccionado = this.archivosSeleccionado.filter(file => file.name !== fileName);
  }

  onFileClear(): void {
    this.archivosSeleccionado = [];
    this.messageService.add({
      severity: 'info',
      summary: 'Archivos Limpiados',
      detail: 'Todos los archivos han sido removidos.'
    });
  }

  // Declara la propiedad con @Input() para recibir el FormGroup del padre
  @Input() formularioDelPadre!: FormGroup;

  // Puedes acceder a los controles del formulario desde aquí
  public obtenerValor(): void {
    console.log(this.formularioDelPadre.get('razonSocial')?.value);
  }

  // Declara el emisor de eventos con @Output()
  @Output() cargarDatos = new EventEmitter<any>();

  public ejecutarFuncionDelPadre(): void {
    this.formularioDelPadre.get('tipoClienteSeleccionado')?.setValue([this.groupPoppupDG.get('tipoCliente')?.value]);
    this.formularioDelPadre.get('estadocliente')?.setValue(['1']);
    // Cuando quieras que el padre ejecute la función, emite el evento
    // Puedes pasar datos en el evento si es necesario
    this.cargarDatos.emit();
  }

  @Output() ejecutarTransaccion = new EventEmitter<any>();

  // Un método en el hijo que decide cuándo el padre debe poder llamar a esta función
  public notificarAlPadreParaTransaccion(accion: string, datos: any): void {
    // Emite un evento, enviando la función *como dato* si el padre la necesita,
    // O simplemente avisa que la acción está lista
    this.ejecutarTransaccion.emit({ accion: accion, datos: datos });
  }
}
